webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Admin__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Instructor__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Student__ = __webpack_require__(528);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    admin: __WEBPACK_IMPORTED_MODULE_6__Admin__["a" /* default */],
    instructor: __WEBPACK_IMPORTED_MODULE_7__Instructor__["a" /* default */],
    student: __WEBPACK_IMPORTED_MODULE_8__Student__["a" /* default */]
  },
  state: {
    token: '',
    userInfo: null,
    isLoggedIn: false,
    sidebarItems: null,
    userDetails: {}
  },
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* default */],
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__["a" /* default */])({
    paths: ['token']
  })]
});

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return router; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sidebar__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_HomePage_Index_vue__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_HomePage_About_vue__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_HomePage_Calendar_vue__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_HomePage_Director_vue__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_HomePage_NewsArticle_vue__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_HomePage_News_vue__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_HomePage_Signup_vue__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_HomePage_Login_vue__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Admin_Dashboard_vue__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Admin_Classrooms_vue__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Admin_Classroom_vue__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Admin_Instructor_vue__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Admin_Students_vue__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Admin_Calendar_vue__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Admin_News_vue__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Instructor_Classrooms_vue__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Instructor_Classroom_vue__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Student_Classrooms_vue__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Student_Classroom_vue__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Misc_404_vue__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__homeconfig__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__adminguard__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__instructorguard__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__studentguard__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__logout__ = __webpack_require__(736);






















// import InstructorDashboard from '@/components/Instructor/Dashboard.vue'














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Index',
    component: __WEBPACK_IMPORTED_MODULE_4__components_HomePage_Index_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_24__homeconfig__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_5__components_HomePage_About_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_24__homeconfig__["a" /* default */]
  }, {
    path: '/calendar',
    name: 'Calendar',
    component: __WEBPACK_IMPORTED_MODULE_6__components_HomePage_Calendar_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_24__homeconfig__["a" /* default */]
  }, {
    path: '/director',
    name: 'Director',
    component: __WEBPACK_IMPORTED_MODULE_7__components_HomePage_Director_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_24__homeconfig__["a" /* default */]
  }, {
    path: '/news',
    name: 'News',
    component: __WEBPACK_IMPORTED_MODULE_9__components_HomePage_News_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_24__homeconfig__["a" /* default */]
  }, {
    path: '/news/:id',
    name: 'NewsArticle',
    component: __WEBPACK_IMPORTED_MODULE_8__components_HomePage_NewsArticle_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_24__homeconfig__["a" /* default */]
  }, {
    path: '/signup',
    name: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_10__components_HomePage_Signup_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_24__homeconfig__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_11__components_HomePage_Login_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_24__homeconfig__["a" /* default */]
  },
  // Admin Routes
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Admin_Dashboard_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__adminguard__["a" /* default */]
  }, {
    path: '/admin/classroom',
    name: 'AdminClassrooms',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Admin_Classrooms_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__adminguard__["a" /* default */]
  }, {
    path: '/admin/classroom/:id',
    name: 'AdminClassroom',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Admin_Classroom_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__adminguard__["a" /* default */]
  }, {
    path: '/admin/instructors',
    name: 'AdminInstructor',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Admin_Instructor_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__adminguard__["a" /* default */]
  }, {
    path: '/admin/students',
    name: 'AdminStudents',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Admin_Students_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__adminguard__["a" /* default */]
  }, {
    path: '/admin/calendar',
    name: 'AdminCalendar',
    component: __WEBPACK_IMPORTED_MODULE_17__components_Admin_Calendar_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__adminguard__["a" /* default */]
  }, {
    path: '/admin/news',
    name: 'AdminNews',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Admin_News_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_25__adminguard__["a" /* default */]
  }, {
    path: '/logout',
    name: 'Logout',
    beforeEnter: __WEBPACK_IMPORTED_MODULE_28__logout__["a" /* default */]
  },
  // Instructor Routes
  {
    path: '/instructor',
    name: 'InstructorClassrooms',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Instructor_Classrooms_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_26__instructorguard__["a" /* default */]
  }, {
    path: '/instructor/classroom/:id',
    name: 'InstructorClassroom',
    component: __WEBPACK_IMPORTED_MODULE_20__components_Instructor_Classroom_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_26__instructorguard__["a" /* default */]
  },
  // {
  //   path: '/instructor/classrooms',
  //   name: 'InstructorClassroom',
  //   component: InstructorClassroom,
  //   beforeEnter: InstructorGuard
  // },
  // Student Routes
  {
    path: '/student',
    name: 'StudentClassrooms',
    component: __WEBPACK_IMPORTED_MODULE_21__components_Student_Classrooms_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__studentguard__["a" /* default */]
  }, {
    path: '/student/classroom/:id',
    name: 'StudentClassroom',
    component: __WEBPACK_IMPORTED_MODULE_22__components_Student_Classroom_vue__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_27__studentguard__["a" /* default */]
  }, {
    path: '*',
    name: 'NotFound',
    component: __WEBPACK_IMPORTED_MODULE_23__components_Misc_404_vue__["a" /* default */]
  }],
  mode: 'history'
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(13);


var home = [{
  icon: 'home',
  title: 'Home',
  link: '/',
  items: [{ title: 'Add' }]
}, {
  icon: 'info_outline',
  title: 'About',
  link: '/about'
}, {
  icon: 'date_range',
  title: 'Calendar',
  link: '/calendar'
}, {
  icon: 'rss_feed',
  title: 'News',
  link: '/news'
}, {
  icon: 'person_add',
  title: 'Signup',
  link: '/signup'
}, {
  icon: 'fingerprint',
  title: 'Login',
  link: '/login'
}];

var admin = [{
  icon: 'dashboard',
  title: 'Dashboard',
  link: '/admin'
}, {
  icon: 'class',
  title: 'Classroom',
  link: '/admin/classroom'
}, {
  icon: 'group',
  title: 'Instructors',
  link: '/admin/instructors'
}, {
  icon: 'face',
  title: 'Students',
  link: '/admin/students'
}, {
  icon: 'view_headline',
  title: 'News',
  link: '/admin/news'
}, {
  icon: 'date_range',
  title: 'Calendar',
  link: '/admin/calendar'
}, {
  icon: 'power_settings_new',
  title: 'Logout',
  link: '/logout'
}];

var instructor = [{
  icon: 'dashboard',
  title: 'Dashboard',
  link: '/instructor'
}, {
  icon: 'power_settings_new',
  title: 'Logout',
  link: '/logout'
}];

var student = [{
  icon: 'dashboard',
  title: 'Dashboard',
  link: '/student'
}, {
  icon: 'power_settings_new',
  title: 'Logout',
  link: '/logout'
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  home: home,
  admin: admin,
  instructor: instructor,
  student: student
});

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      miniVariant: true,
      title: 'Institute of Computer Studies'
    };
  },

  computed: {
    sideBarItems: function sideBarItems() {
      return this.$store.getters.GET_SIDEBAR_ITEMS;
    },
    getUserDetails: function getUserDetails() {
      return this.$store.getters.GET_USER_DETAILS;
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var userData, role, _userData$data, given_name, middle_name, family_name, user_id, user_role, userObject, userDetails;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.$store.getters.GET_TOKEN) {
                _context.next = 19;
                break;
              }

              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/api/profile', { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

            case 4:
              userData = _context.sent;
              _context.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/api/auth/me/role', { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

            case 7:
              role = _context.sent;
              _userData$data = userData.data, given_name = _userData$data.given_name, middle_name = _userData$data.middle_name, family_name = _userData$data.family_name, user_id = _userData$data.user_id;
              user_role = role.data.user_role;
              userObject = { name: given_name + ' ' + family_name, user_id: user_id };
              userDetails = {};

              if (user_role === 0) {
                userDetails = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, userObject, { role: 'Administrator' });
              } else if (user_role === 1) {
                userDetails = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, userObject, { role: 'Instructor' });
              } else if (user_role === 2) {
                userDetails = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, userObject, { role: 'Student' });
              }

              _this.$store.commit('SET_USER_DETAILS', userDetails);
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context['catch'](1);


              console.log(_context.t0);

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 16]]);
    }))();
  },

  name: 'App'
});

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      floatingButton: false,
      events: [],
      newsData: [],
      bannerImg: [{ src: '/static/img/resources/1.jpg' }]
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/calendar').then(function (events) {
      // this.events = events
      var formattedDate = events.data.map(function (event) {
        event.start_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(event.start_date).format('MMM D');
        event.end_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(event.end_date).format('MMM D');
        return event;
      });
      _this.events = formattedDate;
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/news').then(function (news) {
      _this.newsData = news.data;
      news.data.filter(function (newsData) {
        if (newsData.image_url) return newsData;
      }).map(function (mapItem) {
        _this.bannerImg.push({
          src: mapItem.image_url,
          title: mapItem.news_title,
          content: mapItem.news_content,
          newsId: mapItem.news_id
        });
      });
    });
  },

  methods: {
    onScroll: function onScroll(e) {
      if (typeof window === 'undefined') return;

      var top = window.pageYOffset || document.documentElement.offsetTop || 0;

      this.floatingButton = top > 150;
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_content_loading__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_content_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_content_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__About_VisionMission_vue__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__About_QualityPolicy_vue__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__About_OrgList_vue__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__About_Academics_vue__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__About_Goals_vue__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__About_CoreValues_vue__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__About_History_vue__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__About_Seal_vue__ = __webpack_require__(550);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VclCode: __WEBPACK_IMPORTED_MODULE_1_vue_content_loading__["VclCode"],
    VisionMission: __WEBPACK_IMPORTED_MODULE_2__About_VisionMission_vue__["a" /* default */],
    QualityPolicy: __WEBPACK_IMPORTED_MODULE_3__About_QualityPolicy_vue__["a" /* default */],
    OrgList: __WEBPACK_IMPORTED_MODULE_4__About_OrgList_vue__["a" /* default */],
    Academics: __WEBPACK_IMPORTED_MODULE_5__About_Academics_vue__["a" /* default */],
    Goals: __WEBPACK_IMPORTED_MODULE_6__About_Goals_vue__["a" /* default */],
    CoreValues: __WEBPACK_IMPORTED_MODULE_7__About_CoreValues_vue__["a" /* default */],
    History: __WEBPACK_IMPORTED_MODULE_8__About_History_vue__["a" /* default */],
    Seal: __WEBPACK_IMPORTED_MODULE_9__About_Seal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      mission: '',
      vision: '',
      orgCharts: [],
      loaded: false,
      items: ['Mission/Vision', 'Quality Policy', 'Organizational List', 'Academics', 'Goals', 'Core Values', 'History', 'ICS Seal']
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/about').then(function (data) {
      // this.mission = data.data.mis_vis_go[0].config_value
      // this.vision = data.data.mis_vis_go[1].config_value
      // this.orgCharts = data.data.org_chart
      // this.loaded = true
    }).catch(function (e) {
      console.log(e);
    });
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_content_loading__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_content_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_content_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VclCode: __WEBPACK_IMPORTED_MODULE_0_vue_content_loading__["VclCode"]
  },
  data: function data() {
    return {
      mission: '',
      vision: '',
      orgCharts: [],
      loaded: false
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/about').then(function (data) {
      _this.mission = data.data.mis_vis_go[0].config_value;
      _this.vision = data.data.mis_vis_go[1].config_value;
      _this.orgCharts = data.data.org_chart;
      _this.loaded = true;
    }).catch(function (e) {
      console.log(e);
    });
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      orgCharts: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/about').then(function (data) {
      _this.orgCharts = data.data.org_chart;
    }).catch(function (e) {
      console.log(e);
    });
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      demoEvents: []
    };
  },
  created: function created() {
    var _this = this;

    // ADD TIME TO DESCRIPTION
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/calendar/0').then(function (event) {
      var mapped = event.data.map(function (details) {
        return {
          date: details.start_date.split('-').join('/'),
          title: details.name,
          desc: '\n              Range: ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(details.start_date).format('MMMM D, YYYY') + ' - ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(details.end_date).format('MMMM D, YYYY') + ' |\n              Description: ' + details.description + '\n            '
        };
      });
      _this.demoEvents = mapped;
    }).catch(function (e) {
      console.log(e);
    });
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_content_loading__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_content_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_content_loading__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VclList: __WEBPACK_IMPORTED_MODULE_4_vue_content_loading__["VclList"]
  },
  data: function data() {
    return {
      image_url: '',
      title: '',
      content: '',
      dateFormat: '',
      fromNow: '',
      loaded: false
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var newsData, found;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/news');

            case 3:
              newsData = _context.sent;
              found = newsData.data.find(function (val) {
                return val.news_id.toString() === _this.$route.params.id ? val : null;
              });

              _this.image_url = found.image_url;
              _this.title = found.news_title;
              _this.content = found.news_content;
              _this.dateFormat = __WEBPACK_IMPORTED_MODULE_3_moment___default()(found.created_at).format('MMMM D, YYYY');
              _this.fromNow = __WEBPACK_IMPORTED_MODULE_3_moment___default()(found.created_at).fromNow();
              _this.loaded = true;
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](0);

              console.log(_context.t0);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 13]]);
    }))();
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      news: [],
      loaded: false
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var result;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/news');

            case 3:
              result = _context.sent;

              _this.news = result.data;
              _this.loaded = true;
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](0);

              console.log(_context.t0);

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }))();
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vuelidate__["validationMixin"]],
  validations: {
    date: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    username: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    password: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    givenName: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    familyName: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    contactNo: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    }
  },
  data: function data() {
    return {
      date: null,
      gender: true,
      menu: false,
      checkbox: false,
      username: '',
      password: '',
      givenName: '',
      familyName: '',
      middleName: '',
      extName: '',
      address: '',
      contactNo: ''
    };
  },

  watch: {
    menu: function menu(val) {
      var _this = this;

      val && this.$nextTick(function () {
        return _this.$refs.picker.activePicker = 'YEAR';
      });
    }
  },
  methods: {
    signUp: function signUp() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var username, password, givenName, familyName, middleName, extName, address, contactNo, date, checkbox, gender, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                username = _this2.username, password = _this2.password, givenName = _this2.givenName, familyName = _this2.familyName, middleName = _this2.middleName, extName = _this2.extName, address = _this2.address, contactNo = _this2.contactNo, date = _this2.date, checkbox = _this2.checkbox, gender = _this2.gender;

                _this2.$v.$touch();

                if (_this2.$v.$error) {
                  _context.next = 19;
                  break;
                }

                _this2.$Progress.start();
                _context.prev = 4;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/auth/signup', {
                  username: username,
                  password: password,
                  isMale: gender,
                  family_name: familyName,
                  given_name: givenName,
                  middle_name: middleName,
                  ext_name: extName,
                  address: address,
                  birthday: date,
                  contact_number: contactNo
                  // user_role: checkbox ? 1 : 2
                }, { headers: { 'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN } });

              case 7:
                response = _context.sent;

                _this2.showSuccessMsg({ title: 'Success!', message: 'Signup successful! Please wait for this account to be verified.' });
                _this2.$Progress.finish();
                _this2.clearFields();
                _this2.$router.push('/');
                _context.next = 19;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](4);

                console.log(_context.t0);
                _this2.showErrorMsg({ title: _context.t0.response.statusText, message: 'Signup not successful.' });
                _this2.$Progress.fail();

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[4, 14]]);
      }))();
    },
    save: function save(date) {
      this.$refs.menu.save(date);
    },
    allowedDates: function allowedDates(val) {
      return new Date().toISOString().substr(0, 10) >= val;
    },
    clearFields: function clearFields() {
      this.date = null, this.menu = false, this.checkbox = false, this.username = '', this.password = '', this.givenName = '', this.familyName = '', this.middleName = '', this.extName = '', this.address = '', this.contactNo = '';
      this.gender = true;
    }
  },
  computed: {
    dateErrors: function dateErrors() {
      var errors = [];
      if (!this.$v.date.$dirty) return errors;
      !this.$v.date.required && errors.push('Birthdate is required');
      return errors;
    },
    userNameErrors: function userNameErrors() {
      var errors = [];
      if (!this.$v.username.$dirty) return errors;
      !this.$v.username.required && errors.push('Username is required');
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push('Password is required');
      return errors;
    },
    givenNameErrors: function givenNameErrors() {
      var errors = [];
      if (!this.$v.givenName.$dirty) return errors;
      !this.$v.givenName.required && errors.push('Given name is required');
      return errors;
    },
    familyNameErrors: function familyNameErrors() {
      var errors = [];
      if (!this.$v.familyName.$dirty) return errors;
      !this.$v.familyName.required && errors.push('Family name is required');
      return errors;
    },

    // middleNameErrors(){
    //   const errors = []
    //   if(!this.$v.middleName.$dirty) return errors
    //   !this.$v.middleName.required && errors.push('Middle name is required')
    //   return errors
    // },
    // addressErrors(){
    //   const errors = []
    //   if(!this.$v.address.$dirty) return errors
    //   !this.$v.address.required && errors.push('Address is required')
    //   return errors
    // },
    contactNoErrors: function contactNoErrors() {
      var errors = [];
      if (!this.$v.contactNo.$dirty) return errors;
      !this.$v.contactNo.required && errors.push('Contact number is required');
      return errors;
    }
  },
  notifications: {
    showSuccessMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.success },
    showErrorMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.error }
  }
});

/***/ }),
/* 254 */,
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_notifications__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vuelidate__["validationMixin"]],
  validations: {
    username: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
    },
    password: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
    }
  },
  data: function data() {
    return {
      username: '',
      password: '',
      loading: true,
      snackbar: {
        timeout: 3000,
        text: '',
        appear: false
      }
    };
  },

  methods: {
    logIn: function logIn() {
      var _this = this;

      var username = this.username,
          password = this.password;

      this.$v.$touch();

      if (!this.$v.$error) {
        this.$Progress.start();
        this.$store.dispatch('REQUEST_TOKEN', { username: username, password: password }).then(function (role) {
          if (role === 0) {
            _this.$router.push('/admin');
          } else if (role === 1) {
            _this.$router.push('/instructor');
          } else if (role === 2) {
            _this.$router.push('/student');
          }
          _this.$Progress.finish();
        }).catch(function (err) {
          console.log(err);
          if (err.response.data.code === 401) _this.showErrorMsg({ title: err.response.statusText, message: err.response.data.message });
          _this.$Progress.fail();
        });
      }
    },
    deleteFormFields: function deleteFormFields() {
      this.username = '';
      this.password = '';
    }
  },
  computed: {
    usernameErrors: function usernameErrors() {
      var errors = [];
      if (!this.$v.username.$dirty) return errors;
      // !this.$v.username.maxLength && errors.push('Username must be valid')
      !this.$v.username.required && errors.push('Username is required');
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push('Password is required');
      return errors;
    }
  },
  notifications: {
    showErrorMsg: { type: __WEBPACK_IMPORTED_MODULE_0_vue_notifications___default.a.types.error }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Charts_StudentGender_vue__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Charts_InstructorGender_vue__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dashboard_NotVerified_vue__ = __webpack_require__(641);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { StudentGender: __WEBPACK_IMPORTED_MODULE_1__Charts_StudentGender_vue__["a" /* default */], InstructorGender: __WEBPACK_IMPORTED_MODULE_2__Charts_InstructorGender_vue__["a" /* default */], NotVerified: __WEBPACK_IMPORTED_MODULE_3__Dashboard_NotVerified_vue__["a" /* default */] },
  created: function created() {
    this.$store.dispatch('admin/FETCH_INSTRUCTORS');
    this.$store.dispatch('admin/FETCH_STUDENTS');
  },

  computed: {
    noOfStudents: function noOfStudents() {
      return this.$store.getters['admin/GET_STUDENTS'].filter(function (item) {
        return item.verified ? item : null;
      }).length;
    },
    noOfInstructors: function noOfInstructors() {
      return this.$store.getters['admin/GET_INSTRUCTORS'].filter(function (item) {
        return item.verified ? item : null;
      }).length;
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_chartjs__ = __webpack_require__(258);





/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_3_vue_chartjs__["a" /* Bar */],
  data: function data() {
    return {
      student: {
        male: 0,
        female: 0
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var profile, studMale, studeFemale;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/accounts', { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

            case 2:
              profile = _context.sent;
              studMale = profile.data.students.filter(function (stud) {
                return stud.profile.isMale;
              });
              studeFemale = profile.data.students.length - studMale.length;

              _this.student.male = studMale.length;
              _this.student.female = studeFemale;

              _this.renderChart({
                labels: ['Students'],
                datasets: [{
                  label: 'Male',
                  backgroundColor: '#07b5d6',
                  data: [_this.student.male, 0]
                }, {
                  label: 'Female',
                  backgroundColor: '#f87979',
                  data: [_this.student.female, 0]
                }]
              }, { responsive: true, maintainAspectRatio: false });

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_chartjs__ = __webpack_require__(258);





/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_3_vue_chartjs__["a" /* Bar */],
  data: function data() {
    return {
      faculty: {
        male: 0,
        female: 0
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var profile, facultyMale, studeFemale;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/accounts', { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

            case 2:
              profile = _context.sent;
              facultyMale = profile.data.faculty.filter(function (stud) {
                return stud.profile.isMale;
              });
              studeFemale = profile.data.faculty.length - facultyMale.length;

              _this.faculty.male = facultyMale.length;
              _this.faculty.female = studeFemale;

              _this.renderChart({
                labels: ['Instructors'],
                datasets: [{
                  label: 'Male',
                  backgroundColor: '#07b5d6',
                  data: [_this.faculty.male, 0]
                }, {
                  label: 'Female',
                  backgroundColor: '#f87979',
                  data: [_this.faculty.female, 0]
                }]
              }, { responsive: true, maintainAspectRatio: false });

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: '',
      headers: [{ text: 'Family Name', value: 'family_name', align: 'left' }, { text: 'Given Name', value: 'given_name', align: 'left' }, { text: 'Middle Name', value: 'middle_name', align: 'left' }, { text: 'Extension Name', value: 'ext_name', align: 'left' }, { text: 'Username', value: 'username', align: 'left' },
      // { text: 'Role', value: 'role', align: 'left' },
      { text: 'Operation', value: 'ops', align: 'left', sortable: false }],
      roleDialog: false,
      role: true,
      loading: false,
      item: []
    };
  },

  computed: {
    items: function items() {
      var instructor = this.$store.getters['admin/GET_INSTRUCTORS'].map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item.profile, { verified: item.verified, value: false, username: item.username, role: 'Instructor', user_role: item.user_role });
      }).filter(function (item) {
        return !item.verified ? item : null;
      });

      var student = this.$store.getters['admin/GET_STUDENTS'].map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item.profile, { verified: item.verified, value: false, username: item.username, role: 'Student', user_role: item.user_role });
      }).filter(function (item) {
        return !item.verified ? item : null;
      });

      var items = instructor.concat(student);
      return items;
    }
  },
  methods: {
    openDialog: function openDialog(item) {
      this.roleDialog = true;
      this.item = item;
    },

    // To be fixed
    verifyAccount: function verifyAccount() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.$Progress.start();
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/accounts/change', {
                  type: 0,
                  user_role: _this.role ? 2 : 1,
                  id: _this.item.user_id
                }, { params: { ids: [_this.item.user_id] }, headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

              case 4:
                _this.$store.dispatch('admin/FETCH_INSTRUCTORS');
                _this.$store.dispatch('admin/FETCH_STUDENTS');
                _this.role = true;
                _this.roleDialog = false;
                _this.$Progress.finish();
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);
                _this.$Progress.fail();

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 11]]);
      }))();
    },
    deleteAccount: function deleteAccount(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.t0 = confirm('Are you sure you want to delete this user?');

                if (!_context2.t0) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete('/api/accounts', {
                  params: {
                    ids: [id]
                  }, headers: { 'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN }
                });

              case 5:
                _this2.$store.dispatch('admin/FETCH_INSTRUCTORS');
                _this2.$store.dispatch('admin/FETCH_STUDENTS');
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t1 = _context2['catch'](0);

                console.log(_context2.t1);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Profile_vue__ = __webpack_require__(646);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Profile: __WEBPACK_IMPORTED_MODULE_6__Profile_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vuelidate__["validationMixin"]],
  validations: {
    classroomName: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    subject: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    section: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    }
  },
  data: function data() {
    return {
      fab: false,
      bottom: true,
      right: true,
      transition: 'slide-y-reverse-transition',
      direction: 'top',
      classDialog: false,
      classroomName: '',
      subject: '',
      section: '',
      checkIfAdd: null,
      editId: null,
      deleteModal: false,
      selectedId: null
    };
  },

  methods: {
    addClass: function addClass() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var classroomName, subject, section, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                classroomName = _this.classroomName, subject = _this.subject, section = _this.section;

                _this.$v.$touch();

                if (_this.$v.$error) {
                  _context.next = 22;
                  break;
                }

                _context.prev = 3;

                _this.$Progress.start();
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/class', {
                  name: classroomName,
                  subject: subject,
                  section: section
                }, { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

              case 7:
                response = _context.sent;

                _this.$store.dispatch('admin/FETCH_CLASSES');
                _this.clearFormField();
                _this.classDialog = false;
                _this.showSuccessMsg({ title: 'Success!', message: 'Classroom added successfully!' });
                _this.$Progress.finish();
                _context.next = 22;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](3);

                _this.clearFormField();
                _this.classDialog = false;
                _this.showErrorMsg({ title: _context.t0.response.statusText, message: _context.t0.response.data.error.message });
                console.log(_context.t0);
                _this.$Progress.fail();

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 15]]);
      }))();
    },
    editClass: function editClass() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var classroomName, subject, section, editId, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                classroomName = _this2.classroomName, subject = _this2.subject, section = _this2.section, editId = _this2.editId;

                _this2.$v.$touch();

                if (_this2.$v.$error) {
                  _context2.next = 22;
                  break;
                }

                _context2.prev = 3;

                _this2.$Progress.start();
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put('/api/class/' + editId, {
                  name: classroomName,
                  subject: subject,
                  section: section
                }, { headers: { 'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN } });

              case 7:
                result = _context2.sent;

                _this2.$store.dispatch('admin/FETCH_CLASSES');
                _this2.clearFormField();
                _this2.classDialog = false;
                _this2.showSuccessMsg({ title: 'Success!', message: 'Classroom details is updated successfully!' });
                _this2.$Progress.finish();
                _context2.next = 22;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](3);

                _this2.clearFormField();
                _this2.classDialog = false;
                _this2.showErrorMsg({ title: _context2.t0.response.statusText, message: _context2.t0.response.data.error.message });
                console.log(_context2.t0);
                _this2.$Progress.fail();

              case 22:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[3, 15]]);
      }))();
    },
    deleteClass: function deleteClass() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete('/api/class/' + _this3.selectedId, {
                  headers: {
                    'Authorization': 'Bearer ' + _this3.$store.getters.GET_TOKEN
                  }
                });

              case 3:
                response = _context3.sent;

                _this3.$store.dispatch('admin/FETCH_CLASSES');
                _this3.clearFormField();
                _this3.deleteModal = false;
                _this3.showSuccessMsg({ title: 'Success!', message: 'Classroom is deleted successfully!' });
                _this3.$Progress.finish();
                _context3.next = 18;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](0);

                _this3.clearFormField();
                _this3.deleteModal = false;
                _this3.showErrorMsg({ title: _context3.t0.response.statusText, message: _context3.t0.response.data.error.message });
                console.log(_context3.t0);
                _this3.$Progress.fail();

              case 18:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 11]]);
      }))();
    },
    unenroll: function unenroll() {},
    configDelete: function configDelete(id) {
      this.deleteModal = true;
      this.selectedId = id;
    },
    setEventAction: function setEventAction(action, id) {
      // If action is true then it is add, else it is false
      this.checkIfAdd = action ? true : false;
      // If edit is clicked
      if (!action) {
        var details = this.$store.getters['admin/GET_CLASSES'].find(function (el) {
          return el.classroom_id === id;
        });
        this.editId = id;
        this.classroomName = details.classroom_name;
        this.subject = details.subject;
        this.section = details.section;
      }

      this.classDialog = true;
    },
    clearFormField: function clearFormField() {
      this.classroomName = '';
      this.subject = '';
      this.section = '';
      this.classDialog = false;
    }
  },
  created: function created() {
    this.$store.dispatch('admin/FETCH_CLASSES');
  },

  computed: {
    classroomNameErrors: function classroomNameErrors() {
      var errors = [];
      if (!this.$v.classroomName.$dirty) return errors;
      !this.$v.classroomName.required && errors.push('Classroom Name is required');
      return errors;
    },
    subjectErrors: function subjectErrors() {
      var errors = [];
      if (!this.$v.subject.$dirty) return errors;
      !this.$v.subject.required && errors.push('Subject is required');
      return errors;
    },
    sectionErrors: function sectionErrors() {
      var errors = [];
      if (!this.$v.section.$dirty) return errors;
      !this.$v.section.required && errors.push('Section is required');
      return errors;
    },
    classrooms: function classrooms() {
      return this.$store.getters['admin/GET_CLASSES'];
    }
  },
  notifications: {
    showSuccessMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.success },
    showErrorMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.error }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vuelidate__["validationMixin"]],
  validations: {
    date: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    givenName: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    familyName: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    contactNo: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    }
  },
  data: function data() {
    return {
      givenName: '',
      familyName: '',
      middleName: '',
      extName: '',
      date: '',
      menu: false,
      address: '',
      contactNo: '',
      profile: null,
      imageDialog: false,
      profileDialog: false,
      loading: false,
      gender: true,
      passwordDialog: false,
      password1: '',
      password2: ''
    };
  },
  created: function created() {
    this.getProfile();
  },

  methods: {
    changePassword: function changePassword() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.password1 && _this.password2)) {
                  _context.next = 22;
                  break;
                }

                if (!(_this.password1 === _this.password2)) {
                  _context.next = 20;
                  break;
                }

                _context.prev = 2;

                _this.$Progress.start();
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/profile/changepassword', {
                  password: _this.password1
                }, { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

              case 6:
                res = _context.sent;

                _this.passwordDialog = false;
                _this.password1 = '';
                _this.password2 = '';
                _this.showSuccessMsg({ title: 'Success!', message: 'Password updated successfully!' });
                _this.$Progress.finish();
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](2);

                console.log(_context.t0);
                _this.$Progress.fail();

              case 18:
                _context.next = 22;
                break;

              case 20:
                _this.showErrorMsg({ title: 'Error!', message: 'Passwords do not match!' });
                _this.$Progress.fail();

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 14]]);
      }))();
    },
    getProfile: function getProfile() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var profile;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/api/profile', { headers: { 'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN } });

              case 2:
                profile = _context2.sent;


                _this2.givenName = profile.data.given_name;
                _this2.familyName = profile.data.family_name;
                _this2.middleName = profile.data.middle_name;
                _this2.extName = profile.data.ext_name;
                _this2.date = profile.data.birthday;
                _this2.address = profile.data.address;
                _this2.contactNo = profile.data.contact_number;
                _this2.gender = profile.data.isMale;
                _this2.profile = profile.data;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    changeProfileImage: function changeProfileImage() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = new FormData();

                data.append('image', _this3.$refs.image.files[0]);
                _context3.prev = 2;

                _this3.$Progress.start();
                _this3.loading = true;
                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/profile/image/update', data, {
                  headers: {
                    'Authorization': 'Bearer ' + _this3.$store.getters.GET_TOKEN,
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 7:
                res = _context3.sent;

                _this3.showSuccessMsg({ title: 'Success!', message: 'Profile image updated successfully!' });
                _this3.$Progress.finish();
                _this3.getProfile();
                _this3.loading = false;
                _this3.imageDialog = false;
                _context3.next = 21;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3['catch'](2);

                console.log(_context3.t0);
                _this3.showErrorMsg({ title: _context3.t0.response.statusText, message: _context3.t0.response.data.error.join(' ') });
                _this3.loading = false;
                _this3.$Progress.fail();

              case 21:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[2, 15]]);
      }))();
    },
    editProfileDetails: function editProfileDetails() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var givenName, familyName, middleName, extName, address, contactNo, date, gender;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                givenName = _this4.givenName, familyName = _this4.familyName, middleName = _this4.middleName, extName = _this4.extName, address = _this4.address, contactNo = _this4.contactNo, date = _this4.date, gender = _this4.gender;

                if (_this4.$v.$error) {
                  _context4.next = 17;
                  break;
                }

                _context4.prev = 2;

                _this4.$Progress.start();
                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/profile/update', {
                  given_name: givenName,
                  family_name: familyName,
                  middle_name: middleName,
                  ext_name: extName,
                  birthday: date,
                  address: address,
                  contact_number: contactNo,
                  isMale: gender
                }, { headers: {
                    'Authorization': 'Bearer ' + _this4.$store.getters.GET_TOKEN
                  } });

              case 6:
                _this4.showSuccessMsg({ title: 'Success!', message: 'Profile details updated successfully!' });
                _this4.getProfile();
                _this4.$Progress.finish();
                _this4.profileDialog = false;
                _context4.next = 17;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4['catch'](2);

                console.log(_context4.t0);
                _this4.showErrorMsg({ title: _context4.t0.response.statusText, message: _context4.t0.response.data.error.join(' ') });
                _this4.$Progress.fail();

              case 17:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[2, 12]]);
      }))();
    },
    allowedDates: function allowedDates(val) {
      return new Date().toISOString().substr(0, 10) >= val;
    },
    save: function save(date) {
      this.$refs.menu.save(date);
    }
  },
  computed: {
    dateErrors: function dateErrors() {
      var errors = [];
      if (!this.$v.date.$dirty) return errors;
      !this.$v.date.required && errors.push('Birthdate is required');
      return errors;
    },
    givenNameErrors: function givenNameErrors() {
      var errors = [];
      if (!this.$v.givenName.$dirty) return errors;
      !this.$v.givenName.required && errors.push('Given name is required');
      return errors;
    },
    familyNameErrors: function familyNameErrors() {
      var errors = [];
      if (!this.$v.familyName.$dirty) return errors;
      !this.$v.familyName.required && errors.push('Family name is required');
      return errors;
    },
    contactNoErrors: function contactNoErrors() {
      var errors = [];
      if (!this.$v.contactNo.$dirty) return errors;
      !this.$v.contactNo.required && errors.push('Contact number is required');
      return errors;
    }
  },
  watch: {
    menu: function menu(val) {
      var _this5 = this;

      val && this.$nextTick(function () {
        return _this5.$refs.picker.activePicker = 'YEAR';
      });
    }
  },
  notifications: {
    showSuccessMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.success },
    showErrorMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.error }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Classroom_Post_vue__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Classroom_AddPost_vue__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Classroom_Students_vue__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Classroom_Files_vue__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Classroom_Assignments_vue__ = __webpack_require__(664);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Post: __WEBPACK_IMPORTED_MODULE_3__Classroom_Post_vue__["a" /* default */], AddPost: __WEBPACK_IMPORTED_MODULE_4__Classroom_AddPost_vue__["a" /* default */], StudentList: __WEBPACK_IMPORTED_MODULE_5__Classroom_Students_vue__["a" /* default */], FileList: __WEBPACK_IMPORTED_MODULE_6__Classroom_Files_vue__["a" /* default */], AssignmentList: __WEBPACK_IMPORTED_MODULE_7__Classroom_Assignments_vue__["a" /* default */]
  },
  data: function data() {
    return {
      items: ['Feed', 'Students', 'Files', 'Assignments'],
      classInfo: '',
      students: []
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$store.dispatch('admin/FETCH_POSTS', { class_id: _this.$route.params.id });
              _this.$store.dispatch('admin/FETCH_FILES', { class_id: _this.$route.params.id });
              _this.$store.dispatch('admin/FETCH_ASSIGNMENTS', { class_id: _this.$route.params.id });

              _this.fetchStudents();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    fetchStudents: function fetchStudents() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var info;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/class/' + _this2.$route.params.id, { headers: { 'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN } });

              case 3:
                info = _context2.sent;

                _this2.classInfo = info.data;
                _this2.students = info.data.studentclass;
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8]]);
      }))();
    }
  },
  computed: {
    posts: function posts() {
      return this.$store.getters['admin/GET_POSTS'];
    },
    files: function files() {
      return this.$store.getters['admin/GET_FILES'];
    },
    assignments: function assignments() {
      return this.$store.getters['admin/GET_ASSIGNMENTS'];
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PostComment_vue__ = __webpack_require__(652);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostComment: __WEBPACK_IMPORTED_MODULE_3__PostComment_vue__["a" /* default */]
  },
  props: ['post'],
  data: function data() {
    return {
      commentStatus: false,
      commentText: '',
      editedText: '',
      loading: false,
      editDialog: false,
      deleteDialog: false,
      collapsed: true
    };
  },

  methods: {
    comment: function comment() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/post/comment', {
                  post_id: _this.post.post_id,
                  comment: _this.commentText
                }, { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

              case 4:
                response = _context.sent;

                _this.$store.dispatch('admin/FETCH_POSTS', { class_id: _this.$route.params.id });
                _this.restart();
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                _this.loading = false;
                console.log(_context.t0);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    restart: function restart() {
      this.loading = false;
      this.commentStatus = false;
      this.commentText = '';
      this.editedText = '';
      this.editDialog = false;
    },
    editPost: function editPost(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.loading = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/post/update', {
                  post_id: id,
                  post_content: _this2.editedText
                }, { headers: { 'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN } });

              case 4:
                response = _context2.sent;

                _this2.$store.dispatch('admin/FETCH_POSTS', { class_id: _this2.$route.params.id });
                _this2.restart();
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                _this2.loading = false;
                console.log(_context2.t0);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    deletePost: function deletePost(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this3.loading = true;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/post/delete', null, {
                  headers: {
                    'Authorization': 'Bearer ' + _this3.$store.getters.GET_TOKEN
                  },
                  params: {
                    ids: [id]
                  }
                });

              case 4:
                response = _context3.sent;

                _this3.$store.dispatch('admin/FETCH_POSTS', { class_id: _this3.$route.params.id });
                _this3.restart();
                _context3.next = 13;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);

                _this3.loading = false;
                console.log(_context3.t0);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 9]]);
      }))();
    },
    openEditDialog: function openEditDialog() {
      this.editDialog = true;
      this.editedText = this.post.post_content;
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['comment'],
  data: function data() {
    return {
      editDialog: false,
      editedText: '',
      loading: false,
      deleteDialog: false
    };
  },

  methods: {
    openEditDialog: function openEditDialog() {
      this.editDialog = true;
      this.editedText = this.comment.comment;
    },
    editComment: function editComment(comment_id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/post/comment/update', {
                  comment_id: comment_id,
                  comment: _this.editedText
                }, { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

              case 4:
                response = _context.sent;

                _this.$store.dispatch('admin/FETCH_POSTS', { class_id: _this.$route.params.id });
                _this.restart();
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                _this.loading = false;
                console.log(_context.t0);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    deleteComment: function deleteComment(comment_id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.loading = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/post/comment/delete', {
                  id: comment_id
                }, {
                  headers: {
                    'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN
                  } });

              case 4:
                response = _context2.sent;

                _this2.$store.dispatch('admin/FETCH_POSTS', { class_id: _this2.$route.params.id });
                _this2.restart();
                _context2.next = 14;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                _this2.loading = false;
                _this2.showErrorMsg({ title: _context2.t0.response.statusText, message: _context2.t0.response.data.error.join(' ') });
                console.log(_context2.t0);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    restart: function restart() {
      this.loading = false;
      this.editedText = '';
      this.editDialog = false;
      this.deleteDialog = false;
    }
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      postStatus: false,
      text: '',
      loading: false
    };
  },

  methods: {
    postAnnouncement: function postAnnouncement() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/post', {
                  class_code: _this.$route.params.id,
                  post_content: _this.text
                }, { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

              case 4:
                _this.$store.dispatch('admin/FETCH_POSTS', { class_id: _this.$route.params.id });
                _this.restart();
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                _this.loading = false;
                console.log(_context.t0);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    restart: function restart() {
      this.loading = false;
      this.postStatus = false;
      this.text = '';
    }
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['student', 'fetchStudents'],
  data: function data() {
    return {
      deleteDialog: false,
      loading: false
    };
  },

  methods: {
    removeStudent: function removeStudent() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/' + _this.$route.params.id + '/remove', null, {
                  params: {
                    ids: [_this.student.student_id]
                  },
                  headers: {
                    'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN
                  }
                });

              case 4:
                res = _context.sent;

                console.log(res);
                _this.loading = false;
                _this.deleteDialog = false;
                _this.fetchStudents();
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](0);

                _this.loading = false;
                console.log(_context.t0);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 11]]);
      }))();
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__File_vue__ = __webpack_require__(661);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    File: __WEBPACK_IMPORTED_MODULE_3__File_vue__["a" /* default */]
  },
  props: ['files'],
  data: function data() {
    return {
      fab: false,
      bottom: true,
      right: true,
      transition: 'slide-y-reverse-transition',
      direction: 'top',
      file: null,
      fileTitle: '',
      fileDialog: false,
      fileName: '',
      loading: false
    };
  },
  created: function created() {},

  methods: {
    fileHandler: function fileHandler() {
      this.file = this.$refs.file.files[0];
      this.fileTitle = this.$refs.file.files[0].name;
      this.fileDialog = true;
    },
    uploadFile: function uploadFile() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                data = new FormData();

                data.append('file_name', _this.fileTitle);
                data.append('file', _this.file);
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/' + _this.$route.params.id + '/upload', data, {
                  headers: {
                    'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN,
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 7:
                res = _context.sent;

                _this.$store.dispatch('admin/FETCH_FILES', { class_id: _this.$route.params.id });
                _this.file = null;
                _this.fileTitle = '';
                _this.loading = false;
                _this.fileDialog = false;
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);
                _this.loading = false;

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 15]]);
      }))();
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['file'],
  data: function data() {
    return {
      deleteDialog: false,
      loading: false
    };
  },

  methods: {
    downloadFile: function downloadFile(file) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/' + _this.$route.params.id + '/download', {
                  file_location: file
                }, {
                  headers: {
                    'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN
                  }
                });

              case 3:
                res = _context.sent;

                _this.$store.dispatch('admin/FETCH_FILES', { class_id: _this.$route.params.id });
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    deleteFile: function deleteFile(file) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete('/api/class/' + _this2.$route.params.id + '/delete', {
                  headers: {
                    'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN
                  },
                  params: {
                    filenames: [file]
                  }
                });

              case 3:
                res = _context2.sent;

                _this2.$store.dispatch('admin/FETCH_FILES', { class_id: _this2.$route.params.id });
                _this2.deleteDialog = false;
                _this2.loading = false;
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Assignment_vue__ = __webpack_require__(665);
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['assignments'],
  components: { Assignment: __WEBPACK_IMPORTED_MODULE_0__Assignment_vue__["a" /* default */] }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['assignment'],
  data: function data() {
    return {
      loading: false,
      deleteDialog: false
    };
  },

  methods: {
    downloadFile: function downloadFile(file) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/' + _this.$route.params.id + '/download', {
                  file_location: file
                }, {
                  headers: {
                    'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN
                  }
                });

              case 3:
                res = _context.sent;
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 6]]);
      }))();
    },
    deleteFile: function deleteFile(file) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.loading = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete('/api/class/' + _this2.$route.params.id + '/assignments/delete', {
                  headers: {
                    'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN
                  },
                  params: {
                    filenames: [file]
                  }
                });

              case 4:
                res = _context2.sent;

                _this2.$store.dispatch('admin/FETCH_ASSIGNMENTS', { class_id: _this2.$route.params.id });
                _this2.loading = false;
                _this2.deleteDialog = false;
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                _this2.loading = false;
                console.log(_context2.t0);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 10]]);
      }))();
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notifications__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5_vuelidate__["validationMixin"]],
  validations: {
    date: {
      required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
    },
    // username: {
    //   required
    // },
    // password: {
    //   required
    // },
    givenName: {
      required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
    },
    familyName: {
      required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
    },
    contactNo: {
      required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
    }
  },
  data: function data() {
    return {
      fab: false,
      bottom: true,
      right: true,
      transition: 'slide-y-reverse-transition',
      direction: 'top',
      selected: [],
      headers: [
      // { text: 'Select', value: 'select', align: 'center', sortable: false },
      { text: 'Family Name', value: 'family_name', align: 'left' }, { text: 'Given Name', value: 'given_name', align: 'left' }, { text: 'Middle Name', value: 'middle_name', align: 'left' }, { text: 'Extension Name', value: 'ext_name', align: 'left' }, { text: 'Birthdate', value: 'birthdate', align: 'left' }, { text: 'Address', value: 'address', align: 'left' }, { text: 'Contact No.', value: 'contact_number', align: 'left' }],

      search: '',
      menu: false,
      date: null,
      instructorDialog: false,
      deleteModal: false,
      checkIfAdd: null,
      username: '',
      password: '',
      givenName: '',
      familyName: '',
      middleName: '',
      extName: '',
      address: '',
      contactNo: '',
      gender: true
    };
  },

  watch: {
    menu: function menu(val) {
      var _this = this;

      val && this.$nextTick(function () {
        return _this.$refs.picker.activePicker = 'YEAR';
      });
    }
  },
  methods: {
    addInstructor: function addInstructor() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var username, password, givenName, familyName, middleName, extName, address, contactNo, date, gender;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                username = _this2.username, password = _this2.password, givenName = _this2.givenName, familyName = _this2.familyName, middleName = _this2.middleName, extName = _this2.extName, address = _this2.address, contactNo = _this2.contactNo, date = _this2.date, gender = _this2.gender;

                _this2.$v.$touch();

                if (_this2.$v.$error) {
                  _context.next = 19;
                  break;
                }

                _this2.$Progress.start();
                _context.prev = 4;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/api/accounts', {
                  username: username,
                  password: password,
                  given_name: givenName,
                  family_name: familyName,
                  middle_name: middleName,
                  ext_name: extName,
                  birthday: date,
                  address: address,
                  contact_number: contactNo,
                  user_role: 1,
                  isMale: gender
                }, {
                  headers: {
                    'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN
                  } });

              case 7:
                _this2.$store.dispatch('admin/FETCH_INSTRUCTORS');
                _this2.clearFormField();
                _this2.instructorDialog = false;
                _this2.showSuccessMsg({ title: 'Success!', message: 'Instructor added successfully!' });
                _this2.$Progress.finish();
                _context.next = 19;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](4);

                console.log(_context.t0);
                _this2.showErrorMsg({ title: _context.t0.response.statusText, message: _context.t0.response.data.error.join(' ') });
                _this2.$Progress.fail();

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[4, 14]]);
      }))();
    },
    editInstructor: function editInstructor() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var username, password, givenName, familyName, middleName, extName, address, contactNo, date, gender;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                username = _this3.username, password = _this3.password, givenName = _this3.givenName, familyName = _this3.familyName, middleName = _this3.middleName, extName = _this3.extName, address = _this3.address, contactNo = _this3.contactNo, date = _this3.date, gender = _this3.gender;

                _this3.$v.$touch();

                if (_this3.$v.$error) {
                  _context2.next = 20;
                  break;
                }

                _context2.prev = 3;

                _this3.$Progress.start();
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/api/accounts/update', {
                  user_id: _this3.selected[0].user_id,
                  given_name: givenName,
                  family_name: familyName,
                  middle_name: middleName,
                  ext_name: extName,
                  birthday: date,
                  address: address,
                  contact_number: contactNo,
                  isMale: gender
                }, { headers: {
                    'Authorization': 'Bearer ' + _this3.$store.getters.GET_TOKEN
                  } });

              case 7:
                _this3.$store.dispatch('admin/FETCH_INSTRUCTORS');
                _this3.clearFormField();
                _this3.instructorDialog = false;
                _this3.selected = [];
                _this3.showSuccessMsg({ title: 'Success!', message: 'Instructor updated successfully!' });
                _this3.$Progress.finish();
                _context2.next = 20;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](3);

                // this.clearFormField()
                // this.instructorDialog = false
                console.log(_context2.t0);
                _this3.showErrorMsg({ title: _context2.t0.response.statusText, message: _context2.t0.response.data.error.join(' ') });
                _this3.$Progress.fail();

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[3, 15]]);
      }))();
    },
    deleteInstructors: function deleteInstructors() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var instructors;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                instructors = _this4.selected.map(function (instructor) {
                  return instructor.user_id;
                });
                _context3.prev = 1;

                _this4.$Progress.start();
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('/api/accounts', {
                  params: {
                    ids: instructors
                  },
                  headers: {
                    'Authorization': 'Bearer ' + _this4.$store.getters.GET_TOKEN
                  } });

              case 5:
                _this4.$store.dispatch('admin/FETCH_INSTRUCTORS');
                _this4.deleteModal = false;
                _this4.clearFormField();
                _this4.showSuccessMsg({ title: 'Success!', message: 'Instructor deleted successfully!' });
                _this4.selected = [];
                _this4.$Progress.finish();
                _context3.next = 18;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](1);

                console.log(_context3.t0);
                _this4.showErrorMsg({ title: _context3.t0.response.statusText, message: _context3.t0.response.data.error.join(' ') });
                _this4.$Progress.fail();

              case 18:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[1, 13]]);
      }))();
    },
    setInstructorsAction: function setInstructorsAction(action) {
      this.checkIfAdd = action;
      if (!action) {
        var _selected$ = this.selected[0],
            given_name = _selected$.given_name,
            family_name = _selected$.family_name,
            middle_name = _selected$.middle_name,
            ext_name = _selected$.ext_name,
            birthday = _selected$.birthday,
            contact_number = _selected$.contact_number,
            isMale = _selected$.isMale;

        this.givenName = given_name;
        this.familyName = family_name;
        this.middleName = middle_name;
        this.extName = ext_name;
        this.contactNo = contact_number;
        this.date = birthday;
        this.gender = isMale;
      }
      this.instructorDialog = true;
    },
    allowedDates: function allowedDates(val) {
      return new Date().toISOString().substr(0, 10) >= val;
    },
    save: function save(date) {
      this.$refs.menu.save(date);
    },
    clearFormField: function clearFormField() {
      this.instructorDialog = false;
      this.username = '', this.password = '', this.givenName = '', this.familyName = '', this.middleName = '', this.extName = '', this.address = '', this.contactNo = '';
      this.gender = true;
    }
  },
  created: function created() {
    this.$store.dispatch('admin/FETCH_INSTRUCTORS');
  },

  computed: {
    items: function items() {
      var items = this.$store.getters['admin/GET_INSTRUCTORS'].map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item.profile, { verified: item.verified, value: false });
      }).filter(function (item) {
        if (item.verified) return item;
      });
      return items;
    },
    dateErrors: function dateErrors() {
      var errors = [];
      if (!this.$v.date.$dirty) return errors;
      !this.$v.date.required && errors.push('Birthdate is required');
      return errors;
    },

    // userNameErrors(){
    //   const errors = []
    //   if(!this.$v.username.$dirty) return errors
    //   !this.$v.username.required && errors.push('Username is required')
    //   return errors
    // },
    // passwordErrors(){
    //   const errors = []
    //   if(!this.$v.password.$dirty) return errors
    //   !this.$v.password.required && errors.push('Password is required')
    //   return errors
    // },
    givenNameErrors: function givenNameErrors() {
      var errors = [];
      if (!this.$v.givenName.$dirty) return errors;
      !this.$v.givenName.required && errors.push('Given name is required');
      return errors;
    },
    familyNameErrors: function familyNameErrors() {
      var errors = [];
      if (!this.$v.familyName.$dirty) return errors;
      !this.$v.familyName.required && errors.push('Family name is required');
      return errors;
    },
    contactNoErrors: function contactNoErrors() {
      var errors = [];
      if (!this.$v.contactNo.$dirty) return errors;
      !this.$v.contactNo.required && errors.push('Contact number is required');
      return errors;
    },
    editSelected: function editSelected() {
      return this.selected.length == 1 ? true : false;
    },
    deleteSelected: function deleteSelected() {
      return this.selected.length > 0 ? true : false;
    }
  },
  notifications: {
    showSuccessMsg: { type: __WEBPACK_IMPORTED_MODULE_3_vue_notifications___default.a.types.success },
    showErrorMsg: { type: __WEBPACK_IMPORTED_MODULE_3_vue_notifications___default.a.types.error }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notifications__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5_vuelidate__["validationMixin"]],
  validations: {
    date: {
      required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
    },
    // username: {
    //   required
    // },
    // password: {
    //   required
    // },
    givenName: {
      required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
    },
    familyName: {
      required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
    },
    contactNo: {
      required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
    }
  },
  data: function data() {
    return {
      fab: false,
      bottom: true,
      right: true,
      transition: 'slide-y-reverse-transition',
      direction: 'top',
      selected: [],
      headers: [{ text: 'Family Name', value: 'family_name', align: 'left' }, { text: 'Given Name', value: 'given_name', align: 'left' }, { text: 'Middle Name', value: 'middle_name', align: 'left' }, { text: 'Extension Name', value: 'ext_name', align: 'left' }, { text: 'Birthdate', value: 'birthdate', align: 'left' }, { text: 'Address', value: 'address', align: 'left' }, { text: 'Username', value: 'username', align: 'left' }],
      search: '',
      checkIfAdd: false,
      studentDialog: false,
      deleteModal: false,
      username: '',
      password: '',
      givenName: '',
      familyName: '',
      middleName: '',
      extName: '',
      address: '',
      contactNo: '',
      menu: false,
      date: null,
      gender: true
    };
  },
  created: function created() {
    this.$store.dispatch('admin/FETCH_STUDENTS');
  },

  methods: {
    addStudent: function addStudent() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var username, password, givenName, familyName, middleName, extName, address, contactNo, date, gender;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                username = _this.username, password = _this.password, givenName = _this.givenName, familyName = _this.familyName, middleName = _this.middleName, extName = _this.extName, address = _this.address, contactNo = _this.contactNo, date = _this.date, gender = _this.gender;

                _this.$v.$touch();

                if (_this.$v.$error) {
                  _context.next = 19;
                  break;
                }

                _this.$Progress.start();
                _context.prev = 4;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/api/accounts', {
                  username: username,
                  password: password,
                  given_name: givenName,
                  family_name: familyName,
                  middle_name: middleName,
                  ext_name: extName,
                  birthday: date,
                  address: address,
                  contact_number: contactNo,
                  user_role: 2,
                  isMale: gender
                }, {
                  headers: {
                    'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN
                  } });

              case 7:
                _this.$store.dispatch('admin/FETCH_STUDENTS');
                _this.clearFormField();
                _this.instructorDialog = false;
                _this.showSuccessMsg({ title: 'Success!', message: 'Student added successfully!' });
                _this.$Progress.finish();
                _context.next = 19;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](4);

                console.log(_context.t0);
                _this.showErrorMsg({ title: _context.t0.response.statusText, message: _context.t0.response.data.error.join(' ') });
                _this.$Progress.fail();

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 14]]);
      }))();
    },
    editStudent: function editStudent() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var username, password, givenName, familyName, middleName, extName, address, contactNo, date, gender;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                username = _this2.username, password = _this2.password, givenName = _this2.givenName, familyName = _this2.familyName, middleName = _this2.middleName, extName = _this2.extName, address = _this2.address, contactNo = _this2.contactNo, date = _this2.date, gender = _this2.gender;

                _this2.$v.$touch();

                if (_this2.$v.$error) {
                  _context2.next = 20;
                  break;
                }

                _context2.prev = 3;

                _this2.$Progress.start();
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/api/accounts/update', {
                  user_id: _this2.selected[0].user_id,
                  given_name: givenName,
                  family_name: familyName,
                  middle_name: middleName,
                  ext_name: extName,
                  birthday: date,
                  address: address,
                  contact_number: contactNo,
                  isMale: gender
                }, { headers: {
                    'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN
                  } });

              case 7:
                _this2.$store.dispatch('admin/FETCH_STUDENTS');
                _this2.clearFormField();
                _this2.instructorDialog = false;
                _this2.selected = [];
                _this2.showSuccessMsg({ title: 'Success!', message: 'Student updated successfully!' });
                _this2.$Progress.finish();
                _context2.next = 20;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](3);

                // this.clearFormField()
                // this.instructorDialog = false
                console.log(_context2.t0);
                _this2.showErrorMsg({ title: _context2.t0.response.statusText, message: _context2.t0.response.data.error.join(' ') });
                _this2.$Progress.fail();

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[3, 15]]);
      }))();
    },
    deleteStudents: function deleteStudents() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var students;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                students = _this3.selected.map(function (student) {
                  return student.user_id;
                });
                _context3.prev = 1;

                _this3.$Progress.start();
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('/api/accounts', {
                  params: {
                    ids: students
                  },
                  headers: {
                    'Authorization': 'Bearer ' + _this3.$store.getters.GET_TOKEN
                  } });

              case 5:
                _this3.$store.dispatch('admin/FETCH_STUDENTS');
                _this3.deleteModal = false;
                _this3.clearFormField();
                _this3.showSuccessMsg({ title: 'Success!', message: 'Student deleted successfully!' });
                _this3.selected = [];
                _this3.$Progress.finish();
                _context3.next = 18;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](1);

                console.log(_context3.t0);
                _this3.showErrorMsg({ title: _context3.t0.response.statusText, message: _context3.t0.response.data.error.join(' ') });
                _this3.$Progress.fail();

              case 18:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 13]]);
      }))();
    },
    setStudentsAction: function setStudentsAction(action) {
      this.checkIfAdd = action;
      if (!action) {
        var _selected$ = this.selected[0],
            given_name = _selected$.given_name,
            family_name = _selected$.family_name,
            middle_name = _selected$.middle_name,
            ext_name = _selected$.ext_name,
            birthday = _selected$.birthday,
            address = _selected$.address,
            contact_number = _selected$.contact_number,
            isMale = _selected$.isMale;

        this.givenName = given_name;
        this.familyName = family_name;
        this.middleName = middle_name;
        this.extName = ext_name;
        this.contactNo = contact_number;
        this.date = birthday;
        this.gender = isMale;
        this.address = address;
      }
      this.studentDialog = true;
    },
    save: function save(date) {
      this.$refs.menu.save(date);
    },
    allowedDates: function allowedDates(val) {
      return new Date().toISOString().substr(0, 10) >= val;
    },
    clearFormField: function clearFormField() {
      this.studentDialog = false;
      this.username = '', this.password = '', this.givenName = '', this.familyName = '', this.middleName = '', this.extName = '', this.address = '', this.contactNo = '';
      this.gender = true;
    }
  },
  watch: {
    menu: function menu(val) {
      var _this4 = this;

      val && this.$nextTick(function () {
        return _this4.$refs.picker.activePicker = 'YEAR';
      });
    }
  },
  computed: {
    items: function items() {
      var items = this.$store.getters['admin/GET_STUDENTS'].map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item.profile, { verified: item.verified, username: item.username, value: false });
      }).filter(function (item) {
        if (item.verified) return item;
      });
      return items;
    },
    editSelected: function editSelected() {
      return this.selected.length == 1 ? true : false;
    },
    deleteSelected: function deleteSelected() {
      return this.selected.length > 0 ? true : false;
    },
    dateErrors: function dateErrors() {
      var errors = [];
      if (!this.$v.date.$dirty) return errors;
      !this.$v.date.required && errors.push('Birthdate is required');
      return errors;
    },

    // userNameErrors(){
    //   const errors = []
    //   if(!this.$v.username.$dirty) return errors
    //   !this.$v.username.required && errors.push('Username is required')
    //   return errors
    // },
    // passwordErrors(){
    //   const errors = []
    //   if(!this.$v.password.$dirty) return errors
    //   !this.$v.password.required && errors.push('Password is required')
    //   return errors
    // },
    givenNameErrors: function givenNameErrors() {
      var errors = [];
      if (!this.$v.givenName.$dirty) return errors;
      !this.$v.givenName.required && errors.push('Given name is required');
      return errors;
    },
    familyNameErrors: function familyNameErrors() {
      var errors = [];
      if (!this.$v.familyName.$dirty) return errors;
      !this.$v.familyName.required && errors.push('Family name is required');
      return errors;
    },
    contactNoErrors: function contactNoErrors() {
      var errors = [];
      if (!this.$v.contactNo.$dirty) return errors;
      !this.$v.contactNo.required && errors.push('Contact number is required');
      return errors;
    }
  },
  notifications: {
    showSuccessMsg: { type: __WEBPACK_IMPORTED_MODULE_3_vue_notifications___default.a.types.success },
    showErrorMsg: { type: __WEBPACK_IMPORTED_MODULE_3_vue_notifications___default.a.types.error }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vuelidate__["validationMixin"]],
  validations: {
    eventName: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    startDate: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    endDate: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    }
  },
  data: function data() {
    return {
      fab: false,
      bottom: true,
      right: true,
      transition: 'slide-y-reverse-transition',
      direction: 'top',
      selected: [],
      headers: [{ text: 'Name', value: 'name', align: 'left' }, { text: 'Description', value: 'description', align: 'left' }, { text: 'Start Date', value: 'start_date', align: 'left' }, { text: 'End Date', value: 'end_date', align: 'left' }],
      eventDialog: false,
      startDateMenu: false,
      startDate: null,
      startDatePicker: false,
      endDateMenu: false,
      endDate: null,
      endDatePicker: false,
      eventName: '',
      description: '',
      deleteModal: false,
      checkIfAdd: null,
      eventId: null
    };
  },

  methods: {
    addCalendarEvent: function addCalendarEvent() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var startDate, endDate, description, eventName, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                startDate = _this.startDate, endDate = _this.endDate, description = _this.description, eventName = _this.eventName;

                _this.$v.$touch();

                if (_this.$v.$error) {
                  _context.next = 22;
                  break;
                }

                _context.prev = 3;

                _this.$Progress.start();
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/calendar', {
                  name: eventName,
                  description: description,
                  start_date: startDate,
                  end_date: endDate
                }, { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

              case 7:
                response = _context.sent;

                _this.$store.dispatch('admin/CALENDAR_EVENTS');
                _this.clearFormField();
                _this.eventDialog = false;
                _this.showSuccessMsg({ title: 'Success!', message: 'Calendar event is successfully added!' });
                _this.$Progress.finish();
                _context.next = 22;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](3);

                _this.clearFormField();
                _this.eventDialog = false;
                console.log(_context.t0);
                _this.showErrorMsg({ title: _context.t0.response.statusText, message: _context.t0.response.data.error.message });
                _this.$Progress.fail();

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 15]]);
      }))();
    },
    editCalendarEvent: function editCalendarEvent() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var startDate, endDate, description, eventName, eventId, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                startDate = _this2.startDate, endDate = _this2.endDate, description = _this2.description, eventName = _this2.eventName, eventId = _this2.eventId;

                _this2.$v.$touch();

                if (_this2.$v.$error) {
                  _context2.next = 23;
                  break;
                }

                _context2.prev = 3;

                _this2.$Progress.start();
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put('/api/calendar/' + eventId, {
                  name: eventName,
                  description: description,
                  start_date: startDate,
                  end_date: endDate
                }, { headers: { 'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN } });

              case 7:
                result = _context2.sent;

                _this2.$store.dispatch('admin/CALENDAR_EVENTS');
                _this2.clearFormField();
                _this2.eventDialog = false;
                _this2.showSuccessMsg({ title: 'Success!', message: 'Calendar event is successfully updated!' });
                _this2.selected = [];
                _this2.$Progress.finish();
                _context2.next = 23;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](3);

                _this2.clearFormField();
                _this2.eventDialog = false;
                console.log(_context2.t0);
                _this2.showErrorMsg({ title: _context2.t0.response.statusText, message: _context2.t0.response.data.error.join(' ') });
                _this2.$Progress.fail();

              case 23:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[3, 16]]);
      }))();
    },
    deleteCalendarEvent: function deleteCalendarEvent() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var events, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                events = _this3.selected.map(function (event) {
                  return event.event_id;
                });
                _context3.prev = 1;

                _this3.$Progress.start();
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete('/api/calendar', {
                  params: {
                    ids: events
                  },
                  headers: {
                    'Authorization': 'Bearer ' + _this3.$store.getters.GET_TOKEN
                  } });

              case 5:
                response = _context3.sent;

                _this3.$store.dispatch('admin/CALENDAR_EVENTS');
                _this3.clearFormField();
                _this3.deleteModal = false;
                _this3.showSuccessMsg({ title: 'Success!', message: 'Calendar event is successfully deleted!' });
                _this3.selected = [];
                _this3.$Progress.finish();
                _context3.next = 20;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3['catch'](1);

                _this3.$store.dispatch('admin/CALENDAR_EVENTS');
                console.log(_context3.t0);
                _this3.showErrorMsg({ title: _context3.t0.response.statusText, message: _context3.t0.response.data.error.join(' ') });
                _this3.$Progress.fail();

              case 20:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 14]]);
      }))();
    },
    setEventAction: function setEventAction(action) {
      // If action is true then it is add, else it is false
      this.checkIfAdd = action ? true : false;
      // If edit is clicked
      if (!action) {
        var _selected$ = this.selected[0],
            description = _selected$.description,
            end_date = _selected$.end_date,
            event_id = _selected$.event_id,
            name = _selected$.name,
            start_date = _selected$.start_date;

        this.eventName = name;
        this.description = description;
        this.startDate = start_date;
        this.endDate = end_date;
        this.eventId = event_id;
      }

      this.eventDialog = true;
    },
    clearFormField: function clearFormField() {
      this.eventDialog = false;
      this.startDate = null;
      this.endDate = null;
      this.eventName = '';
      this.description = '';
    },
    allowedDates: function allowedDates(val) {
      if (this.startDate) {
        return this.startDate <= val;
      }
    }
  },
  created: function created() {
    this.$store.dispatch('admin/CALENDAR_EVENTS');
  },

  computed: {
    editSelected: function editSelected() {
      return this.selected.length == 1 ? true : false;
    },
    deleteSelected: function deleteSelected() {
      return this.selected.length > 0 ? true : false;
    },
    items: function items() {
      return this.$store.getters['admin/GET_CALENDAR_EVENTS'];
    },
    eventNameErrors: function eventNameErrors() {
      var errors = [];
      if (!this.$v.eventName.$dirty) return errors;
      !this.$v.eventName.required && errors.push('Event Name is required');
      return errors;
    },
    startDateErrors: function startDateErrors() {
      var errors = [];
      if (!this.$v.startDate.$dirty) return errors;
      !this.$v.startDate.required && errors.push('Start Date is required');
      return errors;
    },
    endDateErrors: function endDateErrors() {
      var errors = [];
      if (!this.$v.endDate.$dirty) return errors;
      !this.$v.endDate.required && errors.push('End Date is required');
      return errors;
    }
  },
  notifications: {
    showSuccessMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.success },
    showErrorMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.error }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vuelidate__["validationMixin"]],
  validations: {
    newsTitle: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    newsContent: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    }
  },
  data: function data() {
    return {
      fab: false,
      bottom: true,
      right: true,
      transition: 'slide-y-reverse-transition',
      direction: 'top',
      selected: [],
      headers: [{ text: 'Title', value: 'title', align: 'left' }, { text: 'Content', value: 'content', align: 'left' }],
      newsDialog: false,
      checkIfAdd: null,
      newsTitle: '',
      newsContent: '',
      newsId: null,
      deleteModal: false,
      image: null,
      imageTitle: ''
    };
  },

  methods: {
    imageHandler: function imageHandler() {
      this.image = this.$refs.image.files[0];
      this.imageTitle = this.$refs.image.files[0].name;
    },
    setNewsAction: function setNewsAction(action) {
      this.checkIfAdd = action ? true : false;
      if (!action) {
        var _selected$ = this.selected[0],
            news_id = _selected$.news_id,
            news_title = _selected$.news_title,
            news_content = _selected$.news_content;

        this.newsTitle = news_title;
        this.newsContent = news_content;
        this.newsId = news_id;
      }
      this.newsDialog = true;
    },
    clearFormField: function clearFormField() {
      this.newsDialog = false;
      this.newsTitle = '';
      this.newsContent = '';
      this.image = null;
      this.imageTitle = '';
    },
    addNews: function addNews() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var newsTitle, newsContent, image, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                newsTitle = _this.newsTitle, newsContent = _this.newsContent, image = _this.image;

                _this.$v.$touch();

                if (_this.$v.$error) {
                  _context.next = 25;
                  break;
                }

                _context.prev = 3;

                _this.$Progress.start();
                data = new FormData();

                data.append('news_title', newsTitle);
                data.append('news_content', newsContent);
                data.append('image', image);
                _context.next = 11;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/news', data, {
                  headers: {
                    'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN,
                    'Content-Type': 'multipart/form-data'
                  }

                });

              case 11:
                _this.$store.dispatch('admin/FETCH_NEWS');
                _this.clearFormField();
                _this.newsDialog = false;
                _this.showSuccessMsg({ title: 'Success!', message: 'Article added successfully!' });
                _this.$Progress.finish();
                _context.next = 25;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](3);

                _this.clearFormField();
                _this.newsDialog = false;
                console.log(_context.t0);
                _this.showErrorMsg({ title: _context.t0.response.statusText, message: _context.t0.response.data.error.join(' ') });
                _this.$Progress.fail();

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 18]]);
      }))();
    },
    editNews: function editNews() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var newsTitle, newsContent, newsId;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                newsTitle = _this2.newsTitle, newsContent = _this2.newsContent, newsId = _this2.newsId;

                _this2.$v.$touch();

                if (_this2.$v.$error) {
                  _context2.next = 22;
                  break;
                }

                _context2.prev = 3;

                _this2.$Progress.start();
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put('/api/news/' + newsId, {
                  news_title: newsTitle,
                  news_content: newsContent
                }, { headers: { 'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN } });

              case 7:
                _this2.$store.dispatch('admin/FETCH_NEWS');
                _this2.clearFormField();
                _this2.selected = [];
                _this2.eventDialog = false;
                _this2.showSuccessMsg({ title: 'Success!', message: 'Article updated successfully!' });
                _this2.$Progress.finish();
                _context2.next = 22;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](3);

                _this2.clearFormField();
                _this2.newsDialog = false;
                _this2.showErrorMsg({ title: _context2.t0.response.statusText, message: _context2.t0.response.data.error.join(' ') });
                console.log(_context2.t0);
                _this2.$Progress.fail();

              case 22:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[3, 15]]);
      }))();
    },
    deleteNews: function deleteNews() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var news;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                news = _this3.selected.map(function (news) {
                  return news.news_id;
                });
                _context3.prev = 1;

                _this3.$Progress.start();
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete('/api/news', {
                  params: {
                    ids: news
                  },
                  headers: {
                    'Authorization': 'Bearer ' + _this3.$store.getters.GET_TOKEN
                  } });

              case 5:
                _this3.$store.dispatch('admin/FETCH_NEWS');
                _this3.deleteModal = false;
                _this3.clearFormField();
                _this3.showSuccessMsg({ title: 'Success!', message: 'Article deleted successfully!' });
                _this3.selected = [];
                _this3.$Progress.finish();
                _context3.next = 20;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](1);

                _this3.clearFormField();
                _this3.newsDialog = false;
                _this3.showErrorMsg({ title: _context3.t0.response.statusText, message: _context3.t0.response.data.error.join(' ') });
                console.log(_context3.t0);
                _this3.$Progress.fail();

              case 20:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 13]]);
      }))();
    }
  },
  created: function created() {
    this.$store.dispatch('admin/FETCH_NEWS');
  },

  computed: {
    items: function items() {
      return this.$store.getters['admin/GET_NEWS'];
    },
    editSelected: function editSelected() {
      return this.selected.length == 1 ? true : false;
    },
    deleteSelected: function deleteSelected() {
      return this.selected.length > 0 ? true : false;
    },
    newsTitleErrors: function newsTitleErrors() {
      var errors = [];
      if (!this.$v.newsTitle.$dirty) return errors;
      !this.$v.newsTitle.required && errors.push('A title is required');
      return errors;
    },
    newsContentErrors: function newsContentErrors() {
      var errors = [];
      if (!this.$v.newsContent.$dirty) return errors;
      !this.$v.newsContent.required && errors.push('A content is required');
      return errors;
    }
  },
  notifications: {
    showSuccessMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.success },
    showErrorMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.error }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Profile_vue__ = __webpack_require__(683);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Profile: __WEBPACK_IMPORTED_MODULE_6__Profile_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vuelidate__["validationMixin"]],
  validations: {
    classroomName: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    subject: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    section: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    }
  },
  data: function data() {
    return {
      fab: false,
      bottom: true,
      right: true,
      transition: 'slide-y-reverse-transition',
      direction: 'top',
      classDialog: false,
      classroomName: '',
      subject: '',
      section: '',
      checkIfAdd: null,
      editId: null,
      deleteModal: false,
      selectedId: null
    };
  },

  methods: {
    addClass: function addClass() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var classroomName, subject, section, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                classroomName = _this.classroomName, subject = _this.subject, section = _this.section;

                _this.$v.$touch();

                if (_this.$v.$error) {
                  _context.next = 22;
                  break;
                }

                _context.prev = 3;

                _this.$Progress.start();
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/class', {
                  name: classroomName,
                  subject: subject,
                  section: section
                }, { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

              case 7:
                response = _context.sent;

                _this.$store.dispatch('instructor/FETCH_CLASSES');
                _this.clearFormField();
                _this.classDialog = false;
                _this.showSuccessMsg({ title: 'Success!', message: 'Classroom added successfully!' });
                _this.$Progress.finish();
                _context.next = 22;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](3);

                _this.clearFormField();
                _this.classDialog = false;
                _this.showErrorMsg({ title: _context.t0.response.statusText, message: _context.t0.response.data.error.message });
                console.log(_context.t0);
                _this.$Progress.fail();

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 15]]);
      }))();
    },
    editClass: function editClass() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var classroomName, subject, section, editId, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                classroomName = _this2.classroomName, subject = _this2.subject, section = _this2.section, editId = _this2.editId;

                _this2.$v.$touch();

                if (_this2.$v.$error) {
                  _context2.next = 22;
                  break;
                }

                _context2.prev = 3;

                _this2.$Progress.start();
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put('/api/class/' + editId, {
                  name: classroomName,
                  subject: subject,
                  section: section
                }, { headers: { 'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN } });

              case 7:
                result = _context2.sent;

                _this2.$store.dispatch('instructor/FETCH_CLASSES');
                _this2.clearFormField();
                _this2.classDialog = false;
                _this2.showSuccessMsg({ title: 'Success!', message: 'Classroom details is updated successfully!' });
                _this2.$Progress.finish();
                _context2.next = 22;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](3);

                _this2.clearFormField();
                _this2.classDialog = false;
                _this2.showErrorMsg({ title: _context2.t0.response.statusText, message: _context2.t0.response.data.error.message });
                console.log(_context2.t0);
                _this2.$Progress.fail();

              case 22:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[3, 15]]);
      }))();
    },
    deleteClass: function deleteClass() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete('/api/class/' + _this3.selectedId, {
                  headers: {
                    'Authorization': 'Bearer ' + _this3.$store.getters.GET_TOKEN
                  }
                });

              case 3:
                response = _context3.sent;

                _this3.$store.dispatch('instructor/FETCH_CLASSES');
                _this3.clearFormField();
                _this3.deleteModal = false;
                _this3.showSuccessMsg({ title: 'Success!', message: 'Classroom is deleted successfully!' });
                _this3.$Progress.finish();
                _context3.next = 18;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](0);

                _this3.clearFormField();
                _this3.deleteModal = false;
                _this3.showErrorMsg({ title: _context3.t0.response.statusText, message: _context3.t0.response.data.error.message });
                console.log(_context3.t0);
                _this3.$Progress.fail();

              case 18:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 11]]);
      }))();
    },
    unenroll: function unenroll() {},
    configDelete: function configDelete(id) {
      this.deleteModal = true;
      this.selectedId = id;
    },
    setEventAction: function setEventAction(action, id) {
      // If action is true then it is add, else it is false
      this.checkIfAdd = action ? true : false;
      // If edit is clicked
      if (!action) {
        var details = this.$store.getters['instructor/GET_CLASSES'].find(function (el) {
          return el.classroom_id === id;
        });
        this.editId = id;
        this.classroomName = details.classroom_name;
        this.subject = details.subject;
        this.section = details.section;
      }

      this.classDialog = true;
    },
    clearFormField: function clearFormField() {
      this.classroomName = '';
      this.subject = '';
      this.section = '';
      this.classDialog = false;
    }
  },
  created: function created() {
    this.$store.dispatch('instructor/FETCH_CLASSES');
  },

  computed: {
    classroomNameErrors: function classroomNameErrors() {
      var errors = [];
      if (!this.$v.classroomName.$dirty) return errors;
      !this.$v.classroomName.required && errors.push('Classroom Name is required');
      return errors;
    },
    subjectErrors: function subjectErrors() {
      var errors = [];
      if (!this.$v.subject.$dirty) return errors;
      !this.$v.subject.required && errors.push('Subject is required');
      return errors;
    },
    sectionErrors: function sectionErrors() {
      var errors = [];
      if (!this.$v.section.$dirty) return errors;
      !this.$v.section.required && errors.push('Section is required');
      return errors;
    },
    classrooms: function classrooms() {
      return this.$store.getters['instructor/GET_CLASSES'];
    }
  },
  notifications: {
    showSuccessMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.success },
    showErrorMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.error }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vuelidate__["validationMixin"]],
  validations: {
    date: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    givenName: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    familyName: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    contactNo: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    }
  },
  data: function data() {
    return {
      givenName: '',
      familyName: '',
      middleName: '',
      extName: '',
      date: '',
      menu: false,
      address: '',
      contactNo: '',
      profile: null,
      imageDialog: false,
      profileDialog: false,
      loading: false,
      gender: true,
      passwordDialog: false,
      password1: '',
      password2: ''
    };
  },
  created: function created() {
    this.getProfile();
  },

  methods: {
    changePassword: function changePassword() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.password1 && _this.password2)) {
                  _context.next = 22;
                  break;
                }

                if (!(_this.password1 === _this.password2)) {
                  _context.next = 20;
                  break;
                }

                _context.prev = 2;

                _this.$Progress.start();
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/profile/changepassword', {
                  password: _this.password1
                }, { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

              case 6:
                res = _context.sent;

                _this.passwordDialog = false;
                _this.password1 = '';
                _this.password2 = '';
                _this.showSuccessMsg({ title: 'Success!', message: 'Password updated successfully!' });
                _this.$Progress.finish();
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](2);

                console.log(_context.t0);
                _this.$Progress.fail();

              case 18:
                _context.next = 22;
                break;

              case 20:
                _this.showErrorMsg({ title: 'Error!', message: 'Passwords do not match!' });
                _this.$Progress.fail();

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 14]]);
      }))();
    },
    getProfile: function getProfile() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var profile;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/api/profile', { headers: { 'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN } });

              case 2:
                profile = _context2.sent;


                _this2.givenName = profile.data.given_name;
                _this2.familyName = profile.data.family_name;
                _this2.middleName = profile.data.middle_name;
                _this2.extName = profile.data.ext_name;
                _this2.date = profile.data.birthday;
                _this2.address = profile.data.address;
                _this2.contactNo = profile.data.contact_number;
                _this2.gender = profile.data.isMale;
                _this2.profile = profile.data;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    changeProfileImage: function changeProfileImage() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = new FormData();

                data.append('image', _this3.$refs.image.files[0]);
                _context3.prev = 2;

                _this3.$Progress.start();
                _this3.loading = true;
                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/profile/image/update', data, {
                  headers: {
                    'Authorization': 'Bearer ' + _this3.$store.getters.GET_TOKEN,
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 7:
                res = _context3.sent;

                _this3.showSuccessMsg({ title: 'Success!', message: 'Profile image updated successfully!' });
                _this3.$Progress.finish();
                _this3.getProfile();
                _this3.loading = false;
                _this3.imageDialog = false;
                _context3.next = 21;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3['catch'](2);

                console.log(_context3.t0);
                _this3.showErrorMsg({ title: _context3.t0.response.statusText, message: _context3.t0.response.data.error.join(' ') });
                _this3.loading = false;
                _this3.$Progress.fail();

              case 21:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[2, 15]]);
      }))();
    },
    editProfileDetails: function editProfileDetails() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var givenName, familyName, middleName, extName, address, contactNo, date, gender;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                givenName = _this4.givenName, familyName = _this4.familyName, middleName = _this4.middleName, extName = _this4.extName, address = _this4.address, contactNo = _this4.contactNo, date = _this4.date, gender = _this4.gender;

                if (_this4.$v.$error) {
                  _context4.next = 17;
                  break;
                }

                _context4.prev = 2;

                _this4.$Progress.start();
                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/profile/update', {
                  given_name: givenName,
                  family_name: familyName,
                  middle_name: middleName,
                  ext_name: extName,
                  birthday: date,
                  address: address,
                  contact_number: contactNo,
                  isMale: gender
                }, { headers: {
                    'Authorization': 'Bearer ' + _this4.$store.getters.GET_TOKEN
                  } });

              case 6:
                _this4.showSuccessMsg({ title: 'Success!', message: 'Profile details updated successfully!' });
                _this4.getProfile();
                _this4.$Progress.finish();
                _this4.profileDialog = false;
                _context4.next = 17;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4['catch'](2);

                console.log(_context4.t0);
                _this4.showErrorMsg({ title: _context4.t0.response.statusText, message: _context4.t0.response.data.error.join(' ') });
                _this4.$Progress.fail();

              case 17:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[2, 12]]);
      }))();
    },
    allowedDates: function allowedDates(val) {
      return new Date().toISOString().substr(0, 10) >= val;
    },
    save: function save(date) {
      this.$refs.menu.save(date);
    }
  },
  computed: {
    dateErrors: function dateErrors() {
      var errors = [];
      if (!this.$v.date.$dirty) return errors;
      !this.$v.date.required && errors.push('Birthdate is required');
      return errors;
    },
    givenNameErrors: function givenNameErrors() {
      var errors = [];
      if (!this.$v.givenName.$dirty) return errors;
      !this.$v.givenName.required && errors.push('Given name is required');
      return errors;
    },
    familyNameErrors: function familyNameErrors() {
      var errors = [];
      if (!this.$v.familyName.$dirty) return errors;
      !this.$v.familyName.required && errors.push('Family name is required');
      return errors;
    },
    contactNoErrors: function contactNoErrors() {
      var errors = [];
      if (!this.$v.contactNo.$dirty) return errors;
      !this.$v.contactNo.required && errors.push('Contact number is required');
      return errors;
    }
  },
  watch: {
    menu: function menu(val) {
      var _this5 = this;

      val && this.$nextTick(function () {
        return _this5.$refs.picker.activePicker = 'YEAR';
      });
    }
  },
  notifications: {
    showSuccessMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.success },
    showErrorMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.error }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Classroom_Post_vue__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Classroom_AddPost_vue__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Classroom_Students_vue__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Classroom_Files_vue__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Classroom_Assignments_vue__ = __webpack_require__(701);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Post: __WEBPACK_IMPORTED_MODULE_3__Classroom_Post_vue__["a" /* default */], AddPost: __WEBPACK_IMPORTED_MODULE_4__Classroom_AddPost_vue__["a" /* default */], StudentList: __WEBPACK_IMPORTED_MODULE_5__Classroom_Students_vue__["a" /* default */], FileList: __WEBPACK_IMPORTED_MODULE_6__Classroom_Files_vue__["a" /* default */], AssignmentList: __WEBPACK_IMPORTED_MODULE_7__Classroom_Assignments_vue__["a" /* default */]
  },
  data: function data() {
    return {
      items: ['Feed', 'Students', 'Files', 'Assignments'],
      classInfo: '',
      students: []
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$store.dispatch('instructor/FETCH_POSTS', { class_id: _this.$route.params.id });
              _this.$store.dispatch('instructor/FETCH_FILES', { class_id: _this.$route.params.id });
              _this.$store.dispatch('instructor/FETCH_ASSIGNMENTS', { class_id: _this.$route.params.id });

              _this.fetchStudents();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    fetchStudents: function fetchStudents() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var info;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/class/' + _this2.$route.params.id, { headers: { 'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN } });

              case 3:
                info = _context2.sent;

                _this2.classInfo = info.data;
                _this2.students = info.data.studentclass;
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8]]);
      }))();
    }
  },
  computed: {
    posts: function posts() {
      return this.$store.getters['instructor/GET_POSTS'];
    },
    files: function files() {
      return this.$store.getters['instructor/GET_FILES'];
    },
    assignments: function assignments() {
      return this.$store.getters['instructor/GET_ASSIGNMENTS'];
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PostComment_vue__ = __webpack_require__(689);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostComment: __WEBPACK_IMPORTED_MODULE_3__PostComment_vue__["a" /* default */]
  },
  props: ['post'],
  data: function data() {
    return {
      commentStatus: false,
      commentText: '',
      editedText: '',
      loading: false,
      editDialog: false,
      deleteDialog: false,
      collapsed: true
    };
  },

  methods: {
    comment: function comment() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/post/comment', {
                  post_id: _this.post.post_id,
                  comment: _this.commentText
                }, { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

              case 4:
                response = _context.sent;

                _this.$store.dispatch('instructor/FETCH_POSTS', { class_id: _this.$route.params.id });
                _this.restart();
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                _this.loading = false;
                console.log(_context.t0);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    restart: function restart() {
      this.loading = false;
      this.commentStatus = false;
      this.commentText = '';
      this.editedText = '';
      this.editDialog = false;
    },
    editPost: function editPost(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.loading = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/post/update', {
                  post_id: id,
                  post_content: _this2.editedText
                }, { headers: { 'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN } });

              case 4:
                response = _context2.sent;

                _this2.$store.dispatch('instructor/FETCH_POSTS', { class_id: _this2.$route.params.id });
                _this2.restart();
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                _this2.loading = false;
                console.log(_context2.t0);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    deletePost: function deletePost(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this3.loading = true;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/post/delete', null, {
                  headers: {
                    'Authorization': 'Bearer ' + _this3.$store.getters.GET_TOKEN
                  },
                  params: {
                    ids: [id]
                  }
                });

              case 4:
                response = _context3.sent;

                _this3.$store.dispatch('instructor/FETCH_POSTS', { class_id: _this3.$route.params.id });
                _this3.restart();
                _context3.next = 13;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);

                _this3.loading = false;
                console.log(_context3.t0);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 9]]);
      }))();
    },
    openEditDialog: function openEditDialog() {
      this.editDialog = true;
      this.editedText = this.post.post_content;
    }
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['comment'],
  data: function data() {
    return {
      editDialog: false,
      editedText: '',
      loading: false,
      deleteDialog: false
    };
  },

  methods: {
    openEditDialog: function openEditDialog() {
      this.editDialog = true;
      this.editedText = this.comment.comment;
    },
    editComment: function editComment(comment_id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/post/comment/update', {
                  comment_id: comment_id,
                  comment: _this.editedText
                }, { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

              case 4:
                response = _context.sent;

                _this.$store.dispatch('instructor/FETCH_POSTS', { class_id: _this.$route.params.id });
                _this.restart();
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                _this.loading = false;
                console.log(_context.t0);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    deleteComment: function deleteComment(comment_id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.loading = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/post/comment/delete', {
                  id: comment_id
                }, {
                  headers: {
                    'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN
                  } });

              case 4:
                response = _context2.sent;

                _this2.$store.dispatch('instructor/FETCH_POSTS', { class_id: _this2.$route.params.id });
                _this2.restart();
                _context2.next = 14;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                _this2.loading = false;
                _this2.showErrorMsg({ title: _context2.t0.response.statusText, message: _context2.t0.response.data.error.join(' ') });
                console.log(_context2.t0);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    restart: function restart() {
      this.loading = false;
      this.editedText = '';
      this.editDialog = false;
      this.deleteDialog = false;
    }
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      postStatus: false,
      text: '',
      loading: false
    };
  },

  methods: {
    postAnnouncement: function postAnnouncement() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/post', {
                  class_code: _this.$route.params.id,
                  post_content: _this.text
                }, { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

              case 4:
                _this.$store.dispatch('instructor/FETCH_POSTS', { class_id: _this.$route.params.id });
                _this.restart();
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                _this.loading = false;
                console.log(_context.t0);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    restart: function restart() {
      this.loading = false;
      this.postStatus = false;
      this.text = '';
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['student', 'fetchStudents'],
  data: function data() {
    return {
      deleteDialog: false,
      loading: false
    };
  },

  methods: {
    removeStudent: function removeStudent() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/' + _this.$route.params.id + '/remove', null, {
                  params: {
                    ids: [_this.student.student_id]
                  },
                  headers: {
                    'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN
                  }
                });

              case 4:
                res = _context.sent;

                console.log(res);
                _this.loading = false;
                _this.deleteDialog = false;
                _this.fetchStudents();
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](0);

                _this.loading = false;
                console.log(_context.t0);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 11]]);
      }))();
    }
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__File_vue__ = __webpack_require__(698);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    File: __WEBPACK_IMPORTED_MODULE_3__File_vue__["a" /* default */]
  },
  props: ['files'],
  data: function data() {
    return {
      fab: false,
      bottom: true,
      right: true,
      transition: 'slide-y-reverse-transition',
      direction: 'top',
      file: null,
      fileTitle: '',
      fileDialog: false,
      fileName: '',
      loading: false
    };
  },
  created: function created() {},

  methods: {
    fileHandler: function fileHandler() {
      this.file = this.$refs.file.files[0];
      this.fileTitle = this.$refs.file.files[0].name;
      this.fileDialog = true;
    },
    uploadFile: function uploadFile() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                data = new FormData();

                data.append('file_name', _this.fileTitle);
                data.append('file', _this.file);
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/' + _this.$route.params.id + '/upload', data, {
                  headers: {
                    'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN,
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 7:
                res = _context.sent;

                _this.$store.dispatch('instructor/FETCH_FILES', { class_id: _this.$route.params.id });
                _this.file = null;
                _this.fileTitle = '';
                _this.loading = false;
                _this.fileDialog = false;
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);
                _this.loading = false;

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 15]]);
      }))();
    }
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['file'],
  data: function data() {
    return {
      deleteDialog: false,
      loading: false
    };
  },

  methods: {
    downloadFile: function downloadFile(file) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/' + _this.$route.params.id + '/download', {
                  file_location: file
                }, {
                  headers: {
                    'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN
                  }
                });

              case 3:
                res = _context.sent;

                _this.$store.dispatch('instructor/FETCH_FILES', { class_id: _this.$route.params.id });
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    deleteFile: function deleteFile(file) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete('/api/class/' + _this2.$route.params.id + '/delete', {
                  headers: {
                    'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN
                  },
                  params: {
                    filenames: [file]
                  }
                });

              case 3:
                res = _context2.sent;

                _this2.deleteDialog = false;
                _this2.loading = false;
                _this2.$store.dispatch('instructor/FETCH_FILES', { class_id: _this2.$route.params.id });

                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    }
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Assignment_vue__ = __webpack_require__(702);
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['assignments'],
  components: { Assignment: __WEBPACK_IMPORTED_MODULE_0__Assignment_vue__["a" /* default */] }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['assignment'],
  data: function data() {
    return {
      loading: false,
      deleteDialog: false
    };
  },

  methods: {
    downloadFile: function downloadFile(file) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/' + _this.$route.params.id + '/download', {
                  file_location: file
                }, {
                  headers: {
                    'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN
                  }
                });

              case 3:
                res = _context.sent;
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 6]]);
      }))();
    },
    deleteFile: function deleteFile(file) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.loading = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete('/api/class/' + _this2.$route.params.id + '/assignments/delete', {
                  headers: {
                    'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN
                  },
                  params: {
                    filenames: [file]
                  }
                });

              case 4:
                res = _context2.sent;

                _this2.$store.dispatch('instructor/FETCH_ASSIGNMENTS', { class_id: _this2.$route.params.id });
                _this2.loading = false;
                _this2.deleteDialog = false;
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                _this2.loading = false;
                console.log(_context2.t0);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 10]]);
      }))();
    }
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ClassroomCard_vue__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Profile_vue__ = __webpack_require__(710);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ClassroomCard: __WEBPACK_IMPORTED_MODULE_4__ClassroomCard_vue__["a" /* default */], Profile: __WEBPACK_IMPORTED_MODULE_5__Profile_vue__["a" /* default */]
  },
  data: function data() {
    return {
      classCodeModal: false,
      classCode: '',
      loading: false,
      fab: false,
      bottom: true,
      right: true,
      transition: 'slide-y-reverse-transition',
      direction: 'top'
    };
  },
  created: function created() {
    this.$store.dispatch('student/FETCH_CLASSES');
  },

  methods: {
    enterClassCode: function enterClassCode() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/enroll', {
                  class_code: _this.classCode
                }, { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

              case 4:
                res = _context.sent;

                _this.classCodeModal = false;
                _this.loading = false;
                _this.$store.dispatch('student/FETCH_CLASSES');
                _this.classCode = '';
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](0);

                _this.loading = false;
                console.log(_context.t0);
                _this.showErrorMsg({ title: 'Failed!', message: _context.t0.response.data.error.join(' ') });

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 11]]);
      }))();
    }
  },
  computed: {
    classrooms: function classrooms() {
      return this.$store.getters['student/GET_CLASSES'];
    }
  },
  notifications: {
    showSuccessMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.success },
    showErrorMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.error }
  }
  // ZijCQq

});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['classroom', 'inc'],
  data: function data() {
    return {
      deleteDialog: false,
      loading: false
    };
  },

  methods: {
    unenroll: function unenroll() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/leave', {
                  class_code: '' + _this.classroom.classroom_id
                }, {
                  headers: {
                    'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN
                  }
                });

              case 4:
                res = _context.sent;

                _this.loading = false;
                _this.deleteDialog = false;
                _this.$store.dispatch('student/FETCH_CLASSES');
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);

                _this.loading = false;
                console.log(_context.t0);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 10]]);
      }))();
    }
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vuelidate__["validationMixin"]],
  validations: {
    date: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    givenName: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    familyName: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    },
    contactNo: {
      required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
    }
  },
  data: function data() {
    return {
      givenName: '',
      familyName: '',
      middleName: '',
      extName: '',
      date: '',
      menu: false,
      address: '',
      contactNo: '',
      profile: null,
      imageDialog: false,
      profileDialog: false,
      loading: false,
      gender: true,
      passwordDialog: false,
      password1: '',
      password2: ''
    };
  },
  created: function created() {
    this.getProfile();
  },

  methods: {
    changePassword: function changePassword() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.password1 && _this.password2)) {
                  _context.next = 22;
                  break;
                }

                if (!(_this.password1 === _this.password2)) {
                  _context.next = 20;
                  break;
                }

                _context.prev = 2;

                _this.$Progress.start();
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/profile/changepassword', {
                  password: _this.password1
                }, { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

              case 6:
                res = _context.sent;

                _this.passwordDialog = false;
                _this.password1 = '';
                _this.password2 = '';
                _this.showSuccessMsg({ title: 'Success!', message: 'Password updated successfully!' });
                _this.$Progress.finish();
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](2);

                console.log(_context.t0);
                _this.$Progress.fail();

              case 18:
                _context.next = 22;
                break;

              case 20:
                _this.showErrorMsg({ title: 'Error!', message: 'Passwords do not match!' });
                _this.$Progress.fail();

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 14]]);
      }))();
    },
    getProfile: function getProfile() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var profile;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/api/profile', { headers: { 'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN } });

              case 2:
                profile = _context2.sent;


                _this2.givenName = profile.data.given_name;
                _this2.familyName = profile.data.family_name;
                _this2.middleName = profile.data.middle_name;
                _this2.extName = profile.data.ext_name;
                _this2.date = profile.data.birthday;
                _this2.address = profile.data.address;
                _this2.contactNo = profile.data.contact_number;
                _this2.gender = profile.data.isMale;
                _this2.profile = profile.data;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    changeProfileImage: function changeProfileImage() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = new FormData();

                data.append('image', _this3.$refs.image.files[0]);
                _context3.prev = 2;

                _this3.$Progress.start();
                _this3.loading = true;
                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/profile/image/update', data, {
                  headers: {
                    'Authorization': 'Bearer ' + _this3.$store.getters.GET_TOKEN,
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 7:
                res = _context3.sent;

                _this3.showSuccessMsg({ title: 'Success!', message: 'Profile image updated successfully!' });
                _this3.$Progress.finish();
                _this3.getProfile();
                _this3.loading = false;
                _this3.imageDialog = false;
                _context3.next = 21;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3['catch'](2);

                _this3.loading = false;
                _this3.showErrorMsg({ title: _context3.t0.response.statusText, message: _context3.t0.response.data.error.join(' ') });
                _this3.$Progress.fail();
                console.log(_context3.t0);

              case 21:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[2, 15]]);
      }))();
    },
    editProfileDetails: function editProfileDetails() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var givenName, familyName, middleName, extName, address, contactNo, date, gender;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                givenName = _this4.givenName, familyName = _this4.familyName, middleName = _this4.middleName, extName = _this4.extName, address = _this4.address, contactNo = _this4.contactNo, date = _this4.date, gender = _this4.gender;

                if (_this4.$v.$error) {
                  _context4.next = 17;
                  break;
                }

                _context4.prev = 2;

                _this4.$Progress.start();
                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/profile/update', {
                  given_name: givenName,
                  family_name: familyName,
                  middle_name: middleName,
                  ext_name: extName,
                  birthday: date,
                  address: address,
                  contact_number: contactNo,
                  isMale: gender
                }, { headers: {
                    'Authorization': 'Bearer ' + _this4.$store.getters.GET_TOKEN
                  } });

              case 6:
                _this4.showSuccessMsg({ title: 'Success!', message: 'Profile details updated successfully!' });
                _this4.getProfile();
                _this4.$Progress.finish();
                _this4.profileDialog = false;
                _context4.next = 17;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4['catch'](2);

                console.log(_context4.t0);
                _this4.showErrorMsg({ title: _context4.t0.response.statusText, message: _context4.t0.response.data.error.join(' ') });
                _this4.$Progress.fail();

              case 17:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[2, 12]]);
      }))();
    },
    allowedDates: function allowedDates(val) {
      return new Date().toISOString().substr(0, 10) >= val;
    },
    save: function save(date) {
      this.$refs.menu.save(date);
    }
  },
  computed: {
    dateErrors: function dateErrors() {
      var errors = [];
      if (!this.$v.date.$dirty) return errors;
      !this.$v.date.required && errors.push('Birthdate is required');
      return errors;
    },
    givenNameErrors: function givenNameErrors() {
      var errors = [];
      if (!this.$v.givenName.$dirty) return errors;
      !this.$v.givenName.required && errors.push('Given name is required');
      return errors;
    },
    familyNameErrors: function familyNameErrors() {
      var errors = [];
      if (!this.$v.familyName.$dirty) return errors;
      !this.$v.familyName.required && errors.push('Family name is required');
      return errors;
    },
    contactNoErrors: function contactNoErrors() {
      var errors = [];
      if (!this.$v.contactNo.$dirty) return errors;
      !this.$v.contactNo.required && errors.push('Contact number is required');
      return errors;
    }
  },
  watch: {
    menu: function menu(val) {
      var _this5 = this;

      val && this.$nextTick(function () {
        return _this5.$refs.picker.activePicker = 'YEAR';
      });
    }
  },
  notifications: {
    showSuccessMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.success },
    showErrorMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.error }
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Classroom_Post_vue__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Classroom_AddPost_vue__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Classroom_Students_vue__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Classroom_Files_vue__ = __webpack_require__(724);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Post: __WEBPACK_IMPORTED_MODULE_3__Classroom_Post_vue__["a" /* default */], AddPost: __WEBPACK_IMPORTED_MODULE_4__Classroom_AddPost_vue__["a" /* default */], StudentList: __WEBPACK_IMPORTED_MODULE_5__Classroom_Students_vue__["a" /* default */], FileList: __WEBPACK_IMPORTED_MODULE_6__Classroom_Files_vue__["a" /* default */]
  },
  data: function data() {
    return {
      items: ['Feed', 'Students', 'Files'],
      classInfo: '',
      students: []
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var info;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$store.dispatch('student/FETCH_POSTS', { class_id: _this.$route.params.id });
              _this.$store.dispatch('student/FETCH_FILES', { class_id: _this.$route.params.id });
              // this.$store.dispatch('student/FETCH_ASSIGNMENTS', {class_id: this.$route.params.id})
              _context.prev = 2;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/class/' + _this.$route.params.id, { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

            case 5:
              info = _context.sent;

              _this.classInfo = info.data;
              _this.students = info.data.studentclass;
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](2);

              console.log(_context.t0);

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 10]]);
    }))();
  },

  computed: {
    posts: function posts() {
      return this.$store.getters['student/GET_POSTS'];
    },
    files: function files() {
      return this.$store.getters['student/GET_FILES'];
    }
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PostComment_vue__ = __webpack_require__(716);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PostComment: __WEBPACK_IMPORTED_MODULE_3__PostComment_vue__["a" /* default */]
  },
  props: ['post'],
  data: function data() {
    return {
      commentStatus: false,
      commentText: '',
      editedText: '',
      loading: false,
      editDialog: false,
      deleteDialog: false,
      collapsed: true
    };
  },

  methods: {
    comment: function comment() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/post/comment', {
                  post_id: _this.post.post_id,
                  comment: _this.commentText
                }, { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

              case 4:
                response = _context.sent;

                _this.$store.dispatch('student/FETCH_POSTS', { class_id: _this.$route.params.id });
                _this.restart();
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                _this.loading = false;
                console.log(_context.t0);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    restart: function restart() {
      this.loading = false;
      this.commentStatus = false;
      this.commentText = '';
      this.editedText = '';
      this.editDialog = false;
    },
    editPost: function editPost(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.loading = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/post/update', {
                  post_id: id,
                  post_content: _this2.editedText
                }, { headers: { 'Authorization': 'Bearer ' + _this2.$store.getters.GET_TOKEN } });

              case 4:
                response = _context2.sent;

                _this2.$store.dispatch('student/FETCH_POSTS', { class_id: _this2.$route.params.id });
                _this2.restart();
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                _this2.loading = false;
                console.log(_context2.t0);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    deletePost: function deletePost(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this3.loading = true;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/post/delete', null, {
                  headers: {
                    'Authorization': 'Bearer ' + _this3.$store.getters.GET_TOKEN
                  },
                  params: {
                    ids: [id]
                  }
                });

              case 4:
                response = _context3.sent;

                _this3.$store.dispatch('student/FETCH_POSTS', { class_id: _this3.$route.params.id });
                _this3.restart();
                _context3.next = 13;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);

                _this3.loading = false;
                console.log(_context3.t0);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 9]]);
      }))();
    },
    openEditDialog: function openEditDialog() {
      this.editDialog = true;
      this.editedText = this.post.post_content;
    }
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['comment'],
  data: function data() {
    return {
      editDialog: false,
      editedText: '',
      loading: false
    };
  },

  methods: {
    openEditDialog: function openEditDialog() {
      this.editDialog = true;
      this.editedText = this.comment.comment;
    },
    editComment: function editComment(comment_id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/post/comment/update', {
                  comment_id: comment_id,
                  comment: _this.editedText
                }, { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

              case 4:
                response = _context.sent;

                _this.restart();
                _this.$store.dispatch('student/FETCH_POSTS', { class_id: _this.$route.params.id });
                _context.next = 14;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                _this.loading = false;
                _this.showErrorMsg({ title: _context.t0.response.statusText, message: _context.t0.response.data.error.join(' ') });
                console.log(_context.t0);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    restart: function restart() {
      this.loading = false;
      this.editedText = '';
      this.editDialog = false;
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      postStatus: false,
      text: '',
      loading: false
    };
  },

  methods: {
    postAnnouncement: function postAnnouncement() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/class/post', {
                  class_code: _this.$route.params.id,
                  post_content: _this.text
                }, { headers: { 'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN } });

              case 4:
                _this.$store.dispatch('student/FETCH_POSTS', { class_id: _this.$route.params.id });
                _this.restart();
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                _this.loading = false;
                console.log(_context.t0);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    restart: function restart() {
      this.loading = false;
      this.postStatus = false;
      this.text = '';
    }
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['student']
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__File_vue__ = __webpack_require__(726);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    File: __WEBPACK_IMPORTED_MODULE_4__File_vue__["a" /* default */]
  },
  props: ['files'],
  data: function data() {
    return {
      fab: false,
      bottom: true,
      right: true,
      transition: 'slide-y-reverse-transition',
      direction: 'top',
      file: null,
      fileTitle: '',
      fileDialog: false,
      loading: false
    };
  },
  created: function created() {},

  methods: {
    fileHandler: function fileHandler() {
      this.file = this.$refs.file.files[0];
      this.fileTitle = this.$refs.file.files[0].name;
      this.fileDialog = true;
    },
    uploadFile: function uploadFile() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                data = new FormData();

                data.append('file_name', _this.fileTitle);
                data.append('file', _this.file);
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/class/' + _this.$route.params.id + '/assignments/upload', data, {
                  headers: {
                    'Authorization': 'Bearer ' + _this.$store.getters.GET_TOKEN,
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 7:
                res = _context.sent;

                _this.showSuccessMsg({ title: 'Success!', message: 'Assignment uploaded successfully!' });
                _this.$store.dispatch('student/FETCH_FILES', { class_id: _this.$route.params.id });
                _this.file = null;
                _this.fileTitle = '';
                _this.loading = false;
                _this.fileDialog = false;
                _context.next = 21;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);
                _this.loading = false;
                _this.showErrorMsg({ title: _context.t0.response.statusText, message: _context.t0.response.data.error.join(' ') });

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 16]]);
      }))();
    }
  },
  notifications: {
    showSuccessMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.success },
    showErrorMsg: { type: __WEBPACK_IMPORTED_MODULE_2_vue_notifications___default.a.types.error }
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['file']
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_scrollto__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_progressbar__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_dist_vuetify_min_css__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_event_calendar_dist_style_css__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_event_calendar_dist_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_event_calendar_dist_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_event_calendar__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_event_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_event_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_notifications__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sweetalert__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












// axios.defaults.headers.common['Origin'] = 'http://localhost:8080';
__WEBPACK_IMPORTED_MODULE_9_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */].getters.GET_TOKEN;
// axios.defaults.baseURL = 'http://127.0.0.1:8000';
__WEBPACK_IMPORTED_MODULE_9_axios___default.a.defaults.baseURL = 'https://tesseract-ics.herokuapp.com';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuetify___default.a, {
  theme: {
    primary: "#43a047",
    secondary: "#FAFAFA",
    accent: "#FFC400",
    error: "#f44336",
    warning: "#ffeb3b",
    info: "#2196f3",
    success: "#4caf50"
  } });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_scrollto___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_progressbar___default.a, {
  color: '#ffdc3c',
  thickness: '2px'
});



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_event_calendar___default.a, {
  locale: 'en',
  color: '#43a047'
});




function toast(_ref) {
  var title = _ref.title,
      message = _ref.message,
      type = _ref.type,
      timeout = _ref.timeout,
      cb = _ref.cb;

  if (type === __WEBPACK_IMPORTED_MODULE_12_vue_notifications___default.a.types.warn) type = 'warning';
  return __WEBPACK_IMPORTED_MODULE_13_sweetalert___default()(title, message, type);
}

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_notifications___default.a, {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__, {
  load: {
    key: 'AIzaSyBm7Pwe3xwVfY_6Yp-ci1nj_xnd7T918M4',
    libraries: 'places' // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* router */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  template: '<App/>'
});

/***/ }),
/* 451 */,
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(97);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_201a7fa3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(512);
function injectStyle (ssrContext) {
  __webpack_require__(453)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-201a7fa3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_201a7fa3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"grey lighten-4"},[_c('vue-progress-bar'),_vm._v(" "),_c('v-navigation-drawer',{attrs:{"persistent":"","mini-variant":_vm.miniVariant,"enable-resize-watcher":"","fixed":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',[_c('v-tooltip',{attrs:{"lazy":"","right":""}},[_c('v-list-tile',{attrs:{"slot":"activator"},on:{"click":function($event){_vm.miniVariant = !_vm.miniVariant}},slot:"activator"},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.miniVariant ? 'chevron_right' : 'chevron_left'))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"collapse grey--text text--darken-1"},[_vm._v("Collapse")])],1)],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.miniVariant ? 'Expand' : 'Collapse'))])],1),_vm._v(" "),_vm._l((_vm.sideBarItems),function(item,i){return _c('v-tooltip',{key:i,attrs:{"right":"","lazy":""}},[_c('v-list-tile',{attrs:{"slot":"activator","value":"true","ripple":"","exact":"","to":item.link},slot:"activator"},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"grey--text text--darken-1",domProps:{"textContent":_vm._s(item.title)}})],1)],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title))])],1)})],2)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"green darken-1",attrs:{"app":"","dark":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"tag":"span","to":"/","flat":""}},[(!this.$store.getters.GET_TOKEN)?_c('v-avatar',[_c('img',{attrs:{"src":"https://res.cloudinary.com/tesseract-ics/image/upload/c_scale,w_64/site/logo","alt":"ICS Logo"}})]):_vm._e()],1),_vm._v(" "),(!this.$store.getters.GET_TOKEN)?_c('v-toolbar-title',{domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-title',{staticClass:"body-1"},[_c('div',[_vm._v(_vm._s(_vm.getUserDetails.name))]),_vm._v(" "),_c('div',{staticStyle:{"font-weight":"300"}},[_vm._v(_vm._s(_vm.getUserDetails.role))])])],1),_vm._v(" "),_c('v-content',[_c('v-slide-x-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('v-footer',{attrs:{"fixed":_vm.fixed,"app":""}},[_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear())+" Tesseract Tech Solutions")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(41);







/* harmony default export */ __webpack_exports__["a"] = ({
  SET_SIDEBAR: function SET_SIDEBAR(_ref, sidebarItems) {
    var commit = _ref.commit;

    commit('SET_SIDEBAR', sidebarItems);
  },
  REQUEST_TOKEN: function REQUEST_TOKEN(_ref2, credentials) {
    var _this = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res, _res$data$profile, given_name, middle_name, family_name, user_id, image, token, userRole, userObject, userDetails;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/api/auth/login', credentials);

            case 3:
              res = _context.sent;
              _res$data$profile = res.data.profile, given_name = _res$data$profile.given_name, middle_name = _res$data$profile.middle_name, family_name = _res$data$profile.family_name, user_id = _res$data$profile.user_id, image = _res$data$profile.image;
              token = res.data.token;
              _context.next = 8;
              return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/api/auth/me/role', { headers: { 'Authorization': 'Bearer ' + token } });

            case 8:
              userRole = _context.sent;
              userObject = { name: given_name + ' ' + family_name, user_id: user_id, image: image };
              userDetails = {};

              if (userRole.data.user_role === 0) {
                userDetails = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, userObject, { role: 'Administrator' });
              } else if (userRole.data.user_role === 1) {
                userDetails = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, userObject, { role: 'Instructor' });
              } else if (userRole.data.user_role === 2) {
                userDetails = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, userObject, { role: 'Student' });
              }

              commit('SET_TOKEN', token);
              commit('SET_USER_DETAILS', userDetails);

              // Return if admin, instructor or student
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(userRole.data.user_role));

            case 17:
              _context.prev = 17;
              _context.t0 = _context['catch'](0);

              commit('REMOVE_TOKEN');
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(_context.t0));

            case 21:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 17]]);
    }))();
  },
  LOGGED_OUT: function LOGGED_OUT(_ref3) {
    var _this2 = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // try{
              //   let logout = await axios.post('/api/auth/logout')
              //   console.log(logout)
              // commit('REMOVE_TOKEN')
              __WEBPACK_IMPORTED_MODULE_5__router__["a" /* router */].push('/');
              // }catch(e){

              // }

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  GET_SIDEBAR_ITEMS: function GET_SIDEBAR_ITEMS(state) {
    return state.sidebarItems;
  },
  GET_TOKEN: function GET_TOKEN(state) {
    return state.token;
  },
  GET_USER_DETAILS: function GET_USER_DETAILS(state) {
    return state.userDetails;
  }
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SET_SIDEBAR: function SET_SIDEBAR(state, payload) {
    state.sidebarItems = payload;
  },
  SET_TOKEN: function SET_TOKEN(state, payload) {
    state.token = payload;
  },
  REMOVE_TOKEN: function REMOVE_TOKEN(state, payload) {
    state.token = '';
  },
  SET_USER_DETAILS: function SET_USER_DETAILS(state, payload) {
    state.userDetails = payload;
  },
  REMOVE_USER_DETAILS: function REMOVE_USER_DETAILS(state, payload) {
    state.userDetails = {};
  },
  RESET_STORE: function RESET_STORE(state, payload) {
    state.token = '', state.userInfo = null, state.isLoggedIn = false, state.userDetails = {};
  }
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(523);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    calendarItems: [],
    newsItems: [],
    instructorsItem: [],
    studentsItem: [],
    classItems: [],
    posts: [],
    files: [],
    assignments: []
  },
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["a"] = ({
  CALENDAR_EVENTS: function CALENDAR_EVENTS(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var calendarEvents;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/calendar/0');

            case 3:
              calendarEvents = _context.sent;

              commit('SET_CALENDAR_EVENTS', calendarEvents.data);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

              console.log(_context.t0);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7]]);
    }))();
  },
  FETCH_NEWS: function FETCH_NEWS(_ref2) {
    var _this2 = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var newsData;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/news');

            case 3:
              newsData = _context2.sent;

              commit('SET_NEWS', newsData.data);
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2['catch'](0);

              console.log(_context2.t0);

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 7]]);
    }))();
  },
  FETCH_INSTRUCTORS: function FETCH_INSTRUCTORS(_ref3) {
    var _this3 = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var instructorsData;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/accounts', { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_4__index__["a" /* store */].getters.GET_TOKEN } });

            case 3:
              instructorsData = _context3.sent;

              commit('SET_INSTRUCTORS', instructorsData.data.faculty);
              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3['catch'](0);

              console.log(_context3.t0);

            case 10:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 7]]);
    }))();
  },
  FETCH_STUDENTS: function FETCH_STUDENTS(_ref4) {
    var _this4 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var studentsData;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/accounts', { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_4__index__["a" /* store */].getters.GET_TOKEN } });

            case 3:
              studentsData = _context4.sent;

              commit('SET_STUDENTS', studentsData.data.students);
              _context4.next = 10;
              break;

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4['catch'](0);

              console.log(_context4.t0);

            case 10:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 7]]);
    }))();
  },
  FETCH_CLASSES: function FETCH_CLASSES(_ref5) {
    var _this5 = this;

    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var classes;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/class', { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_4__index__["a" /* store */].getters.GET_TOKEN } });

            case 3:
              classes = _context5.sent;

              commit('SET_CLASS_DATA', classes.data);
              _context5.next = 10;
              break;

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5['catch'](0);

              console.log(_context5.t0);

            case 10:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 7]]);
    }))();
  },
  FETCH_POSTS: function FETCH_POSTS(_ref6, _ref7) {
    var _this6 = this;

    var commit = _ref6.commit;
    var class_id = _ref7.class_id;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var posts, postsData;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/posts', {
                headers: {
                  'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_4__index__["a" /* store */].getters.GET_TOKEN
                },
                params: {
                  class_id: class_id
                }
              });

            case 3:
              posts = _context6.sent;

              console.log(posts);
              postsData = posts.data.map(function (post) {
                post.created_at = __WEBPACK_IMPORTED_MODULE_3_moment___default()(post.created_at).fromNow();
                post.updated_at = __WEBPACK_IMPORTED_MODULE_3_moment___default()(post.updated_at).fromNow();
                post.comments.map(function (comment) {
                  comment.created_at = __WEBPACK_IMPORTED_MODULE_3_moment___default()(comment.created_at).fromNow();
                  comment.updated_at = __WEBPACK_IMPORTED_MODULE_3_moment___default()(comment.updated_at).fromNow();
                  return comment;
                });
                return post;
              });

              commit('SET_POSTS', posts.data);
              _context6.next = 12;
              break;

            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6['catch'](0);

              console.log(_context6.t0);

            case 12:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 9]]);
    }))();
  },
  FETCH_FILES: function FETCH_FILES(_ref8, _ref9) {
    var _this7 = this;

    var commit = _ref8.commit;
    var class_id = _ref9.class_id;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var files;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/class/files/' + class_id, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_4__index__["a" /* store */].getters.GET_TOKEN } });

            case 3:
              files = _context7.sent;

              // console.log(files)
              commit('SET_FILES', files.data);
              _context7.next = 10;
              break;

            case 7:
              _context7.prev = 7;
              _context7.t0 = _context7['catch'](0);

              console.log(_context7.t0);

            case 10:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[0, 7]]);
    }))();
  },
  FETCH_ASSIGNMENTS: function FETCH_ASSIGNMENTS(_ref10, _ref11) {
    var _this8 = this;

    var commit = _ref10.commit;
    var class_id = _ref11.class_id;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var files;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/class/files/assignments/' + class_id, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_4__index__["a" /* store */].getters.GET_TOKEN } });

            case 3:
              files = _context8.sent;

              // console.log(files)
              commit('SET_ASSIGNMENTS', files.data);
              _context8.next = 10;
              break;

            case 7:
              _context8.prev = 7;
              _context8.t0 = _context8['catch'](0);

              console.log(_context8.t0);

            case 10:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[0, 7]]);
    }))();
  }
});

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 120,
	"./af.js": 120,
	"./ar": 121,
	"./ar-dz": 122,
	"./ar-dz.js": 122,
	"./ar-kw": 123,
	"./ar-kw.js": 123,
	"./ar-ly": 124,
	"./ar-ly.js": 124,
	"./ar-ma": 125,
	"./ar-ma.js": 125,
	"./ar-sa": 126,
	"./ar-sa.js": 126,
	"./ar-tn": 127,
	"./ar-tn.js": 127,
	"./ar.js": 121,
	"./az": 128,
	"./az.js": 128,
	"./be": 129,
	"./be.js": 129,
	"./bg": 130,
	"./bg.js": 130,
	"./bm": 131,
	"./bm.js": 131,
	"./bn": 132,
	"./bn.js": 132,
	"./bo": 133,
	"./bo.js": 133,
	"./br": 134,
	"./br.js": 134,
	"./bs": 135,
	"./bs.js": 135,
	"./ca": 136,
	"./ca.js": 136,
	"./cs": 137,
	"./cs.js": 137,
	"./cv": 138,
	"./cv.js": 138,
	"./cy": 139,
	"./cy.js": 139,
	"./da": 140,
	"./da.js": 140,
	"./de": 141,
	"./de-at": 142,
	"./de-at.js": 142,
	"./de-ch": 143,
	"./de-ch.js": 143,
	"./de.js": 141,
	"./dv": 144,
	"./dv.js": 144,
	"./el": 145,
	"./el.js": 145,
	"./en-au": 146,
	"./en-au.js": 146,
	"./en-ca": 147,
	"./en-ca.js": 147,
	"./en-gb": 148,
	"./en-gb.js": 148,
	"./en-ie": 149,
	"./en-ie.js": 149,
	"./en-nz": 150,
	"./en-nz.js": 150,
	"./eo": 151,
	"./eo.js": 151,
	"./es": 152,
	"./es-do": 153,
	"./es-do.js": 153,
	"./es-us": 154,
	"./es-us.js": 154,
	"./es.js": 152,
	"./et": 155,
	"./et.js": 155,
	"./eu": 156,
	"./eu.js": 156,
	"./fa": 157,
	"./fa.js": 157,
	"./fi": 158,
	"./fi.js": 158,
	"./fo": 159,
	"./fo.js": 159,
	"./fr": 160,
	"./fr-ca": 161,
	"./fr-ca.js": 161,
	"./fr-ch": 162,
	"./fr-ch.js": 162,
	"./fr.js": 160,
	"./fy": 163,
	"./fy.js": 163,
	"./gd": 164,
	"./gd.js": 164,
	"./gl": 165,
	"./gl.js": 165,
	"./gom-latn": 166,
	"./gom-latn.js": 166,
	"./gu": 167,
	"./gu.js": 167,
	"./he": 168,
	"./he.js": 168,
	"./hi": 169,
	"./hi.js": 169,
	"./hr": 170,
	"./hr.js": 170,
	"./hu": 171,
	"./hu.js": 171,
	"./hy-am": 172,
	"./hy-am.js": 172,
	"./id": 173,
	"./id.js": 173,
	"./is": 174,
	"./is.js": 174,
	"./it": 175,
	"./it.js": 175,
	"./ja": 176,
	"./ja.js": 176,
	"./jv": 177,
	"./jv.js": 177,
	"./ka": 178,
	"./ka.js": 178,
	"./kk": 179,
	"./kk.js": 179,
	"./km": 180,
	"./km.js": 180,
	"./kn": 181,
	"./kn.js": 181,
	"./ko": 182,
	"./ko.js": 182,
	"./ky": 183,
	"./ky.js": 183,
	"./lb": 184,
	"./lb.js": 184,
	"./lo": 185,
	"./lo.js": 185,
	"./lt": 186,
	"./lt.js": 186,
	"./lv": 187,
	"./lv.js": 187,
	"./me": 188,
	"./me.js": 188,
	"./mi": 189,
	"./mi.js": 189,
	"./mk": 190,
	"./mk.js": 190,
	"./ml": 191,
	"./ml.js": 191,
	"./mr": 192,
	"./mr.js": 192,
	"./ms": 193,
	"./ms-my": 194,
	"./ms-my.js": 194,
	"./ms.js": 193,
	"./mt": 195,
	"./mt.js": 195,
	"./my": 196,
	"./my.js": 196,
	"./nb": 197,
	"./nb.js": 197,
	"./ne": 198,
	"./ne.js": 198,
	"./nl": 199,
	"./nl-be": 200,
	"./nl-be.js": 200,
	"./nl.js": 199,
	"./nn": 201,
	"./nn.js": 201,
	"./pa-in": 202,
	"./pa-in.js": 202,
	"./pl": 203,
	"./pl.js": 203,
	"./pt": 204,
	"./pt-br": 205,
	"./pt-br.js": 205,
	"./pt.js": 204,
	"./ro": 206,
	"./ro.js": 206,
	"./ru": 207,
	"./ru.js": 207,
	"./sd": 208,
	"./sd.js": 208,
	"./se": 209,
	"./se.js": 209,
	"./si": 210,
	"./si.js": 210,
	"./sk": 211,
	"./sk.js": 211,
	"./sl": 212,
	"./sl.js": 212,
	"./sq": 213,
	"./sq.js": 213,
	"./sr": 214,
	"./sr-cyrl": 215,
	"./sr-cyrl.js": 215,
	"./sr.js": 214,
	"./ss": 216,
	"./ss.js": 216,
	"./sv": 217,
	"./sv.js": 217,
	"./sw": 218,
	"./sw.js": 218,
	"./ta": 219,
	"./ta.js": 219,
	"./te": 220,
	"./te.js": 220,
	"./tet": 221,
	"./tet.js": 221,
	"./th": 222,
	"./th.js": 222,
	"./tl-ph": 223,
	"./tl-ph.js": 223,
	"./tlh": 224,
	"./tlh.js": 224,
	"./tr": 225,
	"./tr.js": 225,
	"./tzl": 226,
	"./tzl.js": 226,
	"./tzm": 227,
	"./tzm-latn": 228,
	"./tzm-latn.js": 228,
	"./tzm.js": 227,
	"./uk": 229,
	"./uk.js": 229,
	"./ur": 230,
	"./ur.js": 230,
	"./uz": 231,
	"./uz-latn": 232,
	"./uz-latn.js": 232,
	"./uz.js": 231,
	"./vi": 233,
	"./vi.js": 233,
	"./x-pseudo": 234,
	"./x-pseudo.js": 234,
	"./yo": 235,
	"./yo.js": 235,
	"./zh-cn": 236,
	"./zh-cn.js": 236,
	"./zh-hk": 237,
	"./zh-hk.js": 237,
	"./zh-tw": 238,
	"./zh-tw.js": 238
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 521;

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SET_CALENDAR_EVENTS: function SET_CALENDAR_EVENTS(state, payload) {
    state.calendarItems = payload;
  },
  SET_NEWS: function SET_NEWS(state, payload) {
    state.newsItems = payload;
  },
  SET_INSTRUCTORS: function SET_INSTRUCTORS(state, payload) {
    state.instructorsItem = payload;
  },
  SET_STUDENTS: function SET_STUDENTS(state, payload) {
    state.studentsItem = payload;
  },
  SET_CLASS_DATA: function SET_CLASS_DATA(state, payload) {
    state.classItems = payload;
  },
  SET_POSTS: function SET_POSTS(state, payload) {
    state.posts = payload;
  },
  SET_FILES: function SET_FILES(state, payload) {
    state.files = payload;
  },
  SET_ASSIGNMENTS: function SET_ASSIGNMENTS(state, payload) {
    state.assignments = payload;
  }
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  GET_CALENDAR_EVENTS: function GET_CALENDAR_EVENTS(state) {
    return state.calendarItems;
  },
  GET_NEWS: function GET_NEWS(state) {
    return state.newsItems;
  },
  GET_INSTRUCTORS: function GET_INSTRUCTORS(state) {
    return state.instructorsItem;
  },
  GET_STUDENTS: function GET_STUDENTS(state) {
    return state.studentsItem;
  },
  GET_CLASSES: function GET_CLASSES(state) {
    return state.classItems;
  },
  GET_POSTS: function GET_POSTS(state) {
    return state.posts;
  },
  GET_FILES: function GET_FILES(state) {
    return state.files;
  },
  GET_ASSIGNMENTS: function GET_ASSIGNMENTS(state) {
    return state.assignments;
  }
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(527);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    classItems: [],
    posts: [],
    files: [],
    assignments: []
  },
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);






/* harmony default export */ __webpack_exports__["a"] = ({
  FETCH_CLASSES: function FETCH_CLASSES(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var classes;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/class', { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_3__index__["a" /* store */].getters.GET_TOKEN } });

            case 3:
              classes = _context.sent;

              commit('SET_CLASS_DATA', classes.data);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

              console.log(_context.t0);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7]]);
    }))();
  },
  FETCH_POSTS: function FETCH_POSTS(_ref2, _ref3) {
    var _this2 = this;

    var commit = _ref2.commit;
    var class_id = _ref3.class_id;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var posts, postsData;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/posts', {
                headers: {
                  'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_3__index__["a" /* store */].getters.GET_TOKEN
                },
                params: {
                  class_id: class_id
                }
              });

            case 3:
              posts = _context2.sent;
              postsData = posts.data.map(function (post) {
                post.created_at = __WEBPACK_IMPORTED_MODULE_4_moment___default()(post.created_at).fromNow();
                post.updated_at = __WEBPACK_IMPORTED_MODULE_4_moment___default()(post.updated_at).fromNow();
                post.comments.map(function (comment) {
                  comment.created_at = __WEBPACK_IMPORTED_MODULE_4_moment___default()(comment.created_at).fromNow();
                  comment.updated_at = __WEBPACK_IMPORTED_MODULE_4_moment___default()(comment.updated_at).fromNow();
                  return comment;
                });
                return post;
              });

              commit('SET_POSTS', posts.data);
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2['catch'](0);

              console.log(_context2.t0);

            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  },
  FETCH_FILES: function FETCH_FILES(_ref4, _ref5) {
    var _this3 = this;

    var commit = _ref4.commit;
    var class_id = _ref5.class_id;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var files;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/class/files/' + class_id, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_3__index__["a" /* store */].getters.GET_TOKEN } });

            case 3:
              files = _context3.sent;

              // console.log(files)
              commit('SET_FILES', files.data);
              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3['catch'](0);

              console.log(_context3.t0);

            case 10:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 7]]);
    }))();
  },
  FETCH_ASSIGNMENTS: function FETCH_ASSIGNMENTS(_ref6, _ref7) {
    var _this4 = this;

    var commit = _ref6.commit;
    var class_id = _ref7.class_id;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var files;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/class/files/assignments/' + class_id, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_3__index__["a" /* store */].getters.GET_TOKEN } });

            case 3:
              files = _context4.sent;

              // console.log(files)
              commit('SET_ASSIGNMENTS', files.data);
              _context4.next = 10;
              break;

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4['catch'](0);

              console.log(_context4.t0);

            case 10:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 7]]);
    }))();
  }
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SET_CLASS_DATA: function SET_CLASS_DATA(state, payload) {
    state.classItems = payload;
  },
  SET_POSTS: function SET_POSTS(state, payload) {
    state.posts = payload;
  },
  SET_FILES: function SET_FILES(state, payload) {
    state.files = payload;
  },
  SET_ASSIGNMENTS: function SET_ASSIGNMENTS(state, payload) {
    state.assignments = payload;
  }
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  GET_CLASSES: function GET_CLASSES(state) {
    return state.classItems;
  },
  GET_POSTS: function GET_POSTS(state) {
    return state.posts;
  },
  GET_FILES: function GET_FILES(state) {
    return state.files;
  },
  GET_ASSIGNMENTS: function GET_ASSIGNMENTS(state) {
    return state.assignments;
  }
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(531);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    classItems: [],
    posts: [],
    files: []
  },
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);






/* harmony default export */ __webpack_exports__["a"] = ({
  FETCH_CLASSES: function FETCH_CLASSES(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var classes;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/classes', { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_3__index__["a" /* store */].getters.GET_TOKEN } });

            case 3:
              classes = _context.sent;

              commit('SET_CLASS_DATA', classes.data);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

              console.log(_context.t0);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7]]);
    }))();
  },
  FETCH_POSTS: function FETCH_POSTS(_ref2, _ref3) {
    var _this2 = this;

    var commit = _ref2.commit;
    var class_id = _ref3.class_id;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var posts, postsData;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/posts', {
                headers: {
                  'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_3__index__["a" /* store */].getters.GET_TOKEN
                },
                params: {
                  class_id: class_id
                }
              });

            case 3:
              posts = _context2.sent;
              postsData = posts.data.map(function (post) {
                post.created_at = __WEBPACK_IMPORTED_MODULE_4_moment___default()(post.created_at).fromNow();
                post.updated_at = __WEBPACK_IMPORTED_MODULE_4_moment___default()(post.updated_at).fromNow();
                post.comments.map(function (comment) {
                  comment.created_at = __WEBPACK_IMPORTED_MODULE_4_moment___default()(comment.created_at).fromNow();
                  comment.updated_at = __WEBPACK_IMPORTED_MODULE_4_moment___default()(comment.updated_at).fromNow();
                  return comment;
                });
                return post;
              });

              commit('SET_POSTS', postsData);
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2['catch'](0);

              console.log(_context2.t0);

            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  },
  FETCH_FILES: function FETCH_FILES(_ref4, _ref5) {
    var _this3 = this;

    var commit = _ref4.commit;
    var class_id = _ref5.class_id;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var files;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/class/files/' + class_id, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_3__index__["a" /* store */].getters.GET_TOKEN } });

            case 3:
              files = _context3.sent;

              commit('SET_FILES', files.data);
              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3['catch'](0);

              console.log(_context3.t0);

            case 10:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 7]]);
    }))();
  },
  FETCH_ASSIGNMENTS: function FETCH_ASSIGNMENTS(_ref6, _ref7) {
    var _this4 = this;

    var commit = _ref6.commit;
    var class_id = _ref7.class_id;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var files;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/class/files/assignments/' + class_id, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_3__index__["a" /* store */].getters.GET_TOKEN } });

            case 3:
              files = _context4.sent;

              console.log(files);
              // commit('SET_FILES', files.data)
              _context4.next = 10;
              break;

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4['catch'](0);

              console.log(_context4.t0);

            case 10:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 7]]);
    }))();
  }
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SET_CLASS_DATA: function SET_CLASS_DATA(state, payload) {
    state.classItems = payload;
  },
  SET_POSTS: function SET_POSTS(state, payload) {
    state.posts = payload;
  },
  SET_FILES: function SET_FILES(state, payload) {
    state.files = payload;
  }
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  GET_CLASSES: function GET_CLASSES(state) {
    return state.classItems;
  },
  GET_POSTS: function GET_POSTS(state) {
    return state.posts;
  },
  GET_FILES: function GET_FILES(state) {
    return state.files;
  }
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e7cb876_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(534);
function injectStyle (ssrContext) {
  __webpack_require__(533)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e7cb876"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e7cb876_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"}],attrs:{"column":""}},[_c('section',[_c('v-carousel',{attrs:{"lazy":""}},_vm._l((_vm.bannerImg),function(item,i){return _c('v-carousel-item',{key:i,attrs:{"src":i !== 0 ? item.src : 'https://res.cloudinary.com/tesseract-ics/image/upload/c_scale,w_1024/site/1'}},[(i === 0)?_c('v-layout',{staticClass:"white--text",attrs:{"column":"","align-center":"","justify-center":""}},[_c('h1',{staticClass:"white--text mb-2 display-1 text-xs-center"},[_vm._v("Institute of Computer Studies")]),_vm._v(" "),_c('div',{staticClass:"subheading mb-3 text-xs-center"},[_vm._v("The technological institute of Western Mindanao State University")]),_vm._v(" "),_c('v-btn',{staticClass:"green darken",attrs:{"dark":"","large":"","round":"","to":"/about"}},[_vm._v("Know us more")])],1):_c('v-layout',{staticClass:"white--text",attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"border-box text-xs-center"},[_c('h1',{staticClass:"white--text mb-2 display-1 text-xs-center"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"subheading mb-3 text-xs-center"},[_vm._v(_vm._s(item.content.substr(0,100) + '...'))]),_vm._v(" "),_c('v-btn',{staticClass:"green darken",attrs:{"to":'/news/' + item.newsId,"dark":""}},[_vm._v("Read more")])],1)])],1)}))],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{staticClass:"my-5",attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","md6":""}},[_c('router-link',{attrs:{"to":"/director"}},[_c('img',{attrs:{"src":"http://res.cloudinary.com/tesseract-ics/image/upload/c_scale,w_500/site/director-corner.png","alt":""}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('div',{staticClass:"headline text-xs-center"},[_vm._v("Calendar of Activities")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/calendar"}},[(_vm.events.length !== 0)?_c('v-list',{staticClass:"grey lighten-2",staticStyle:{"max-height":"300px","overflow-y":"scroll"},attrs:{"two-line":""}},[_vm._l((_vm.events),function(item,index){return [_c('v-list-tile',{key:index,attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.start_date)+" - "+_vm._s(item.end_date))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.description))])],1)],1),_vm._v(" "),_c('v-divider',{key:'0' + index})]})],2):_vm._e()],1),_vm._v(" "),(_vm.events.length === 0)?_c('h1',{staticClass:"subheading text-xs-center"},[_vm._v("No events for this month")]):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-parallax',{staticClass:"banner-img",attrs:{"src":"https://res.cloudinary.com/tesseract-ics/image/upload/c_scale,w_1024/site/2","height":"300"}},[_c('v-layout',{staticClass:"white--text",attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline text-xs-center"},[_vm._v("Take part of this stronghold institution.")])])],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{staticClass:"my-5",attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"sm12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("About the Institute")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n              Institute of Computer Studies is a stronghold Institute in Western Mindanao State University, offering quality education in the field of computer science and technology. Be proud and take part of this remarkable Institute.\n            ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Contact us")])]),_vm._v(" "),_c('v-list',{staticClass:"transparent"},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"green--text"},[_vm._v("phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("777-867-5309")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"green--text"},[_vm._v("place")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Normal Road, Baliwasan, Zamboanga City, Philippines")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"green--text"},[_vm._v("email")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("ics@wmsu.edu.ph")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Find us!")])]),_vm._v(" "),_c('v-card-text',[_c('gmap-map',{staticStyle:{"height":"300px"},attrs:{"center":{ lat: 6.913909, lng: 122.061529 },"zoom":17,"draggable":false}},[_c('gmap-marker',{attrs:{"position":{ lat: 6.913909, lng: 122.061529 }}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-fab-transition',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.floatingButton),expression:"floatingButton"},{name:"scroll-to",rawName:"v-scroll-to",value:('body'),expression:"'body'"}],attrs:{"color":"yellow darken-2","dark":"","fixed":"","bottom":"","right":"","fab":""}},[_c('v-icon',[_vm._v("keyboard_arrow_up")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9a9ff96_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(552);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9a9ff96_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisionMission_vue__ = __webpack_require__(241);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f62f420_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VisionMission_vue__ = __webpack_require__(537);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisionMission_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f62f420_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VisionMission_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('h1',{staticClass:"headline"},[_vm._v("Mission")]),_vm._v(" "),(!_vm.loaded)?_c('vcl-code',{staticClass:"mt-2"}):_c('p',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.mission))])],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('h1',{staticClass:"headline"},[_vm._v("Vision")]),_vm._v(" "),(!_vm.loaded)?_c('vcl-code',{staticClass:"mt-2"}):_c('p',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.vision))])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QualityPolicy_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b217d434_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QualityPolicy_vue__ = __webpack_require__(539);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QualityPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b217d434_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QualityPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-text',[_c('p',{staticClass:"subheading"},[_vm._v("The Western Mindanao State University is committed to provide internationally recognized quality education and to be the lead provider of quality human resource and research and development in the country and the ASEAN region in compliance to international, national and local statutory and regulatory requirements. "),_c('br'),_c('br'),_vm._v(" The University commits itself to ensure that its internal and external clientele receive the highest quality service that exceeds their requirements. In so doing, the management shall continually monitor, review and improve the university’s systems and processes by maintaining a comprehensive and effective quality management system with reference to the standard and requirements of ISO 9001:2015.")])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrgList_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_480fa473_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrgList_vue__ = __webpack_require__(541);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrgList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_480fa473_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrgList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.orgCharts),function(orgChart){return _c('v-flex',{key:orgChart.org_chart_id,attrs:{"xs12":"","md6":""}},[_c('v-card',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card-media',{attrs:{"src":orgChart.profile.image,"height":"200px","contain":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"text-xs-center"},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(((orgChart.profile.given_name) + " " + (orgChart.profile.middle_name) + ". " + (orgChart.profile.family_name) + " " + (orgChart.profile.ext_name ? orgChart.profile.ext_name : ''))))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(orgChart.position))])])])],1)],1)],1)],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Academics_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a9d48ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Academics_vue__ = __webpack_require__(543);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Academics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a9d48ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Academics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n            Bachelor of Science in Computer Science (BSCS) Program Objectives\n          ")])]),_vm._v(" "),_c('v-card-text',[_c('div',[_c('p',[_c('strong',[_vm._v("The BSCS program will equip learners with:")])]),_vm._v(" "),_c('p',[_vm._v("● Computer science theories and methodologies and new technologies in the design and development of computing solutions with appropriate consideration to public health and safety, culture, society, gender and environment.")]),_vm._v(" "),_c('p',[_vm._v("● Personal development and lifelong learning attitudes through research and advance studies, and recognize the professional, legal, security, and ethical issues relevant to computing career practice.")]),_vm._v(" "),_c('p',[_vm._v("● Communication and collaborative skills in diverse teams and multidisciplinary settings.")])])]),_vm._v(" "),_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n            Bachelor of Science in Computer Science (BSCS) Program Outcomes\n          ")])]),_vm._v(" "),_c('v-card-text',[_c('div',[_c('p',[_vm._v("● Utilize effectively the concepts of computer science theories and methodologies and adapt new technologies and ideas in formulating effective solutions to address public health and safety, cultural, societal, gender and environmental considerations. ")]),_vm._v(" "),_c('p',[_vm._v("● Work cohesively with members of a team using their individual skills to the successful completion of a project.")]),_vm._v(" "),_c('p',[_vm._v("● Pursue personal development and lifelong learning through research, graduate studies, training and membership to professional organization to be globally competitive.")]),_vm._v(" "),_c('p',[_vm._v("● Communicate effectively with the computing community and society through oral and written correspondence.")])])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n            Bachelor of Science in Information Technology (BSIT) Program Objectives\n          ")])]),_vm._v(" "),_c('v-card-text',[_c('div',[_c('p',[_c('strong',[_vm._v("In pursuit of its goals, the Department shall endeavor to achieve the following specific objectives:")])]),_vm._v(" "),_c('p',[_vm._v("● To provide students to endure with a life-long learning and improve performance as a foundation for continuing professional development. ")]),_vm._v(" "),_c('p',[_vm._v("● To involve and encourage students to produce researchers relevant with institutional, regional, national and globally priorities that will be able to address the needs of the community they serve.")]),_vm._v(" "),_c('p',[_vm._v("● To provide a new technologies or programs that is being used globally.")]),_vm._v(" "),_c('p',[_vm._v("● To provide avenue for graduates’ employability through IT industry linkages.")])])]),_vm._v(" "),_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n            Bachelor of Science in Information Technology (BSIT) Program Outcomes\n          ")])]),_vm._v(" "),_c('v-card-text',[_c('div',[_c('p',[_vm._v("● Utilize effectively the acquisition of concepts and technologies preparing and methodologies concepts in modeling, designing, and electronic solutions to problems of varying complexities. ")]),_vm._v(" "),_c('p',[_vm._v("● Formulates an effective solution to solve information technology-related problems through proper research and understanding of problem.")]),_vm._v(" "),_c('p',[_vm._v("● Adapts new technologies and ideas in the design, analysis and implementation of system and its components.")]),_vm._v(" "),_c('p',[_vm._v("● Demonstrates the ability to work cohesively with members of a team using their individual skills to the successful completion of a project.")]),_vm._v(" "),_c('p',[_vm._v("● Manages the available human and technical resources effectively and efficiently.")]),_vm._v(" "),_c('p',[_vm._v("● Recognizes the societal needs and its professional, legal, security, and ethical issues relevant to IT practice.")]),_vm._v(" "),_c('p',[_vm._v("● Produces IT related researches relevant with institutional, regional, and national priorities.")]),_vm._v(" "),_c('p',[_vm._v("● Produces IT related researches that are relevant responsive to the needs and concerns of the communities they serve.")]),_vm._v(" "),_c('p',[_vm._v("● Pursues personal development and lifelong learning through research, training and membership to professional organization to be globally competitive.")])])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Goals_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91260ace_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Goals_vue__ = __webpack_require__(545);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Goals_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91260ace_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Goals_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-text',[_c('p',{staticClass:"subheading"},[_c('strong',[_vm._v("The institute shall provide academic excellence in the field of Information and Communication Technology, with emphasis on the following goals:")])]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("● Produce quality, excellent and environmentally pro-active graduates imbued with gender responsiveness. ")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("● Achieve highest level of accreditation and center of excellence imbued with outcomes-based education. ")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("● Partner with national and international industries as an outlet for research development and extension. ")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("● Support faculty members through faculty development programs to be competitive with the highest global standards. ")])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoreValues_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30a51ffe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoreValues_vue__ = __webpack_require__(547);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoreValues_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30a51ffe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoreValues_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-text',[_c('p',{staticClass:"subheading"},[_c('strong',[_vm._v("CREATIVITY:")]),_vm._v(" the value of turning ideas into innovative and socially-responsive solutions")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_c('strong',[_vm._v("SELF-RELIANCE:")]),_vm._v(" the ability to have confidence in and exercise one’s own judgment.")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_c('strong',[_vm._v("INTEGRITY:")]),_vm._v(" the value of having commitment, honesty, competence, transparency and responsibility.")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_c('strong',[_vm._v("TEAMWORK:")]),_vm._v(" the ability to support others and place the team over individual importance.")])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e89f24d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__ = __webpack_require__(549);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e89f24d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-text',[_c('p',{staticClass:"subheading"},[_vm._v("The ICS is the Institute in Western Mindanao State University. It  started on a ladderized program in the year 1994, offering: 2 years Associate Computer Technology, 3 years diploma in Computer Technology, 4 years Bachelor of Computer Science, 5 years Bachelor of Computer Engineering under the College of Engineering and Technology. In the year 2000, the ladderized program was removed. The Computer Engineer and Computer Science was separated, at the same time Computer Science has a major, Information Technology and Software Technology. It was revised in the year 2006 but nothing was change, 2016 last year the curriculum was change and the major was removed, BSCS and BSIT at the same time the ICS become an Institute and it was headed by MIT Roderick P. Go.")])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Seal_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a1de0be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Seal_vue__ = __webpack_require__(551);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Seal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a1de0be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Seal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('img',{attrs:{"src":"https://res.cloudinary.com/tesseract-ics/image/upload/c_scale,w_200/site/logo","alt":"ICS Logo"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md10":"","offset-md1":""}},[_c('p',{staticClass:"subheading"},[_vm._v("The shape of the logo is circle, it has a major circle in the middle w/ binary numbers as the backdrop on top of it,there are 6 circles inside with figures showing the different areas of technology. The dominant color in the logo is green which denotes the color of the institute. Green signifies the advancement of the institute in the field of computer science. In the center of the logo there’s a power button image that signifies the power of the institute.")])])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"scrollable":false}},[_c('v-tabs-bar',{staticClass:"green darken-1",attrs:{"dark":""}},[_c('v-tabs-slider',{staticClass:"yellow"}),_vm._v(" "),_vm._l((_vm.items),function(i){return _c('v-tabs-item',{key:i,attrs:{"href":'#' + i}},[_vm._v("\n      "+_vm._s(i)+"\n    ")])})],2),_vm._v(" "),_c('v-tabs-items',[_c('v-tabs-content',{attrs:{"id":"Mission/Vision"}},[_c('vision-mission')],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"Quality Policy"}},[_c('quality-policy')],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"Organizational List"}},[_c('org-list')],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"Academics"}},[_c('academics')],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"Goals"}},[_c('goals')],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"Core Values"}},[_c('core-values')],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"History"}},[_c('history')],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"ICS Seal"}},[_c('seal')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53e06bfa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__ = __webpack_require__(554);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53e06bfa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('vue-event-calendar',{attrs:{"title":'Calendar of Activities',"events":_vm.demoEvents}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Director_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_066b4971_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Director_vue__ = __webpack_require__(556);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Director_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_066b4971_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Director_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('p',{staticClass:"headline"},[_vm._v("Director's Corner")]),_vm._v(" "),_c('v-flex',[_c('p',{staticClass:"subheading"},[_vm._v("• Master in Information Technology(MIT) - Mindanao University of Science and Technology (MUST), Cagayan de Oro City, Philippines, April 3, 2013.")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("• Bachelor of Science in Computer Science – STI Zamboanga – June, 2005.")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("• Professional Course in Education – Western Mindanao State University, Zamboanga City, Philippines")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("• Master in Public Administration -Western Mindanao State University, Philippines, March, 1997.")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("• Bachelor of Science in Commerce, Accounting – Zamboanga A.E. Colleges, Philippines.")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("• Doctor of Philosophy-Technology Management Program (PhD-TM), on dissertation writing, Zamboanga City State Polytechnic College, Philippines.")])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsArticle_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14c947ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsArticle_vue__ = __webpack_require__(559);
function injectStyle (ssrContext) {
  __webpack_require__(558)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14c947ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsArticle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14c947ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsArticle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.image_url)?_c('v-carousel',{staticClass:"image-height",attrs:{"hide-controls":"","hide-delimiters":"","lazy":""}},[_c('v-carousel-item',{attrs:{"src":_vm.image_url}})],1):_vm._e(),_vm._v(" "),_c('v-container',[(!_vm.loaded)?_c('vcl-list'):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"display-1 green--text"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.loaded)?_c('p',{staticClass:"body-1 grey--text mb-3"},[_vm._v(_vm._s(_vm.dateFormat)+" ● "+_vm._s(_vm.fromNow))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.content))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__(252);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_319ec295_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__(561);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_319ec295_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-lg":""}},[_c('div',[_c('span',[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("whatshot")])],1),_vm._v(" "),_c('span',{staticClass:"headline green--text",staticStyle:{"font-weight":"700"}},[_vm._v("Latest News")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.news),function(item,i){return _c('v-flex',{key:i,attrs:{"xs12":"","md8":""}},[(item.image_url)?_c('div',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('img',{attrs:{"src":item.image_url,"height":"150px"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(item.news_title))]),_vm._v(" "),_c('div',[_vm._v("\n                  "+_vm._s(item.news_content.substr(0,150) + '...')+"\n                  "),_c('router-link',{attrs:{"to":'/news/' + item.news_id}},[_vm._v("See More")])],1)])])],1)],1)],1):_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(item.news_title))]),_vm._v(" "),_c('div',[_vm._v("\n          "+_vm._s(item.news_content.substr(0,150) + '...')+"\n          "),_c('router-link',{attrs:{"to":'/news/' + item.news_id}},[_vm._v("See More")])],1)]),_vm._v(" "),_c('v-divider',{staticClass:"mt-2"})],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9824db82_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__(584);
function injectStyle (ssrContext) {
  __webpack_require__(563)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9824db82_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-card',{staticClass:"elevation-2"},[_c('v-toolbar',{attrs:{"color":"white"}},[_c('v-toolbar-title',[_vm._v("Signup for an account")])],1),_vm._v(" "),_c('v-card-text',[_c('small',{staticClass:"red--text"},[_vm._v("NOTE: Our admin will verify if you are a bona fide student or instructor of this institute.")]),_vm._v(" "),_c('v-form',[_c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Username","required":"","error-messages":_vm.userNameErrors},on:{"input":function($event){_vm.$v.username.$touch()},"blur":function($event){_vm.$v.username.$touch()}},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Password","type":"password","required":"","error-messages":_vm.passwordErrors},on:{"input":function($event){_vm.$v.password.$touch()},"blur":function($event){_vm.$v.password.$touch()}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Given Name","required":"","error-messages":_vm.givenNameErrors},on:{"input":function($event){_vm.$v.givenName.$touch()},"blur":function($event){_vm.$v.givenName.$touch()}},model:{value:(_vm.givenName),callback:function ($$v) {_vm.givenName=$$v},expression:"givenName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Family Name","required":"","error-messages":_vm.familyNameErrors},on:{"input":function($event){_vm.$v.familyName.$touch()},"blur":function($event){_vm.$v.familyName.$touch()}},model:{value:(_vm.familyName),callback:function ($$v) {_vm.familyName=$$v},expression:"familyName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Middle Name"},model:{value:(_vm.middleName),callback:function ($$v) {_vm.middleName=$$v},expression:"middleName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md1":""}},[_c('v-text-field',{attrs:{"label":"Ext."},model:{value:(_vm.extName),callback:function ($$v) {_vm.extName=$$v},expression:"extName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('v-menu',{ref:"menu",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"min-width":"290px"},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Birthdate","prepend-icon":"event","readonly":"","required":"","error-messages":_vm.dateErrors},on:{"input":function($event){_vm.$v.date.$touch()},"blur":function($event){_vm.$v.date.$touch()}},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{ref:"picker",attrs:{"allowed-dates":_vm.allowedDates},on:{"change":_vm.save},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Address","multi-line":"","rows":"2"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p',{staticClass:"subheading"},[_vm._v("Gender:")]),_vm._v(" "),_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.gender),callback:function ($$v) {_vm.gender=$$v},expression:"gender"}},[_c('v-radio',{attrs:{"label":"Male","value":true}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Female","value":false}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Contact Number","mask":"###########","error-messages":_vm.contactNoErrors,"required":""},on:{"input":function($event){_vm.$v.contactNo.$touch()},"blur":function($event){_vm.$v.contactNo.$touch()}},model:{value:(_vm.contactNo),callback:function ($$v) {_vm.contactNo=$$v},expression:"contactNo"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"mb-2",attrs:{"block":"","round":"","color":"green darken-1","dark":""},on:{"click":_vm.signUp}},[_vm._v("Sign up")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_688af594_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(587);
function injectStyle (ssrContext) {
  __webpack_require__(586)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_688af594_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{staticClass:"mt-5"},[_c('v-flex',{staticClass:"mt-2",attrs:{"sm6":"","offset-sm3":"","md4":"","offset-md4":""}},[_c('div',{staticClass:"text-xs-center"},[_c('img',{staticClass:"logo-img",attrs:{"src":"https://res.cloudinary.com/tesseract-ics/image/upload/c_scale,w_200/site/logo","alt":"ICS Logo"}})]),_vm._v(" "),_c('form',[_c('v-text-field',{attrs:{"label":"Username","color":"blue","error-messages":_vm.usernameErrors,"required":""},on:{"input":function($event){_vm.$v.username.$touch()},"blur":function($event){_vm.$v.username.$touch()},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.logIn($event)}},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Password","type":"password","color":"blue","error-messages":_vm.passwordErrors,"required":""},on:{"input":function($event){_vm.$v.password.$touch()},"blur":function($event){_vm.$v.password.$touch()},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.logIn($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-btn',{attrs:{"round":"","block":"","color":"success"},on:{"click":_vm.logIn,"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.logIn($event)}}},[_vm._v("Log in")])],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_413230db_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(643);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_413230db_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StudentGender_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StudentGender_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 262,
	"./af.js": 262,
	"./ar": 263,
	"./ar-dz": 264,
	"./ar-dz.js": 264,
	"./ar-kw": 265,
	"./ar-kw.js": 265,
	"./ar-ly": 266,
	"./ar-ly.js": 266,
	"./ar-ma": 267,
	"./ar-ma.js": 267,
	"./ar-sa": 268,
	"./ar-sa.js": 268,
	"./ar-tn": 269,
	"./ar-tn.js": 269,
	"./ar.js": 263,
	"./az": 270,
	"./az.js": 270,
	"./be": 271,
	"./be.js": 271,
	"./bg": 272,
	"./bg.js": 272,
	"./bn": 273,
	"./bn.js": 273,
	"./bo": 274,
	"./bo.js": 274,
	"./br": 275,
	"./br.js": 275,
	"./bs": 276,
	"./bs.js": 276,
	"./ca": 277,
	"./ca.js": 277,
	"./cs": 278,
	"./cs.js": 278,
	"./cv": 279,
	"./cv.js": 279,
	"./cy": 280,
	"./cy.js": 280,
	"./da": 281,
	"./da.js": 281,
	"./de": 282,
	"./de-at": 283,
	"./de-at.js": 283,
	"./de-ch": 284,
	"./de-ch.js": 284,
	"./de.js": 282,
	"./dv": 285,
	"./dv.js": 285,
	"./el": 286,
	"./el.js": 286,
	"./en-au": 287,
	"./en-au.js": 287,
	"./en-ca": 288,
	"./en-ca.js": 288,
	"./en-gb": 289,
	"./en-gb.js": 289,
	"./en-ie": 290,
	"./en-ie.js": 290,
	"./en-nz": 291,
	"./en-nz.js": 291,
	"./eo": 292,
	"./eo.js": 292,
	"./es": 293,
	"./es-do": 294,
	"./es-do.js": 294,
	"./es.js": 293,
	"./et": 295,
	"./et.js": 295,
	"./eu": 296,
	"./eu.js": 296,
	"./fa": 297,
	"./fa.js": 297,
	"./fi": 298,
	"./fi.js": 298,
	"./fo": 299,
	"./fo.js": 299,
	"./fr": 300,
	"./fr-ca": 301,
	"./fr-ca.js": 301,
	"./fr-ch": 302,
	"./fr-ch.js": 302,
	"./fr.js": 300,
	"./fy": 303,
	"./fy.js": 303,
	"./gd": 304,
	"./gd.js": 304,
	"./gl": 305,
	"./gl.js": 305,
	"./gom-latn": 306,
	"./gom-latn.js": 306,
	"./he": 307,
	"./he.js": 307,
	"./hi": 308,
	"./hi.js": 308,
	"./hr": 309,
	"./hr.js": 309,
	"./hu": 310,
	"./hu.js": 310,
	"./hy-am": 311,
	"./hy-am.js": 311,
	"./id": 312,
	"./id.js": 312,
	"./is": 313,
	"./is.js": 313,
	"./it": 314,
	"./it.js": 314,
	"./ja": 315,
	"./ja.js": 315,
	"./jv": 316,
	"./jv.js": 316,
	"./ka": 317,
	"./ka.js": 317,
	"./kk": 318,
	"./kk.js": 318,
	"./km": 319,
	"./km.js": 319,
	"./kn": 320,
	"./kn.js": 320,
	"./ko": 321,
	"./ko.js": 321,
	"./ky": 322,
	"./ky.js": 322,
	"./lb": 323,
	"./lb.js": 323,
	"./lo": 324,
	"./lo.js": 324,
	"./lt": 325,
	"./lt.js": 325,
	"./lv": 326,
	"./lv.js": 326,
	"./me": 327,
	"./me.js": 327,
	"./mi": 328,
	"./mi.js": 328,
	"./mk": 329,
	"./mk.js": 329,
	"./ml": 330,
	"./ml.js": 330,
	"./mr": 331,
	"./mr.js": 331,
	"./ms": 332,
	"./ms-my": 333,
	"./ms-my.js": 333,
	"./ms.js": 332,
	"./my": 334,
	"./my.js": 334,
	"./nb": 335,
	"./nb.js": 335,
	"./ne": 336,
	"./ne.js": 336,
	"./nl": 337,
	"./nl-be": 338,
	"./nl-be.js": 338,
	"./nl.js": 337,
	"./nn": 339,
	"./nn.js": 339,
	"./pa-in": 340,
	"./pa-in.js": 340,
	"./pl": 341,
	"./pl.js": 341,
	"./pt": 342,
	"./pt-br": 343,
	"./pt-br.js": 343,
	"./pt.js": 342,
	"./ro": 344,
	"./ro.js": 344,
	"./ru": 345,
	"./ru.js": 345,
	"./sd": 346,
	"./sd.js": 346,
	"./se": 347,
	"./se.js": 347,
	"./si": 348,
	"./si.js": 348,
	"./sk": 349,
	"./sk.js": 349,
	"./sl": 350,
	"./sl.js": 350,
	"./sq": 351,
	"./sq.js": 351,
	"./sr": 352,
	"./sr-cyrl": 353,
	"./sr-cyrl.js": 353,
	"./sr.js": 352,
	"./ss": 354,
	"./ss.js": 354,
	"./sv": 355,
	"./sv.js": 355,
	"./sw": 356,
	"./sw.js": 356,
	"./ta": 357,
	"./ta.js": 357,
	"./te": 358,
	"./te.js": 358,
	"./tet": 359,
	"./tet.js": 359,
	"./th": 360,
	"./th.js": 360,
	"./tl-ph": 361,
	"./tl-ph.js": 361,
	"./tlh": 362,
	"./tlh.js": 362,
	"./tr": 363,
	"./tr.js": 363,
	"./tzl": 364,
	"./tzl.js": 364,
	"./tzm": 365,
	"./tzm-latn": 366,
	"./tzm-latn.js": 366,
	"./tzm.js": 365,
	"./uk": 367,
	"./uk.js": 367,
	"./ur": 368,
	"./ur.js": 368,
	"./uz": 369,
	"./uz-latn": 370,
	"./uz-latn.js": 370,
	"./uz.js": 369,
	"./vi": 371,
	"./vi.js": 371,
	"./x-pseudo": 372,
	"./x-pseudo.js": 372,
	"./yo": 373,
	"./yo.js": 373,
	"./zh-cn": 374,
	"./zh-cn.js": 374,
	"./zh-hk": 375,
	"./zh-hk.js": 375,
	"./zh-tw": 376,
	"./zh-tw.js": 376
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 622;

/***/ }),
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstructorGender_vue__ = __webpack_require__(377);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstructorGender_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotVerified_vue__ = __webpack_require__(378);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ab405f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotVerified_vue__ = __webpack_require__(642);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotVerified_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ab405f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotVerified_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('v-badge',{attrs:{"right":"","color":"red"}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.items.length))]),_vm._v(" "),_c('h1',{staticClass:"headline"},[_vm._v("To be verified")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-3 mt-2",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"item-key":"user_id"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.family_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.given_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.middle_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.ext_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.username))]),_vm._v(" "),_c('td',[_c('v-tooltip',{attrs:{"left":"","lazy":"","color":"blue"}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"blue"},on:{"click":function($event){_vm.openDialog(props.item)}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1),_vm._v(" "),_c('span',[_vm._v("Verify user")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":"","color":"red"}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"red"},on:{"click":function($event){_vm.deleteAccount(props.item.user_id)}},slot:"activator"},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Delete request")])],1)],1)]}}])}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"300"},model:{value:(_vm.roleDialog),callback:function ($$v) {_vm.roleDialog=$$v},expression:"roleDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Verify User")]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Kindly pick a role for this user.")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.role),callback:function ($$v) {_vm.role=$$v},expression:"role"}},[_c('v-radio',{attrs:{"label":"Student","value":true}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Instructor","value":false}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.roleDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"blue darken-1","loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){_vm.verifyAccount()}}},[_vm._v("\n            Verify\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('div',{staticClass:"mt-4"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/admin/students"}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"blue"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{staticClass:"text-xs-center"},[_c('v-flex',{attrs:{"xs6":"","justify-center":"","align-content-center":""}},[_c('v-icon',{staticStyle:{"font-size":"72px"}},[_vm._v("group")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('div',[_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.noOfStudents))]),_vm._v(" "),_c('div',{staticClass:"headline",staticStyle:{"font-weight":"300"}},[_vm._v("Students")])])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/admin/instructors"}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"green"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{staticClass:"text-xs-center"},[_c('v-flex',{attrs:{"xs6":"","justify-center":"","align-content-center":""}},[_c('v-icon',{staticStyle:{"font-size":"72px"}},[_vm._v("people_outline")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('div',[_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.noOfInstructors))]),_vm._v(" "),_c('div',{staticClass:"headline",staticStyle:{"font-weight":"300"}},[_vm._v("Instructors")])])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"red lighten-1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{staticClass:"text-xs-center"},[_c('v-flex',{attrs:{"xs6":"","justify-center":"","align-content-center":""}},[_c('v-icon',{staticStyle:{"font-size":"72px"}},[_vm._v("school")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('div',[_c('div',{staticClass:"display-1"},[_vm._v("'18-'19")]),_vm._v(" "),_c('div',{staticClass:"headline",staticStyle:{"font-weight":"300"}},[_vm._v("School Year")])])])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_c('not-verified',{staticClass:"mt-2"})],1),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_c('h1',{staticClass:"headline"},[_vm._v("Gender Distribution")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-card',{staticClass:"elevation-3"},[_c('student-gender')],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-card',{staticClass:"elevation-3"},[_c('instructor-gender')],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Classrooms_vue__ = __webpack_require__(379);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19678843_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Classrooms_vue__ = __webpack_require__(648);
function injectStyle (ssrContext) {
  __webpack_require__(645)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Classrooms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19678843_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Classrooms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(380);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60c8eb1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(647);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60c8eb1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.profile)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"lazy":"","right":""}},[_c('label',{staticStyle:{"cursor":"pointer"},attrs:{"slot":"activator","for":"image-upload-admin"},slot:"activator"},[_c('v-avatar',{attrs:{"size":"100px"}},[_c('img',{attrs:{"src":_vm.profile.image,"alt":_vm.profile.family_name}})])],1),_vm._v(" "),_c('input',{ref:"image",attrs:{"hidden":"","type":"file","id":"image-upload-admin","accept":".jpeg, .jpg, .png"},on:{"change":function($event){_vm.imageDialog = true}}}),_vm._v(" "),_c('span',[_vm._v("Change picture")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"lazy":"","bottom":""}},[_c('v-badge',{staticStyle:{"cursor":"pointer"},attrs:{"slot":"activator"},nativeOn:{"click":function($event){_vm.profileDialog = true}},slot:"activator"},[_c('v-icon',{attrs:{"slot":"badge","dark":"","small":""},slot:"badge"},[_vm._v("edit")]),_vm._v(" "),_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.profile.given_name)+" "+_vm._s(_vm.profile.family_name))])],1),_vm._v(" "),_c('span',[_vm._v("Edit Profile")])],1)],1),_vm._v(" "),_c('v-flex',[_c('small',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.passwordDialog = true}}},[_vm._v("Change Password")])]),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.profileDialog),callback:function ($$v) {_vm.profileDialog=$$v},expression:"profileDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Edit Profile")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Given Name","required":"","error-messages":_vm.givenNameErrors},on:{"input":function($event){_vm.$v.givenName.$touch()},"blur":function($event){_vm.$v.givenName.$touch()}},model:{value:(_vm.givenName),callback:function ($$v) {_vm.givenName=$$v},expression:"givenName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Family Name","required":"","error-messages":_vm.familyNameErrors},on:{"input":function($event){_vm.$v.familyName.$touch()},"blur":function($event){_vm.$v.familyName.$touch()}},model:{value:(_vm.familyName),callback:function ($$v) {_vm.familyName=$$v},expression:"familyName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Middle Name"},model:{value:(_vm.middleName),callback:function ($$v) {_vm.middleName=$$v},expression:"middleName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md1":""}},[_c('v-text-field',{attrs:{"label":"Ext."},model:{value:(_vm.extName),callback:function ($$v) {_vm.extName=$$v},expression:"extName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('v-menu',{ref:"menu",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"min-width":"290px"},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Birthdate","prepend-icon":"event","readonly":"","required":"","error-messages":_vm.dateErrors},on:{"input":function($event){_vm.$v.date.$touch()},"blur":function($event){_vm.$v.date.$touch()}},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{ref:"picker",attrs:{"allowed-dates":_vm.allowedDates},on:{"change":_vm.save},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Address","multi-line":"","rows":"2"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p',{staticClass:"subheading"},[_vm._v("Gender:")]),_vm._v(" "),_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.gender),callback:function ($$v) {_vm.gender=$$v},expression:"gender"}},[_c('v-radio',{attrs:{"label":"Male","value":true}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Female","value":false}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Contact Number","mask":"###########","error-messages":_vm.contactNoErrors,"required":""},on:{"input":function($event){_vm.$v.contactNo.$touch()},"blur":function($event){_vm.$v.contactNo.$touch()}},model:{value:(_vm.contactNo),callback:function ($$v) {_vm.contactNo=$$v},expression:"contactNo"}})],1)],1),_vm._v(" "),_c('small',[_vm._v("*indicates required field")])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},on:{"click":function($event){_vm.profileDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.editProfileDetails}},[_vm._v("Edit")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.passwordDialog),callback:function ($$v) {_vm.passwordDialog=$$v},expression:"passwordDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Change Password")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Enter new password","type":"password","required":""},model:{value:(_vm.password1),callback:function ($$v) {_vm.password1=$$v},expression:"password1"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Re-Enter password","type":"password","required":""},model:{value:(_vm.password2),callback:function ($$v) {_vm.password2=$$v},expression:"password2"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},on:{"click":function($event){_vm.passwordDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.changePassword}},[_vm._v("Change")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"300"},model:{value:(_vm.imageDialog),callback:function ($$v) {_vm.imageDialog=$$v},expression:"imageDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Changing Image")]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Are you sure?")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.imageDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"blue darken-1","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.changeProfileImage}},[_vm._v("\n            Save\n          ")])],1)],1)],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('profile'),_vm._v(" "),_c('h1',{staticClass:"headline"},[_vm._v("My Classes")]),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":""}},_vm._l((_vm.classrooms),function(classroom,i){return _c('v-flex',{key:classroom.classroom_id,attrs:{"md3":""}},[_c('v-card',[_c('v-card-media',{attrs:{"src":'https://picsum.photos/1000/700?image='+i,"height":"100px"}},[_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":"","lazy":""}},[_c('v-menu',{attrs:{"slot":"activator","offset-x":""},slot:"activator"},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"white"},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.setEventAction(false, classroom.classroom_id)}}},[_c('v-list-tile-title',[_vm._v("Edit")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.configDelete(classroom.classroom_id)}}},[_c('v-list-tile-title',[_vm._v("Delete")])],1)],1)],1),_vm._v(" "),_c('span',[_vm._v("More actions")])],1)],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('router-link',{staticClass:"underline",staticStyle:{"cursor":"pointer"},attrs:{"to":'/admin/classroom/' + classroom.classroom_id}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(classroom.classroom_name))])]),_vm._v(" "),_c('div',{staticClass:"grey--text"},[_vm._v("Subject: "+_vm._s(classroom.subject))]),_vm._v(" "),_c('div',{staticClass:"grey--text"},[_vm._v("Section: "+_vm._s(classroom.section))]),_vm._v(" "),_c('div',{staticClass:"grey--text"},[_vm._v("Class Code: "+_vm._s(classroom.classroom_id))])],1)])],1)],1)})),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.classDialog),callback:function ($$v) {_vm.classDialog=$$v},expression:"classDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.checkIfAdd ? 'Add' : 'Edit')+" a class")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Name","required":"","error-messages":_vm.classroomNameErrors},on:{"input":function($event){_vm.$v.classroomName.$touch()},"blur":function($event){_vm.$v.classroomName.$touch()}},model:{value:(_vm.classroomName),callback:function ($$v) {_vm.classroomName=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"classroomName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Subject","required":"","error-messages":_vm.subjectErrors},on:{"input":function($event){_vm.$v.subject.$touch()},"blur":function($event){_vm.$v.subject.$touch()}},model:{value:(_vm.subject),callback:function ($$v) {_vm.subject=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"subject"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Section","required":"","error-messages":_vm.sectionErrors},on:{"input":function($event){_vm.$v.section.$touch()},"blur":function($event){_vm.$v.section.$touch()}},model:{value:(_vm.section),callback:function ($$v) {_vm.section=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"section"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},nativeOn:{"click":function($event){_vm.clearFormField($event)}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.checkIfAdd)?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.addClass($event)}}},[_vm._v("Add")]):_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.editClass($event)}}},[_vm._v("Edit")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.deleteModal),callback:function ($$v) {_vm.deleteModal=$$v},expression:"deleteModal"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Warning!")]),_vm._v(" "),_c('v-card-text',[_vm._v("You are about to delete this classroom. Are you sure?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},nativeOn:{"click":function($event){_vm.deleteModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){_vm.deleteClass($event)}}},[_vm._v("Delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[_c('v-speed-dial',{attrs:{"slot":"activator","bottom":_vm.bottom,"right":_vm.right,"direction":_vm.direction,"transition":_vm.transition,"fixed":""},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","color":"red darken-1","dark":"","hover":""},on:{"click":function($event){_vm.setEventAction(true)}},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('span',[_vm._v("Add a classroom")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Classroom_vue__ = __webpack_require__(381);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54e3e637_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Classroom_vue__ = __webpack_require__(668);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Classroom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54e3e637_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Classroom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Post_vue__ = __webpack_require__(382);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ddf997c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Post_vue__ = __webpack_require__(654);
function injectStyle (ssrContext) {
  __webpack_require__(651)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ddf997c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Post_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ddf997c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Post_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostComment_vue__ = __webpack_require__(383);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2230e84c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostComment_vue__ = __webpack_require__(653);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostComment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2230e84c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostComment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-text',{staticClass:"grey lighten-4"},[_c('v-layout',{attrs:{"row":""}},[_c('div',[_c('v-avatar',{attrs:{"size":"42px"}},[_c('img',{staticClass:"mr-3",attrs:{"src":_vm.comment.author.image}})])],1),_vm._v(" "),_c('div',{staticClass:"caption"},[_c('v-layout',{attrs:{"column":""}},[_c('div',[_c('span',{staticStyle:{"font-weight":"700"}},[_vm._v("\n              "+_vm._s(_vm.comment.author.given_name)+" "+_vm._s(_vm.comment.author.family_name)+" "+_vm._s(_vm.comment.author.ext_name)+"\n            ")]),_vm._v(" "),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.comment.edited ? _vm.comment.updated_at : _vm.comment.created_at)+" "+_vm._s(_vm.comment.edited ? '(edited)' : ''))])]),_vm._v(" "),_c('div',{},[_c('span',[_vm._v(_vm._s(_vm.comment.comment))])])])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',[_c('v-menu',{attrs:{"offset-y":"","lazy":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"grey darken-2"},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),(this.$store.getters.GET_USER_DETAILS.user_id === _vm.comment.author.user_id)?_c('v-list',[_c('v-list-tile',{on:{"click":_vm.openEditDialog}},[_c('v-list-tile-title',[_vm._v("Edit")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.deleteDialog = true}}},[_c('v-list-tile-title',[_vm._v("Delete")])],1)],1):_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.deleteDialog = true}}},[_c('v-list-tile-title',[_vm._v("Delete")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"700px"},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-card',[_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Edit your post...","multi-line":"","rows":"1","autofocus":""},model:{value:(_vm.editedText),callback:function ($$v) {_vm.editedText=$$v},expression:"editedText"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.editDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"elevation-0",attrs:{"dark":"","color":"green","loading":_vm.loading},on:{"click":function($event){_vm.editComment(_vm.comment.comment_id)}}},[_vm._v("Edit")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"300px"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"subheading"},[_vm._v("Are you sure you want to delete this comment?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"elevation-0",attrs:{"dark":"","color":"red","loading":_vm.loading},on:{"click":function($event){_vm.deleteComment(_vm.comment.comment_id)}}},[_vm._v("Delete")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":"","offset-md3":""}},[_c('v-card',[_c('v-card-title',[_c('v-layout',{attrs:{"row":""}},[_c('div',[_c('span',[_c('v-avatar',{attrs:{"size":"42px"}},[_c('img',{staticClass:"mr-3",attrs:{"src":_vm.post.author.image}})])],1)]),_vm._v(" "),_c('div',[_c('v-layout',{attrs:{"column":""}},[_c('div',[_vm._v(_vm._s(_vm.post.author.given_name)+" "+_vm._s(_vm.post.author.family_name)+" "+_vm._s(_vm.post.author.ext_name))]),_vm._v(" "),_c('div',{staticClass:"grey--text caption"},[_vm._v(_vm._s(_vm.post.edited ? _vm.post.updated_at : _vm.post.created_at)+" "+_vm._s(_vm.post.edited ? '(edited)' : ''))])])],1)]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":"","lazy":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"grey darken-2"},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),(this.$store.getters.GET_USER_DETAILS.user_id === _vm.post.author.user_id)?_c('v-list',[_c('v-list-tile',{on:{"click":_vm.openEditDialog}},[_c('v-list-tile-title',[_vm._v("Edit")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.deleteDialog = true}}},[_c('v-list-tile-title',[_vm._v("Delete")])],1)],1):_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.deleteDialog = true}}},[_c('v-list-tile-title',[_vm._v("Delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('span',[_vm._v(_vm._s(_vm.post.post_content))])]),_vm._v(" "),(_vm.post.comments.length !== 0)?_c('v-card-text',{staticClass:"grey lighten-4"},[(_vm.post.comments.length > 1)?_c('div',[(_vm.collapsed !== false)?_c('p',{staticClass:"caption comment-caption",on:{"click":function($event){_vm.collapsed = false}}},[_vm._v("View "+_vm._s(_vm.post.comments.length)+" comments..")]):_c('p',{staticClass:"caption comment-caption",on:{"click":function($event){_vm.collapsed = true}}},[_vm._v("Collapse comments..")])]):_vm._e(),_vm._v(" "),_vm._l((!_vm.collapsed ? _vm.post.comments : [_vm.post.comments[_vm.post.comments.length - 1]]),function(comment,i){return _c('post-comment',{key:i,attrs:{"comment":comment}})})],2):_vm._e(),_vm._v(" "),_c('v-card-text',{staticClass:"grey lighten-3 "},[(!_vm.commentStatus)?_c('span',{staticClass:"caption comment-caption",on:{"click":function($event){_vm.commentStatus = true}}},[_vm._v("Write a comment...")]):_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-text-field',{attrs:{"label":"Your comment...","autofocus":""},model:{value:(_vm.commentText),callback:function ($$v) {_vm.commentText=$$v},expression:"commentText"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{attrs:{"flat":"","color":"red","disabled":_vm.loading},on:{"click":function($event){_vm.commentStatus = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"green","loading":_vm.loading},on:{"click":_vm.comment}},[_vm._v("Comment")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"700px"},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-card',[_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Edit your post...","multi-line":"","rows":"1","autofocus":""},model:{value:(_vm.editedText),callback:function ($$v) {_vm.editedText=$$v},expression:"editedText"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.editDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"elevation-0",attrs:{"dark":"","color":"green","loading":_vm.loading},on:{"click":function($event){_vm.editPost(_vm.post.post_id)}}},[_vm._v("Edit")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"300px"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete this post?")]),_vm._v(" "),_c('v-card-text',[_vm._v("Comments will also be deleted.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"elevation-0",attrs:{"dark":"","color":"red","loading":_vm.loading},on:{"click":function($event){_vm.deletePost(_vm.post.post_id)}}},[_vm._v("Delete")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPost_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f4c473c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPost_vue__ = __webpack_require__(657);
function injectStyle (ssrContext) {
  __webpack_require__(656)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f4c473c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f4c473c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":"","offset-md3":""}},[_c('v-card',[_c('v-card-text',[(!_vm.postStatus)?_c('p',{staticClass:"post-caption",on:{"click":function($event){_vm.postStatus = true}}},[_vm._v("Add an announcement...")]):_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"autofocus":"","label":"Your announcement..."},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},on:{"click":function($event){_vm.postStatus = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"green"},on:{"click":_vm.postAnnouncement}},[_vm._v("Post")])],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Students_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9880489c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Students_vue__ = __webpack_require__(659);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Students_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9880489c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Students_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-card',[_c('v-card-text',[_c('v-tooltip',{attrs:{"left":"","lazy":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":function($event){_vm.deleteDialog = true}},slot:"activator"},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('span',[_vm._v("Remove student")])],1),_vm._v(" "),_c('span',[_c('v-avatar',{attrs:{"size":"42px"}},[_c('img',{staticClass:"mr-3",attrs:{"src":_vm.student.profile.image}})])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.student.profile.given_name)+" "+_vm._s(_vm.student.profile.family_name)+" "+_vm._s(_vm.student.profile.ext_name))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"300"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Removing "+_vm._s(_vm.student.profile.given_name)+" "+_vm._s(_vm.student.profile.family_name)+" "+_vm._s(_vm.student.profile.ext_name))]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Are you sure you want to remove this student?")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"red","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.removeStudent}},[_vm._v("\n            Remove\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Files_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72ce209b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Files_vue__ = __webpack_require__(663);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Files_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72ce209b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Files_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_File_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e3a5eb6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_File_vue__ = __webpack_require__(662);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_File_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e3a5eb6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_File_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-card',[_c('v-card-text',[_c('v-btn',{attrs:{"icon":"","tag":"a","href":("http://tesseract-ics.herokuapp.com/api/class/" + (this.$route.params.id) + "/download?file_location=" + _vm.file + "&token=" + (this.$store.getters.GET_TOKEN)),"download":""}},[_c('v-icon',{attrs:{"color":"blue"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.deleteDialog = true}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.file))]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"300"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Deleting file")]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Are you sure you want to delete this file?")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"red","loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){_vm.deleteFile(_vm.file)}}},[_vm._v("\n            Delete\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":"","offset-md3":""}},_vm._l((_vm.files),function(file,i){return _c('file',{key:i,attrs:{"file":file}})}))],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"300"},model:{value:(_vm.fileDialog),callback:function ($$v) {_vm.fileDialog=$$v},expression:"fileDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.fileTitle))]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Upload this file? ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.fileDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"blue darken-1","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.uploadFile}},[_vm._v("\n            Upload\n            "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[_c('v-btn',{staticStyle:{"cursor":"pointer"},attrs:{"slot":"activator","fixed":"","bottom":"","right":"","fab":"","color":"red darken-1","dark":"","tag":"label","for":"file-upload-admin"},slot:"activator"},[_c('v-icon',[_vm._v("attach_file")])],1),_vm._v(" "),_c('input',{ref:"file",attrs:{"hidden":"","type":"file","id":"file-upload-admin"},on:{"change":_vm.fileHandler}}),_vm._v(" "),_c('span',[_vm._v("Upload file")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Assignments_vue__ = __webpack_require__(388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e69aeb40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Assignments_vue__ = __webpack_require__(667);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Assignments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e69aeb40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Assignments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Assignment_vue__ = __webpack_require__(389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_262c0852_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Assignment_vue__ = __webpack_require__(666);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Assignment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_262c0852_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Assignment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-card',[_c('v-card-text',[_c('v-btn',{attrs:{"icon":"","tag":"a","href":("http://tesseract-ics.herokuapp.com/api/class/" + (this.$route.params.id) + "/assignment/download?file_location=" + _vm.assignment + "&token=" + (this.$store.getters.GET_TOKEN)),"download":""}},[_c('v-icon',{attrs:{"color":"blue"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.deleteDialog = true}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.assignment))]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"300"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Deleting file")]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Are you sure you want to delete this file?")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"red","loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){_vm.deleteFile(_vm.file)}}},[_vm._v("\n          Delete\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":"","offset-md3":""}},_vm._l((_vm.assignments),function(assignment,i){return _c('assignment',{key:i,attrs:{"assignment":assignment}})}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.classInfo)?_c('v-tabs',{attrs:{"fixed":"","centered":""}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":"","justify-center":"","align-center":"","column":""}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.classInfo.subject + ' -')+" "+_vm._s(_vm.classInfo.classroom_name))]),_vm._v(" "),_c('div',{staticClass:"subheading text-xs-center"},[_vm._v(_vm._s(_vm.classInfo.section))]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('v-avatar',{attrs:{"size":"42px"}},[_c('img',{staticClass:"mr-3",attrs:{"src":_vm.classInfo.instructor.image,"alt":_vm.classInfo.instructor.family_name}})]),_vm._v(" "),_c('span',{staticClass:"px-0"},[_vm._v(_vm._s(_vm.classInfo.instructor.given_name)+" "+_vm._s(_vm.classInfo.instructor.family_name))])],1)])],1),_vm._v(" "),_c('v-tabs-bar',{staticClass:"green darken-2",attrs:{"dark":""}},[_c('v-tabs-slider',{staticClass:"yellow"}),_vm._v(" "),_vm._l((_vm.items),function(i){return _c('v-tabs-item',{key:i,attrs:{"href":'#' + i}},[_vm._v("\n      "+_vm._s(i)+"\n    ")])})],2),_vm._v(" "),_c('v-tabs-items',[_c('v-tabs-content',{attrs:{"id":"Feed"}},[_c('add-post'),_vm._v(" "),_vm._l((_vm.posts),function(postData){return _c('post',{key:postData.post_id,attrs:{"post":postData}})})],2),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"Students"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":"","offset-md3":""}},_vm._l((_vm.students),function(student){return _c('student-list',{key:student.student_id,attrs:{"student":student,"fetchStudents":_vm.fetchStudents}})}))],1)],1)],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"Files"}},[_c('file-list',{attrs:{"files":_vm.files}})],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"Assignments"}},[_c('assignment-list',{attrs:{"assignments":_vm.assignments}})],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Instructor_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aeab212_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Instructor_vue__ = __webpack_require__(671);
function injectStyle (ssrContext) {
  __webpack_require__(670)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Instructor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aeab212_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Instructor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-title',[_c('h1',{staticClass:"headline"},[_vm._v("List of Instructors")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-3 mt-2",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"loading":_vm.items.length == 0,"select-all":"","item-key":"user_id"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-checkbox',{attrs:{"primary":"","hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.family_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.given_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.middle_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.ext_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.birthday))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.address))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.contact_number))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('v-progress-linear',{attrs:{"slot":"progress","indeterminate":""},slot:"progress"}),_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("\n        Nothing to display here :(\n      ")])],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.instructorDialog),callback:function ($$v) {_vm.instructorDialog=$$v},expression:"instructorDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(this.checkIfAdd ? 'Add' : 'Edit')+" an Instructor")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[(_vm.checkIfAdd)?_c('v-text-field',{attrs:{"label":"Username","required":""},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[(_vm.checkIfAdd)?_c('v-text-field',{attrs:{"label":"Password","type":"password","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Given Name","required":"","error-messages":_vm.givenNameErrors},on:{"input":function($event){_vm.$v.givenName.$touch()},"blur":function($event){_vm.$v.givenName.$touch()}},model:{value:(_vm.givenName),callback:function ($$v) {_vm.givenName=$$v},expression:"givenName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Family Name","required":"","error-messages":_vm.familyNameErrors},on:{"input":function($event){_vm.$v.familyName.$touch()},"blur":function($event){_vm.$v.familyName.$touch()}},model:{value:(_vm.familyName),callback:function ($$v) {_vm.familyName=$$v},expression:"familyName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Middle Name"},model:{value:(_vm.middleName),callback:function ($$v) {_vm.middleName=$$v},expression:"middleName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md1":""}},[_c('v-text-field',{attrs:{"label":"Ext."},model:{value:(_vm.extName),callback:function ($$v) {_vm.extName=$$v},expression:"extName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('v-menu',{ref:"menu",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"min-width":"290px"},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Birthdate","prepend-icon":"event","readonly":"","required":"","error-messages":_vm.dateErrors},on:{"input":function($event){_vm.$v.date.$touch()},"blur":function($event){_vm.$v.date.$touch()}},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{ref:"picker",attrs:{"allowed-dates":_vm.allowedDates},on:{"change":_vm.save},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Address","multi-line":"","rows":"2"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p',{staticClass:"subheading"},[_vm._v("Gender:")]),_vm._v(" "),_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.gender),callback:function ($$v) {_vm.gender=$$v},expression:"gender"}},[_c('v-radio',{attrs:{"label":"Male","value":true}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Female","value":false}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Contact Number","mask":"###########","error-messages":_vm.contactNoErrors,"required":""},on:{"input":function($event){_vm.$v.contactNo.$touch()},"blur":function($event){_vm.$v.contactNo.$touch()}},model:{value:(_vm.contactNo),callback:function ($$v) {_vm.contactNo=$$v},expression:"contactNo"}})],1)],1),_vm._v(" "),_c('small',[_vm._v("*indicates required field")])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},nativeOn:{"click":function($event){_vm.clearFormField($event)}}},[_vm._v("Close")]),_vm._v(" "),(_vm.checkIfAdd)?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.addInstructor}},[_vm._v("Save")]):_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.editInstructor}},[_vm._v("Edit")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.deleteModal),callback:function ($$v) {_vm.deleteModal=$$v},expression:"deleteModal"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Warning!")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          You are about to delete "+_vm._s(this.selected.length)+" instructor"+_vm._s(this.selected.length > 0 ? 's' : '')+". Are you sure?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},nativeOn:{"click":function($event){_vm.deleteModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){_vm.deleteInstructors($event)}}},[_vm._v("Delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-speed-dial',{attrs:{"bottom":true,"right":true,"transition":'slide-y-reverse-transition',"direction":'top',"fixed":"","hover":true},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","color":"red darken-1","dark":"","hover":""},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("more_vert")]),_vm._v(" "),_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","dark":"","color":"green"},on:{"click":function($event){_vm.setInstructorsAction(true)}},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('span',[_vm._v("Add")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[(_vm.editSelected)?_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","dark":"","color":"amber"},on:{"click":function($event){_vm.setInstructorsAction(false)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Edit")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[(_vm.deleteSelected)?_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","dark":"","color":"red"},on:{"click":function($event){_vm.deleteModal = true}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Delete")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Students_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82cbdc6c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Students_vue__ = __webpack_require__(674);
function injectStyle (ssrContext) {
  __webpack_require__(673)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Students_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82cbdc6c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Students_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-title',[_c('h1',{staticClass:"headline"},[_vm._v("List of Students")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-3 mt-2",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"loading":_vm.items.length == 0,"select-all":"","item-key":"user_id"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-checkbox',{attrs:{"primary":"","hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.family_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.given_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.middle_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.ext_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.birthday))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.address))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.username))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('v-progress-linear',{attrs:{"slot":"progress","indeterminate":""},slot:"progress"}),_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("\n        Nothing to display here :(\n      ")])],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.studentDialog),callback:function ($$v) {_vm.studentDialog=$$v},expression:"studentDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(this.checkIfAdd ? 'Add' : 'Edit')+" a Student")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[(_vm.checkIfAdd)?_c('v-text-field',{attrs:{"label":"Username","required":""},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[(_vm.checkIfAdd)?_c('v-text-field',{attrs:{"label":"Password","type":"password","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Given Name","required":"","error-messages":_vm.givenNameErrors},on:{"input":function($event){_vm.$v.givenName.$touch()},"blur":function($event){_vm.$v.givenName.$touch()}},model:{value:(_vm.givenName),callback:function ($$v) {_vm.givenName=$$v},expression:"givenName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Family Name","required":"","error-messages":_vm.familyNameErrors},on:{"input":function($event){_vm.$v.familyName.$touch()},"blur":function($event){_vm.$v.familyName.$touch()}},model:{value:(_vm.familyName),callback:function ($$v) {_vm.familyName=$$v},expression:"familyName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Middle Name"},model:{value:(_vm.middleName),callback:function ($$v) {_vm.middleName=$$v},expression:"middleName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md1":""}},[_c('v-text-field',{attrs:{"label":"Ext."},model:{value:(_vm.extName),callback:function ($$v) {_vm.extName=$$v},expression:"extName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('v-menu',{ref:"menu",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"min-width":"290px"},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Birthdate","prepend-icon":"event","readonly":"","required":"","error-messages":_vm.dateErrors},on:{"input":function($event){_vm.$v.date.$touch()},"blur":function($event){_vm.$v.date.$touch()}},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{ref:"picker",attrs:{"allowed-dates":_vm.allowedDates},on:{"change":_vm.save},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Address","multi-line":"","rows":"2"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p',{staticClass:"subheading"},[_vm._v("Gender:")]),_vm._v(" "),_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.gender),callback:function ($$v) {_vm.gender=$$v},expression:"gender"}},[_c('v-radio',{attrs:{"label":"Male","value":true}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Female","value":false}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Contact Number","mask":"###########","error-messages":_vm.contactNoErrors,"required":""},on:{"input":function($event){_vm.$v.contactNo.$touch()},"blur":function($event){_vm.$v.contactNo.$touch()}},model:{value:(_vm.contactNo),callback:function ($$v) {_vm.contactNo=$$v},expression:"contactNo"}})],1)],1),_vm._v(" "),_c('small',[_vm._v("*indicates required field")])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},nativeOn:{"click":function($event){_vm.clearFormField($event)}}},[_vm._v("Close")]),_vm._v(" "),(_vm.checkIfAdd)?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.addStudent}},[_vm._v("Save")]):_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.editStudent}},[_vm._v("Edit")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.deleteModal),callback:function ($$v) {_vm.deleteModal=$$v},expression:"deleteModal"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Warning!")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          You are about to delete "+_vm._s(this.selected.length)+" student"+_vm._s(this.selected.length > 0 ? 's' : '')+". Are you sure?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},nativeOn:{"click":function($event){_vm.deleteModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){_vm.deleteStudents($event)}}},[_vm._v("Delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-speed-dial',{attrs:{"bottom":true,"right":true,"transition":'slide-y-reverse-transition',"direction":'top',"fixed":"","hover":true},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","color":"red darken-1","dark":"","hover":""},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("more_vert")]),_vm._v(" "),_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","dark":"","color":"green"},on:{"click":function($event){_vm.setStudentsAction(true)}},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('span',[_vm._v("Add")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[(_vm.editSelected)?_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","dark":"","color":"amber"},on:{"click":function($event){_vm.setStudentsAction(false)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Edit")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[(_vm.deleteSelected)?_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","dark":"","color":"red"},on:{"click":function($event){_vm.deleteModal = true}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Delete")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__ = __webpack_require__(392);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f240a4d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__ = __webpack_require__(677);
function injectStyle (ssrContext) {
  __webpack_require__(676)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f240a4d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',{staticClass:"headline"},[_vm._v("List of Activities")]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-3 mt-2",attrs:{"headers":_vm.headers,"items":_vm.items,"loading":_vm.items.length == 0,"item-key":"event_id","select-all":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-checkbox',{attrs:{"primary":"","hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.start_date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.end_date))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('v-progress-linear',{attrs:{"slot":"progress","indeterminate":""},slot:"progress"}),_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("\n      Nothing to display here :(\n    ")])],2),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.eventDialog),callback:function ($$v) {_vm.eventDialog=$$v},expression:"eventDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(this.checkIfAdd ? 'Add' : 'Edit')+" an Event")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Event Name","required":"","error-messages":_vm.eventNameErrors},on:{"input":function($event){_vm.$v.eventName.$touch()},"blur":function($event){_vm.$v.eventName.$touch()}},model:{value:(_vm.eventName),callback:function ($$v) {_vm.eventName=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"eventName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Description","multi-line":""},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-menu',{attrs:{"lazy":"","transition":"scale-transition","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.startDateMenu),callback:function ($$v) {_vm.startDateMenu=$$v},expression:"startDateMenu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Start Date","prepend-icon":"event","error-messages":_vm.startDateErrors,"readonly":"","required":""},on:{"input":function($event){_vm.$v.startDate.$touch()},"blur":function($event){_vm.$v.startDate.$touch()}},slot:"activator",model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"gray"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-menu',{attrs:{"lazy":"","transition":"scale-transition","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.endDateMenu),callback:function ($$v) {_vm.endDateMenu=$$v},expression:"endDateMenu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"End Date","prepend-icon":"event","error-messages":_vm.endDateErrors,"readonly":"","required":""},on:{"input":function($event){_vm.$v.endDate.$touch()},"blur":function($event){_vm.$v.endDate.$touch()}},slot:"activator",model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"allowed-dates":_vm.allowedDates,"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"gray"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)],1),_vm._v(" "),_c('small',[_vm._v("*indicates required field")])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},nativeOn:{"click":function($event){_vm.clearFormField($event)}}},[_vm._v("Close")]),_vm._v(" "),(_vm.checkIfAdd)?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.addCalendarEvent}},[_vm._v("Save")]):_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.editCalendarEvent}},[_vm._v("Edit")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.deleteModal),callback:function ($$v) {_vm.deleteModal=$$v},expression:"deleteModal"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Warning!")]),_vm._v(" "),_c('v-card-text',[_vm._v("You are about to delete "+_vm._s(this.selected.length)+" event"+_vm._s(this.selected.length > 0 ? 's' : '')+". Are you sure?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},nativeOn:{"click":function($event){_vm.deleteModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){_vm.deleteCalendarEvent($event)}}},[_vm._v("Delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-speed-dial',{attrs:{"bottom":_vm.bottom,"right":_vm.right,"direction":_vm.direction,"transition":_vm.transition,"fixed":"","hover":true},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","color":"red darken-1","dark":"","hover":""},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("more_vert")]),_vm._v(" "),_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","dark":"","color":"green"},on:{"click":function($event){_vm.setEventAction(true)}},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('span',[_vm._v("Add")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[(_vm.editSelected)?_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","dark":"","color":"amber"},on:{"click":function($event){_vm.setEventAction(false)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Edit")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[(_vm.deleteSelected)?_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","dark":"","color":"red"},on:{"click":function($event){_vm.deleteModal = true}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Delete")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__(393);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_254312bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__(680);
function injectStyle (ssrContext) {
  __webpack_require__(679)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_254312bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',{staticClass:"headline"},[_vm._v("List of News")]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-3 mt-2",attrs:{"headers":_vm.headers,"items":_vm.items,"loading":_vm.items.length == 0,"item-key":"news_id","select-all":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-checkbox',{attrs:{"primary":"","hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.news_title))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.news_content))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.author_name))])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('v-progress-linear',{attrs:{"slot":"progress","indeterminate":""},slot:"progress"}),_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("\n      Nothing to display here :(\n    ")])],2),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.newsDialog),callback:function ($$v) {_vm.newsDialog=$$v},expression:"newsDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(this.checkIfAdd ? 'Add' : 'Edit')+" an Article")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"News Title","required":"","error-messages":_vm.newsTitleErrors},on:{"input":function($event){_vm.$v.newsTitle.$touch()},"blur":function($event){_vm.$v.newsTitle.$touch()}},model:{value:(_vm.newsTitle),callback:function ($$v) {_vm.newsTitle=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"newsTitle"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Content","required":"","multi-line":"","error-messages":_vm.newsContentErrors},on:{"input":function($event){_vm.$v.newsContent.$touch()},"blur":function($event){_vm.$v.newsContent.$touch()}},model:{value:(_vm.newsContent),callback:function ($$v) {_vm.newsContent=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"newsContent"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticStyle:{"cursor":"pointer"},attrs:{"color":"green","dark":"","tag":"label","for":"file-upload"}},[_vm._v("\n                Browse Image "),_c('v-icon',{attrs:{"right":""}},[_vm._v("camera")])],1),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.imageTitle))]),_vm._v(" "),_c('input',{ref:"image",attrs:{"accept":".jpg,.png","type":"file","id":"file-upload"},on:{"change":_vm.imageHandler}})],1),_vm._v(" "),_c('small',[_vm._v("*indicates required field")])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},nativeOn:{"click":function($event){_vm.clearFormField($event)}}},[_vm._v("Close")]),_vm._v(" "),(_vm.checkIfAdd)?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.addNews}},[_vm._v("Save")]):_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.editNews}},[_vm._v("Edit")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.deleteModal),callback:function ($$v) {_vm.deleteModal=$$v},expression:"deleteModal"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Warning!")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          You are about to delete "+_vm._s(this.selected.length)+" event"+_vm._s(this.selected.length > 0 ? 's' : '')+". Are you sure?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},nativeOn:{"click":function($event){_vm.deleteModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){_vm.deleteNews($event)}}},[_vm._v("Delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-speed-dial',{attrs:{"bottom":true,"right":true,"transition":'slide-y-reverse-transition',"direction":'top',"fixed":"","hover":true},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","color":"red darken-1","dark":"","hover":""},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("more_vert")]),_vm._v(" "),_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","dark":"","color":"green"},on:{"click":function($event){_vm.setNewsAction(true)}},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('span',[_vm._v("Add")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[(_vm.editSelected)?_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","dark":"","color":"amber"},on:{"click":function($event){_vm.setNewsAction(false)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Edit")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[(_vm.deleteSelected)?_c('v-btn',{attrs:{"slot":"activator","small":"","fab":"","dark":"","color":"red"},on:{"click":function($event){_vm.deleteModal = true}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Delete")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Classrooms_vue__ = __webpack_require__(394);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c998f9e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Classrooms_vue__ = __webpack_require__(685);
function injectStyle (ssrContext) {
  __webpack_require__(682)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Classrooms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c998f9e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Classrooms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(395);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5279a223_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(684);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5279a223_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.profile)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"lazy":"","right":""}},[_c('label',{staticStyle:{"cursor":"pointer"},attrs:{"slot":"activator","for":"image-upload-instructor"},slot:"activator"},[_c('v-avatar',{attrs:{"size":"100px"}},[_c('img',{attrs:{"src":_vm.profile.image,"alt":_vm.profile.family_name}})])],1),_vm._v(" "),_c('input',{ref:"image",attrs:{"hidden":"","type":"file","id":"image-upload-instructor","accept":".jpeg, .jpg, .png"},on:{"change":function($event){_vm.imageDialog = true}}}),_vm._v(" "),_c('span',[_vm._v("Change picture")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"lazy":"","bottom":""}},[_c('v-badge',{staticStyle:{"cursor":"pointer"},attrs:{"slot":"activator"},nativeOn:{"click":function($event){_vm.profileDialog = true}},slot:"activator"},[_c('v-icon',{attrs:{"slot":"badge","dark":"","small":""},slot:"badge"},[_vm._v("edit")]),_vm._v(" "),_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.profile.given_name)+" "+_vm._s(_vm.profile.family_name))])],1),_vm._v(" "),_c('span',[_vm._v("Edit Profile")])],1)],1),_vm._v(" "),_c('v-flex',[_c('small',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.passwordDialog = true}}},[_vm._v("Change Password")])]),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.profileDialog),callback:function ($$v) {_vm.profileDialog=$$v},expression:"profileDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Edit Profile")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Given Name","required":"","error-messages":_vm.givenNameErrors},on:{"input":function($event){_vm.$v.givenName.$touch()},"blur":function($event){_vm.$v.givenName.$touch()}},model:{value:(_vm.givenName),callback:function ($$v) {_vm.givenName=$$v},expression:"givenName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Family Name","required":"","error-messages":_vm.familyNameErrors},on:{"input":function($event){_vm.$v.familyName.$touch()},"blur":function($event){_vm.$v.familyName.$touch()}},model:{value:(_vm.familyName),callback:function ($$v) {_vm.familyName=$$v},expression:"familyName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Middle Name"},model:{value:(_vm.middleName),callback:function ($$v) {_vm.middleName=$$v},expression:"middleName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md1":""}},[_c('v-text-field',{attrs:{"label":"Ext."},model:{value:(_vm.extName),callback:function ($$v) {_vm.extName=$$v},expression:"extName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('v-menu',{ref:"menu",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"min-width":"290px"},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Birthdate","prepend-icon":"event","readonly":"","required":"","error-messages":_vm.dateErrors},on:{"input":function($event){_vm.$v.date.$touch()},"blur":function($event){_vm.$v.date.$touch()}},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{ref:"picker",attrs:{"allowed-dates":_vm.allowedDates},on:{"change":_vm.save},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Address","multi-line":"","rows":"2"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p',{staticClass:"subheading"},[_vm._v("Gender:")]),_vm._v(" "),_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.gender),callback:function ($$v) {_vm.gender=$$v},expression:"gender"}},[_c('v-radio',{attrs:{"label":"Male","value":true}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Female","value":false}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Contact Number","mask":"###########","error-messages":_vm.contactNoErrors,"required":""},on:{"input":function($event){_vm.$v.contactNo.$touch()},"blur":function($event){_vm.$v.contactNo.$touch()}},model:{value:(_vm.contactNo),callback:function ($$v) {_vm.contactNo=$$v},expression:"contactNo"}})],1)],1),_vm._v(" "),_c('small',[_vm._v("*indicates required field")])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},on:{"click":function($event){_vm.profileDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.editProfileDetails}},[_vm._v("Edit")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.passwordDialog),callback:function ($$v) {_vm.passwordDialog=$$v},expression:"passwordDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Change Password")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Enter new password","type":"password","required":""},model:{value:(_vm.password1),callback:function ($$v) {_vm.password1=$$v},expression:"password1"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Re-Enter password","type":"password","required":""},model:{value:(_vm.password2),callback:function ($$v) {_vm.password2=$$v},expression:"password2"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},on:{"click":function($event){_vm.passwordDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.changePassword}},[_vm._v("Change")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"300"},model:{value:(_vm.imageDialog),callback:function ($$v) {_vm.imageDialog=$$v},expression:"imageDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Changing Image")]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Are you sure?")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.imageDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"blue darken-1","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.changeProfileImage}},[_vm._v("\n            Save\n          ")])],1)],1)],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('profile'),_vm._v(" "),_c('h1',{staticClass:"headline"},[_vm._v("My Classes")]),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":""}},_vm._l((_vm.classrooms),function(classroom,i){return _c('v-flex',{key:classroom.classroom_id,attrs:{"md3":""}},[_c('v-card',[_c('v-card-media',{attrs:{"src":'https://picsum.photos/1000/700?image='+i,"height":"100px"}},[_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":"","lazy":""}},[_c('v-menu',{attrs:{"slot":"activator","offset-x":""},slot:"activator"},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"white"},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.setEventAction(false, classroom.classroom_id)}}},[_c('v-list-tile-title',[_vm._v("Edit")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.configDelete(classroom.classroom_id)}}},[_c('v-list-tile-title',[_vm._v("Delete")])],1)],1)],1),_vm._v(" "),_c('span',[_vm._v("More actions")])],1)],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('router-link',{staticClass:"underline",staticStyle:{"cursor":"pointer"},attrs:{"to":'/instructor/classroom/' + classroom.classroom_id}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(classroom.classroom_name))])]),_vm._v(" "),_c('div',{staticClass:"grey--text"},[_vm._v("Subject: "+_vm._s(classroom.subject))]),_vm._v(" "),_c('div',{staticClass:"grey--text"},[_vm._v("Section: "+_vm._s(classroom.section))]),_vm._v(" "),_c('div',{staticClass:"grey--text"},[_vm._v("Class Code: "+_vm._s(classroom.classroom_id))])],1)])],1)],1)})),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.classDialog),callback:function ($$v) {_vm.classDialog=$$v},expression:"classDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.checkIfAdd ? 'Add' : 'Edit')+" a class")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Name","required":"","error-messages":_vm.classroomNameErrors},on:{"input":function($event){_vm.$v.classroomName.$touch()},"blur":function($event){_vm.$v.classroomName.$touch()}},model:{value:(_vm.classroomName),callback:function ($$v) {_vm.classroomName=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"classroomName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Subject","required":"","error-messages":_vm.subjectErrors},on:{"input":function($event){_vm.$v.subject.$touch()},"blur":function($event){_vm.$v.subject.$touch()}},model:{value:(_vm.subject),callback:function ($$v) {_vm.subject=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"subject"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Section","required":"","error-messages":_vm.sectionErrors},on:{"input":function($event){_vm.$v.section.$touch()},"blur":function($event){_vm.$v.section.$touch()}},model:{value:(_vm.section),callback:function ($$v) {_vm.section=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"section"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},nativeOn:{"click":function($event){_vm.clearFormField($event)}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.checkIfAdd)?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.addClass($event)}}},[_vm._v("Add")]):_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.editClass($event)}}},[_vm._v("Edit")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.deleteModal),callback:function ($$v) {_vm.deleteModal=$$v},expression:"deleteModal"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Warning!")]),_vm._v(" "),_c('v-card-text',[_vm._v("You are about to delete this classroom. Are you sure?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},nativeOn:{"click":function($event){_vm.deleteModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){_vm.deleteClass($event)}}},[_vm._v("Delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[_c('v-speed-dial',{attrs:{"slot":"activator","bottom":_vm.bottom,"right":_vm.right,"direction":_vm.direction,"transition":_vm.transition,"fixed":""},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","color":"red darken-1","dark":"","hover":""},on:{"click":function($event){_vm.setEventAction(true)}},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('span',[_vm._v("Add a classroom")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Classroom_vue__ = __webpack_require__(396);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d11166b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Classroom_vue__ = __webpack_require__(705);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Classroom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d11166b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Classroom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Post_vue__ = __webpack_require__(397);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0ed80f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Post_vue__ = __webpack_require__(691);
function injectStyle (ssrContext) {
  __webpack_require__(688)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f0ed80f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Post_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0ed80f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Post_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostComment_vue__ = __webpack_require__(398);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_847bf6c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostComment_vue__ = __webpack_require__(690);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostComment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_847bf6c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostComment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-text',{staticClass:"grey lighten-4"},[_c('v-layout',{attrs:{"row":""}},[_c('div',[_c('v-avatar',{attrs:{"size":"42px"}},[_c('img',{staticClass:"mr-3",attrs:{"src":_vm.comment.author.image}})])],1),_vm._v(" "),_c('div',{staticClass:"caption"},[_c('v-layout',{attrs:{"column":""}},[_c('div',[_c('span',{staticStyle:{"font-weight":"700"}},[_vm._v("\n              "+_vm._s(_vm.comment.author.given_name)+" "+_vm._s(_vm.comment.author.family_name)+" "+_vm._s(_vm.comment.author.ext_name)+"\n            ")]),_vm._v(" "),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.comment.edited ? _vm.comment.updated_at : _vm.comment.created_at)+" "+_vm._s(_vm.comment.edited ? '(edited)' : ''))])]),_vm._v(" "),_c('div',{},[_c('span',[_vm._v(_vm._s(_vm.comment.comment))])])])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',[_c('v-menu',{attrs:{"offset-y":"","lazy":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"grey darken-2"},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),(this.$store.getters.GET_USER_DETAILS.user_id === _vm.comment.author.user_id)?_c('v-list',[_c('v-list-tile',{on:{"click":_vm.openEditDialog}},[_c('v-list-tile-title',[_vm._v("Edit")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.deleteDialog = true}}},[_c('v-list-tile-title',[_vm._v("Delete")])],1)],1):_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.deleteDialog = true}}},[_c('v-list-tile-title',[_vm._v("Delete")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"700px"},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-card',[_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Edit your post...","multi-line":"","rows":"1","autofocus":""},model:{value:(_vm.editedText),callback:function ($$v) {_vm.editedText=$$v},expression:"editedText"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.editDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"elevation-0",attrs:{"dark":"","color":"green","loading":_vm.loading},on:{"click":function($event){_vm.editComment(_vm.comment.comment_id)}}},[_vm._v("Edit")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"300px"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"subheading"},[_vm._v("Are you sure you want to delete this comment?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"elevation-0",attrs:{"dark":"","color":"red","loading":_vm.loading},on:{"click":function($event){_vm.deleteComment(_vm.comment.comment_id)}}},[_vm._v("Delete")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":"","offset-md3":""}},[_c('v-card',[_c('v-card-title',[_c('v-layout',{attrs:{"row":""}},[_c('div',[_c('span',[_c('v-avatar',{attrs:{"size":"42px"}},[_c('img',{staticClass:"mr-3",attrs:{"src":_vm.post.author.image}})])],1)]),_vm._v(" "),_c('div',[_c('v-layout',{attrs:{"column":""}},[_c('div',[_vm._v(_vm._s(_vm.post.author.given_name)+" "+_vm._s(_vm.post.author.family_name)+" "+_vm._s(_vm.post.author.ext_name))]),_vm._v(" "),_c('div',{staticClass:"grey--text caption"},[_vm._v(_vm._s(_vm.post.edited ? _vm.post.updated_at : _vm.post.created_at)+" "+_vm._s(_vm.post.edited ? '(edited)' : ''))])])],1)]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":"","lazy":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"grey darken-2"},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),(this.$store.getters.GET_USER_DETAILS.user_id === _vm.post.author.user_id)?_c('v-list',[_c('v-list-tile',{on:{"click":_vm.openEditDialog}},[_c('v-list-tile-title',[_vm._v("Edit")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.deleteDialog = true}}},[_c('v-list-tile-title',[_vm._v("Delete")])],1)],1):_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.deleteDialog = true}}},[_c('v-list-tile-title',[_vm._v("Delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('span',[_vm._v(_vm._s(_vm.post.post_content))])]),_vm._v(" "),(_vm.post.comments.length !== 0)?_c('v-card-text',{staticClass:"grey lighten-4"},[(_vm.post.comments.length > 1)?_c('div',[(_vm.collapsed !== false)?_c('p',{staticClass:"caption comment-caption",on:{"click":function($event){_vm.collapsed = false}}},[_vm._v("View "+_vm._s(_vm.post.comments.length)+" comments..")]):_c('p',{staticClass:"caption comment-caption",on:{"click":function($event){_vm.collapsed = true}}},[_vm._v("Collapse comments..")])]):_vm._e(),_vm._v(" "),_vm._l((!_vm.collapsed ? _vm.post.comments : [_vm.post.comments[_vm.post.comments.length - 1]]),function(comment,i){return _c('post-comment',{key:i,attrs:{"comment":comment}})})],2):_vm._e(),_vm._v(" "),_c('v-card-text',{staticClass:"grey lighten-3 "},[(!_vm.commentStatus)?_c('span',{staticClass:"caption comment-caption",on:{"click":function($event){_vm.commentStatus = true}}},[_vm._v("Write a comment...")]):_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-text-field',{attrs:{"label":"Your comment...","autofocus":""},model:{value:(_vm.commentText),callback:function ($$v) {_vm.commentText=$$v},expression:"commentText"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{attrs:{"flat":"","color":"red","disabled":_vm.loading},on:{"click":function($event){_vm.commentStatus = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"green","loading":_vm.loading},on:{"click":_vm.comment}},[_vm._v("Comment")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"700px"},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-card',[_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Edit your post...","multi-line":"","rows":"1","autofocus":""},model:{value:(_vm.editedText),callback:function ($$v) {_vm.editedText=$$v},expression:"editedText"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.editDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"elevation-0",attrs:{"dark":"","color":"green","loading":_vm.loading},on:{"click":function($event){_vm.editPost(_vm.post.post_id)}}},[_vm._v("Edit")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"300px"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete this post?")]),_vm._v(" "),_c('v-card-text',[_vm._v("Comments will also be deleted.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"elevation-0",attrs:{"dark":"","color":"red","loading":_vm.loading},on:{"click":function($event){_vm.deletePost(_vm.post.post_id)}}},[_vm._v("Delete")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPost_vue__ = __webpack_require__(399);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_166263d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPost_vue__ = __webpack_require__(694);
function injectStyle (ssrContext) {
  __webpack_require__(693)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-166263d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_166263d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":"","offset-md3":""}},[_c('v-card',[_c('v-card-text',[(!_vm.postStatus)?_c('p',{staticClass:"post-caption",on:{"click":function($event){_vm.postStatus = true}}},[_vm._v("Add an announcement...")]):_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"autofocus":"","label":"Your announcement..."},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},on:{"click":function($event){_vm.postStatus = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"green"},on:{"click":_vm.postAnnouncement}},[_vm._v("Post")])],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Students_vue__ = __webpack_require__(400);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b4c530_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Students_vue__ = __webpack_require__(696);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Students_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b4c530_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Students_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-card',[_c('v-card-text',[_c('v-tooltip',{attrs:{"left":"","lazy":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":function($event){_vm.deleteDialog = true}},slot:"activator"},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('span',[_vm._v("Remove student")])],1),_vm._v(" "),_c('span',[_c('v-avatar',{attrs:{"size":"42px"}},[_c('img',{staticClass:"mr-3",attrs:{"src":_vm.student.profile.image}})])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.student.profile.given_name)+" "+_vm._s(_vm.student.profile.family_name)+" "+_vm._s(_vm.student.profile.ext_name))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"300"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Removing "+_vm._s(_vm.student.profile.given_name)+" "+_vm._s(_vm.student.profile.family_name)+" "+_vm._s(_vm.student.profile.ext_name))]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Are you sure you want to remove this student?")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"red","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.removeStudent}},[_vm._v("\n            Remove\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Files_vue__ = __webpack_require__(401);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9335916_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Files_vue__ = __webpack_require__(700);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Files_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9335916_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Files_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_File_vue__ = __webpack_require__(402);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22b50386_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_File_vue__ = __webpack_require__(699);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_File_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22b50386_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_File_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-card',[_c('v-card-text',[_c('v-btn',{attrs:{"icon":"","tag":"a","href":("http://tesseract-ics.herokuapp.com/api/class/" + (this.$route.params.id) + "/download?file_location=" + _vm.file + "&token=" + (this.$store.getters.GET_TOKEN)),"download":""}},[_c('v-icon',{attrs:{"color":"blue"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.deleteDialog = true}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.file))]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"300"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Deleting file")]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Are you sure you want to delete this file?")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"red","loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){_vm.deleteFile(_vm.file)}}},[_vm._v("\n            Delete\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":"","offset-md3":""}},_vm._l((_vm.files),function(file,i){return _c('file',{key:i,attrs:{"file":file}})}))],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"300"},model:{value:(_vm.fileDialog),callback:function ($$v) {_vm.fileDialog=$$v},expression:"fileDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.fileTitle))]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Upload this file? ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.fileDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"blue darken-1","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.uploadFile}},[_vm._v("\n            Upload\n            "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[_c('v-btn',{staticStyle:{"cursor":"pointer"},attrs:{"slot":"activator","fixed":"","bottom":"","right":"","fab":"","color":"red darken-1","dark":"","tag":"label","for":"file-upload-instructor"},slot:"activator"},[_c('v-icon',[_vm._v("attach_file")])],1),_vm._v(" "),_c('input',{ref:"file",attrs:{"hidden":"","type":"file","id":"file-upload-instructor"},on:{"change":_vm.fileHandler}}),_vm._v(" "),_c('span',[_vm._v("Upload file")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Assignments_vue__ = __webpack_require__(403);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_052674bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Assignments_vue__ = __webpack_require__(704);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Assignments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_052674bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Assignments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Assignment_vue__ = __webpack_require__(404);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_316de3d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Assignment_vue__ = __webpack_require__(703);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Assignment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_316de3d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Assignment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-card',[_c('v-card-text',[_c('v-btn',{attrs:{"icon":"","tag":"a","href":("http://tesseract-ics.herokuapp.com/api/class/" + (this.$route.params.id) + "/assignment/download?file_location=" + _vm.assignment + "&token=" + (this.$store.getters.GET_TOKEN)),"download":""}},[_c('v-icon',{attrs:{"color":"blue"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.deleteDialog = true}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.assignment))]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"300"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Deleting file")]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Are you sure you want to delete this file?")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"red","loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){_vm.deleteFile(_vm.file)}}},[_vm._v("\n          Delete\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":"","offset-md3":""}},_vm._l((_vm.assignments),function(assignment,i){return _c('assignment',{key:i,attrs:{"assignment":assignment}})}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.classInfo)?_c('v-tabs',{attrs:{"fixed":"","centered":""}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":"","justify-center":"","align-center":"","column":""}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.classInfo.subject + ' -')+" "+_vm._s(_vm.classInfo.classroom_name))]),_vm._v(" "),_c('div',{staticClass:"subheading text-xs-center"},[_vm._v(_vm._s(_vm.classInfo.section))]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('v-avatar',{attrs:{"size":"42px"}},[_c('img',{staticClass:"mr-3",attrs:{"src":_vm.classInfo.instructor.image,"alt":_vm.classInfo.instructor.family_name}})]),_vm._v(" "),_c('span',{staticClass:"px-0"},[_vm._v(_vm._s(_vm.classInfo.instructor.given_name)+" "+_vm._s(_vm.classInfo.instructor.family_name))])],1)])],1),_vm._v(" "),_c('v-tabs-bar',{staticClass:"green darken-2",attrs:{"dark":""}},[_c('v-tabs-slider',{staticClass:"yellow"}),_vm._v(" "),_vm._l((_vm.items),function(i){return _c('v-tabs-item',{key:i,attrs:{"href":'#' + i}},[_vm._v("\n      "+_vm._s(i)+"\n    ")])})],2),_vm._v(" "),_c('v-tabs-items',[_c('v-tabs-content',{attrs:{"id":"Feed"}},[_c('add-post'),_vm._v(" "),_vm._l((_vm.posts),function(postData){return _c('post',{key:postData.post_id,attrs:{"post":postData}})})],2),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"Students"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":"","offset-md3":""}},_vm._l((_vm.students),function(student){return _c('student-list',{key:student.student_id,attrs:{"student":student,"fetchStudents":_vm.fetchStudents}})}))],1)],1)],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"Files"}},[_c('file-list',{attrs:{"files":_vm.files}})],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"Assignments"}},[_c('assignment-list',{attrs:{"assignments":_vm.assignments}})],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Classrooms_vue__ = __webpack_require__(405);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9583926a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Classrooms_vue__ = __webpack_require__(712);
function injectStyle (ssrContext) {
  __webpack_require__(707)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Classrooms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9583926a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Classrooms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClassroomCard_vue__ = __webpack_require__(406);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a875d69c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClassroomCard_vue__ = __webpack_require__(709);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClassroomCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a875d69c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClassroomCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"md3":""}},[_c('v-card',[_c('v-card-media',{attrs:{"src":'https://picsum.photos/1000/700?image='+_vm.inc,"height":"100px"}},[_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":"","lazy":""}},[_c('v-menu',{attrs:{"slot":"activator","offset-y":""},slot:"activator"},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"white"},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.deleteDialog = true}}},[_c('v-list-tile-title',[_vm._v("Unenroll")])],1)],1)],1),_vm._v(" "),_c('span',[_vm._v("More actions")])],1)],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('router-link',{staticClass:"underline",staticStyle:{"cursor":"pointer"},attrs:{"to":'/student/classroom/' + _vm.classroom.classroom_id}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.classroom.classroom_name))])]),_vm._v(" "),_c('div',{staticClass:"grey--text"},[_vm._v("Subject: "+_vm._s(_vm.classroom.subject))]),_vm._v(" "),_c('div',{staticClass:"grey--text"},[_vm._v("Section: "+_vm._s(_vm.classroom.section))]),_vm._v(" "),_c('div',{staticClass:"grey--text"},[_vm._v("Class Code: "+_vm._s(_vm.classroom.classroom_id))])],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"300"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-text',[_c('p',[_vm._v("Are you sure you want to leave this class?")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"red","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.unenroll}},[_vm._v("\n            Remove\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(407);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2336bfd3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(711);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2336bfd3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.profile)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"lazy":"","right":""}},[_c('label',{staticStyle:{"cursor":"pointer"},attrs:{"slot":"activator","for":"image-upload-instructor"},slot:"activator"},[_c('v-avatar',{attrs:{"size":"100px"}},[_c('img',{attrs:{"src":_vm.profile.image,"alt":_vm.profile.family_name}})])],1),_vm._v(" "),_c('input',{ref:"image",attrs:{"hidden":"","type":"file","id":"image-upload-instructor","accept":".jpeg, .jpg, .png"},on:{"change":function($event){_vm.imageDialog = true}}}),_vm._v(" "),_c('span',[_vm._v("Change picture")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"lazy":"","bottom":""}},[_c('v-badge',{staticStyle:{"cursor":"pointer"},attrs:{"slot":"activator"},nativeOn:{"click":function($event){_vm.profileDialog = true}},slot:"activator"},[_c('v-icon',{attrs:{"slot":"badge","dark":"","small":""},slot:"badge"},[_vm._v("edit")]),_vm._v(" "),_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.profile.given_name)+" "+_vm._s(_vm.profile.family_name))])],1),_vm._v(" "),_c('span',[_vm._v("Edit Profile")])],1)],1),_vm._v(" "),_c('v-flex',[_c('small',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.passwordDialog = true}}},[_vm._v("Change Password")])]),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.profileDialog),callback:function ($$v) {_vm.profileDialog=$$v},expression:"profileDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Edit Profile")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Given Name","required":"","error-messages":_vm.givenNameErrors},on:{"input":function($event){_vm.$v.givenName.$touch()},"blur":function($event){_vm.$v.givenName.$touch()}},model:{value:(_vm.givenName),callback:function ($$v) {_vm.givenName=$$v},expression:"givenName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Family Name","required":"","error-messages":_vm.familyNameErrors},on:{"input":function($event){_vm.$v.familyName.$touch()},"blur":function($event){_vm.$v.familyName.$touch()}},model:{value:(_vm.familyName),callback:function ($$v) {_vm.familyName=$$v},expression:"familyName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Middle Name"},model:{value:(_vm.middleName),callback:function ($$v) {_vm.middleName=$$v},expression:"middleName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md1":""}},[_c('v-text-field',{attrs:{"label":"Ext."},model:{value:(_vm.extName),callback:function ($$v) {_vm.extName=$$v},expression:"extName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md5":""}},[_c('v-menu',{ref:"menu",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"min-width":"290px"},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Birthdate","prepend-icon":"event","readonly":"","required":"","error-messages":_vm.dateErrors},on:{"input":function($event){_vm.$v.date.$touch()},"blur":function($event){_vm.$v.date.$touch()}},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{ref:"picker",attrs:{"allowed-dates":_vm.allowedDates},on:{"change":_vm.save},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Address","multi-line":"","rows":"2"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('p',{staticClass:"subheading"},[_vm._v("Gender:")]),_vm._v(" "),_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.gender),callback:function ($$v) {_vm.gender=$$v},expression:"gender"}},[_c('v-radio',{attrs:{"label":"Male","value":true}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Female","value":false}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Contact Number","mask":"###########","error-messages":_vm.contactNoErrors,"required":""},on:{"input":function($event){_vm.$v.contactNo.$touch()},"blur":function($event){_vm.$v.contactNo.$touch()}},model:{value:(_vm.contactNo),callback:function ($$v) {_vm.contactNo=$$v},expression:"contactNo"}})],1)],1),_vm._v(" "),_c('small',[_vm._v("*indicates required field")])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},on:{"click":function($event){_vm.profileDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.editProfileDetails}},[_vm._v("Edit")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.passwordDialog),callback:function ($$v) {_vm.passwordDialog=$$v},expression:"passwordDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Change Password")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Enter new password","type":"password","required":""},model:{value:(_vm.password1),callback:function ($$v) {_vm.password1=$$v},expression:"password1"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Re-Enter password","type":"password","required":""},model:{value:(_vm.password2),callback:function ($$v) {_vm.password2=$$v},expression:"password2"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":""},on:{"click":function($event){_vm.passwordDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.changePassword}},[_vm._v("Change")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"300"},model:{value:(_vm.imageDialog),callback:function ($$v) {_vm.imageDialog=$$v},expression:"imageDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Changing Image")]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Are you sure?")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.imageDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"blue darken-1","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.changeProfileImage}},[_vm._v("\n            Save\n          ")])],1)],1)],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('profile'),_vm._v(" "),_c('h1',{staticClass:"headline"},[_vm._v("My Classes")]),_vm._v(" "),_c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":""}},_vm._l((_vm.classrooms),function(classroom,i){return _c('classroom-card',{key:classroom.classroom_id,attrs:{"classroom":classroom.classroom,"inc":i}})})),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400px"},model:{value:(_vm.classCodeModal),callback:function ($$v) {_vm.classCodeModal=$$v},expression:"classCodeModal"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Join a class")])]),_vm._v(" "),_c('v-card-text',[_c('span',{staticClass:"body-1"},[_vm._v("Enter the class code that was given by your instructor.")]),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Class Code"},model:{value:(_vm.classCode),callback:function ($$v) {_vm.classCode=$$v},expression:"classCode"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.classCodeModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"elevation-0",attrs:{"dark":"","color":"green","loading":_vm.loading},on:{"click":_vm.enterClassCode}},[_vm._v("Submit")])],1)],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[_c('v-speed-dial',{attrs:{"slot":"activator","bottom":_vm.bottom,"right":_vm.right,"direction":_vm.direction,"transition":_vm.transition,"fixed":""},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","color":"red darken-1","dark":"","hover":""},on:{"click":function($event){_vm.classCodeModal = true}},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('span',[_vm._v("Join a class")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Classroom_vue__ = __webpack_require__(408);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7da03ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Classroom_vue__ = __webpack_require__(729);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Classroom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7da03ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Classroom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Post_vue__ = __webpack_require__(409);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74605e75_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Post_vue__ = __webpack_require__(718);
function injectStyle (ssrContext) {
  __webpack_require__(715)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74605e75"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Post_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74605e75_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Post_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostComment_vue__ = __webpack_require__(410);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f96eb1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostComment_vue__ = __webpack_require__(717);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostComment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f96eb1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostComment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-text',{staticClass:"grey lighten-4"},[_c('v-layout',{attrs:{"row":""}},[_c('div',[_c('v-avatar',{attrs:{"size":"42px"}},[_c('img',{staticClass:"mr-3",attrs:{"src":_vm.comment.author.image}})])],1),_vm._v(" "),_c('div',{staticClass:"caption"},[_c('v-layout',{attrs:{"column":""}},[_c('div',[_c('span',{staticStyle:{"font-weight":"700"}},[_vm._v("\n              "+_vm._s(_vm.comment.author.given_name)+" "+_vm._s(_vm.comment.author.family_name)+" "+_vm._s(_vm.comment.author.ext_name)+"\n            ")]),_vm._v(" "),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.comment.edited ? _vm.comment.updated_at : _vm.comment.created_at)+" "+_vm._s(_vm.comment.edited ? '(edited)' : ''))])]),_vm._v(" "),_c('div',{},[_c('span',[_vm._v(_vm._s(_vm.comment.comment))])])])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(this.$store.getters.GET_USER_DETAILS.user_id === _vm.comment.author.user_id)?_c('div',[_c('v-menu',{attrs:{"offset-y":"","lazy":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"grey darken-2"},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":_vm.openEditDialog}},[_c('v-list-tile-title',[_vm._v("Edit")])],1)],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"700px"},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-card',[_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Edit your post...","multi-line":"","rows":"1","autofocus":""},model:{value:(_vm.editedText),callback:function ($$v) {_vm.editedText=$$v},expression:"editedText"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.editDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"elevation-0",attrs:{"dark":"","color":"green","loading":_vm.loading},on:{"click":function($event){_vm.editComment(_vm.comment.comment_id)}}},[_vm._v("Edit")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":"","offset-md3":""}},[_c('v-card',[_c('v-card-title',[_c('v-layout',{attrs:{"row":""}},[_c('div',[_c('span',[_c('v-avatar',{attrs:{"size":"42px"}},[_c('img',{staticClass:"mr-3",attrs:{"src":_vm.post.author.image}})])],1)]),_vm._v(" "),_c('div',[_c('v-layout',{attrs:{"column":""}},[_c('div',[_vm._v(_vm._s(_vm.post.author.given_name)+" "+_vm._s(_vm.post.author.family_name)+" "+_vm._s(_vm.post.author.ext_name))]),_vm._v(" "),_c('div',{staticClass:"grey--text caption"},[_vm._v(_vm._s(_vm.post.edited ? _vm.post.updated_at : _vm.post.created_at)+" "+_vm._s(_vm.post.edited ? '(edited)' : ''))])])],1)]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(this.$store.getters.GET_USER_DETAILS.user_id === _vm.post.author.user_id)?_c('v-menu',{attrs:{"offset-y":"","lazy":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"grey darken-2"},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":_vm.openEditDialog}},[_c('v-list-tile-title',[_vm._v("Edit")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.deleteDialog = true}}},[_c('v-list-tile-title',[_vm._v("Delete")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('span',[_vm._v(_vm._s(_vm.post.post_content))])]),_vm._v(" "),(_vm.post.comments.length !== 0)?_c('v-card-text',{staticClass:"grey lighten-4"},[(_vm.post.comments.length > 1)?_c('div',[(_vm.collapsed !== false)?_c('p',{staticClass:"caption comment-caption",on:{"click":function($event){_vm.collapsed = false}}},[_vm._v("View "+_vm._s(_vm.post.comments.length)+" comments..")]):_c('p',{staticClass:"caption comment-caption",on:{"click":function($event){_vm.collapsed = true}}},[_vm._v("Collapse comments..")])]):_vm._e(),_vm._v(" "),_vm._l((!_vm.collapsed ? _vm.post.comments : [_vm.post.comments[_vm.post.comments.length - 1]]),function(comment,i){return _c('post-comment',{key:i,attrs:{"comment":comment}})})],2):_vm._e(),_vm._v(" "),_c('v-card-text',{staticClass:"grey lighten-3 "},[(!_vm.commentStatus)?_c('span',{staticClass:"caption comment-caption",on:{"click":function($event){_vm.commentStatus = true}}},[_vm._v("Write a comment...")]):_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md8":""}},[_c('v-text-field',{attrs:{"label":"Your comment...","autofocus":""},model:{value:(_vm.commentText),callback:function ($$v) {_vm.commentText=$$v},expression:"commentText"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{attrs:{"flat":"","color":"red","disabled":_vm.loading},on:{"click":function($event){_vm.commentStatus = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"green","loading":_vm.loading},on:{"click":_vm.comment}},[_vm._v("Comment")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"700px"},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-card',[_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Edit your post...","multi-line":"","rows":"1","autofocus":""},model:{value:(_vm.editedText),callback:function ($$v) {_vm.editedText=$$v},expression:"editedText"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.editDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"elevation-0",attrs:{"dark":"","color":"green","loading":_vm.loading},on:{"click":function($event){_vm.editPost(_vm.post.post_id)}}},[_vm._v("Edit")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"300px"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete this post?")]),_vm._v(" "),_c('v-card-text',[_vm._v("Comments will also be deleted.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.deleteDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"elevation-0",attrs:{"dark":"","color":"red","loading":_vm.loading},on:{"click":function($event){_vm.deletePost(_vm.post.post_id)}}},[_vm._v("Delete")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPost_vue__ = __webpack_require__(411);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a213aea2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPost_vue__ = __webpack_require__(721);
function injectStyle (ssrContext) {
  __webpack_require__(720)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a213aea2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a213aea2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":"","offset-md3":""}},[_c('v-card',[_c('v-card-text',[(!_vm.postStatus)?_c('p',{staticClass:"post-caption",on:{"click":function($event){_vm.postStatus = true}}},[_vm._v("Post an inquiry...")]):_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"autofocus":"","label":"Post an inquiry.."},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},on:{"click":function($event){_vm.postStatus = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"green"},on:{"click":_vm.postAnnouncement}},[_vm._v("Post")])],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Students_vue__ = __webpack_require__(412);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4db40048_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Students_vue__ = __webpack_require__(723);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Students_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4db40048_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Students_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-card',[_c('v-card-text',[_c('span',[_c('v-avatar',{attrs:{"size":"42px"}},[_c('img',{staticClass:"mr-3",attrs:{"src":_vm.student.profile.image}})])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.student.profile.given_name)+" "+_vm._s(_vm.student.profile.family_name)+" "+_vm._s(_vm.student.profile.ext_name))])])],1),_vm._v(" "),_c('v-divider')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Files_vue__ = __webpack_require__(413);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7790f2c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Files_vue__ = __webpack_require__(728);
function injectStyle (ssrContext) {
  __webpack_require__(725)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Files_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7790f2c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Files_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_File_vue__ = __webpack_require__(414);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_470aaee0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_File_vue__ = __webpack_require__(727);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_File_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_470aaee0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_File_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-card',[_c('v-card-text',[_c('v-btn',{attrs:{"icon":"","tag":"a","href":("http://tesseract-ics.herokuapp.com/api/class/" + (this.$route.params.id) + "/download?file_location=" + _vm.file + "&token=" + (this.$store.getters.GET_TOKEN)),"download":""}},[_c('v-icon',{attrs:{"color":"blue"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.file))])],1)],1),_vm._v(" "),_c('v-divider')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":"","offset-md3":""}},_vm._l((_vm.files),function(file,i){return _c('file',{key:i,attrs:{"file":file}})}))],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"300"},model:{value:(_vm.fileDialog),callback:function ($$v) {_vm.fileDialog=$$v},expression:"fileDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.fileTitle))]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Upload this file? ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"gray","flat":"","disabled":_vm.loading},on:{"click":function($event){_vm.fileDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"blue darken-1","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.uploadFile}},[_vm._v("\n            Upload\n            "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":"","lazy":""}},[_c('v-btn',{staticStyle:{"cursor":"pointer"},attrs:{"slot":"activator","fixed":"","bottom":"","right":"","fab":"","color":"red darken-1","dark":"","tag":"label","for":"file-upload"},slot:"activator"},[_c('v-icon',[_vm._v("attach_file")])],1),_vm._v(" "),_c('input',{ref:"file",attrs:{"hidden":"","type":"file","id":"file-upload"},on:{"change":_vm.fileHandler}}),_vm._v(" "),_c('span',[_vm._v("Upload assignment")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.classInfo)?_c('v-tabs',{attrs:{"fixed":"","centered":""}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":"","justify-center":"","align-center":"","column":""}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.classInfo.subject + ' -')+" "+_vm._s(_vm.classInfo.classroom_name))]),_vm._v(" "),_c('div',{staticClass:"subheading text-xs-center"},[_vm._v(_vm._s(_vm.classInfo.section))]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('v-avatar',{attrs:{"size":"42px"}},[_c('img',{staticClass:"mr-3",attrs:{"src":_vm.classInfo.instructor.image,"alt":_vm.classInfo.instructor.family_name}})]),_vm._v(" "),_c('span',{staticClass:"px-0"},[_vm._v(_vm._s(_vm.classInfo.instructor.given_name)+" "+_vm._s(_vm.classInfo.instructor.family_name))])],1)])],1),_vm._v(" "),_c('v-tabs-bar',{staticClass:"green darken-2",attrs:{"dark":""}},[_c('v-tabs-slider',{staticClass:"yellow"}),_vm._v(" "),_vm._l((_vm.items),function(i){return _c('v-tabs-item',{key:i,attrs:{"href":'#' + i}},[_vm._v("\n      "+_vm._s(i)+"\n    ")])})],2),_vm._v(" "),_c('v-tabs-items',[_c('v-tabs-content',{attrs:{"id":"Feed"}},[_c('add-post'),_vm._v(" "),_vm._l((_vm.posts),function(postData){return _c('post',{key:postData.post_id,attrs:{"post":postData}})})],2),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"Students"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":"","offset-md3":""}},_vm._l((_vm.students),function(student){return _c('student-list',{key:student.student_id,attrs:{"student":student}})}))],1)],1)],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"Files"}},[_c('file-list',{attrs:{"files":_vm.files}})],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__ = __webpack_require__(415);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f7255aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__(731);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f7255aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('p',{staticClass:"headline"},[_vm._v("Page not found")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_sidebar__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);



var _this = this;





/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(from, to, next) {
    var validity;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].getters.GET_TOKEN) {
              _context.next = 14;
              break;
            }

            _context.prev = 1;
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/api/auth/me/role', {
              headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].getters.GET_TOKEN }
            });

          case 4:
            validity = _context.sent;

            if (validity.data.user_role === 0) {
              next('/admin');
            } else if (validity.data.user_role === 1) {
              next('/instructor');
            } else if (validity.data.user_role === 2) {
              next('/student');
            }
            _context.next = 12;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](1);

            console.log(_context.t0);
            next('/logout');

          case 12:
            _context.next = 16;
            break;

          case 14:
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('SET_SIDEBAR', __WEBPACK_IMPORTED_MODULE_3__utils_sidebar__["a" /* default */].home);
            next();

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 8]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
})());

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_sidebar__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index__ = __webpack_require__(41);



var _this = this;






/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(from, to, next) {
    var userRole;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/auth/me/role', {
              headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */].getters.GET_TOKEN }
            });

          case 3:
            userRole = _context.sent;

            if (userRole.data.user_role === 0) {
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */].dispatch('SET_SIDEBAR', __WEBPACK_IMPORTED_MODULE_4__utils_sidebar__["a" /* default */].admin);
              next();
            } else {
              __WEBPACK_IMPORTED_MODULE_5__index__["a" /* router */].go(-1);
            }
            _context.next = 11;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context['catch'](0);

            __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */].dispatch('LOGGED_OUT');
            next('/login');

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 7]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
})());

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_sidebar__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index__ = __webpack_require__(41);



var _this = this;






/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(from, to, next) {
    var userRole;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/auth/me/role', {
              headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */].getters.GET_TOKEN }
            });

          case 3:
            userRole = _context.sent;


            if (userRole.data.user_role === 1) {
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */].dispatch('SET_SIDEBAR', __WEBPACK_IMPORTED_MODULE_4__utils_sidebar__["a" /* default */].instructor);
              next();
            } else {
              __WEBPACK_IMPORTED_MODULE_5__index__["a" /* router */].go(-1);
            }
            _context.next = 11;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context['catch'](0);

            __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */].dispatch('LOGGED_OUT');
            next('/');

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 7]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
})());

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_sidebar__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index__ = __webpack_require__(41);



var _this = this;






/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(from, to, next) {
    var userRole;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/auth/me/role', {
              headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */].getters.GET_TOKEN }
            });

          case 3:
            userRole = _context.sent;


            if (userRole.data.user_role === 2) {
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */].dispatch('SET_SIDEBAR', __WEBPACK_IMPORTED_MODULE_4__utils_sidebar__["a" /* default */].student);
              next();
            } else {
              __WEBPACK_IMPORTED_MODULE_5__index__["a" /* router */].go(-1);
            }
            _context.next = 11;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context['catch'](0);

            __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */].dispatch('LOGGED_OUT');
            next('/');

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 7]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
})());

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



var _this = this;




/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(from, to, next) {
    var logout;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/api/auth/logout', null, { headers: {
                'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].getters.GET_TOKEN
              }
            });

          case 3:
            logout = _context.sent;

            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].commit('RESET_STORE');
            // store.dispatch('LOGGED_OUT')
            next('/');
            _context.next = 13;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](0);

            console.log(_context.t0);
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].commit('RESET_STORE');
            // store.dispatch('LOGGED_OUT')
            next('/');

          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[0, 8]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
})());

/***/ }),
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(855);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(859);
function injectStyle (ssrContext) {
  __webpack_require__(857)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */,
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(862);
function injectStyle (ssrContext) {
  __webpack_require__(861)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 861 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(864);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(869);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 870 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 871 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[450]);


// WEBPACK FOOTER //
// static/js/app.142417073e1b6ec574e1.js